webpackJsonp([1],{

/***/ "/EkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5lxg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6FJY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Hc+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AqYs":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "C9st":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CT3h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DkYG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E+6/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LlZK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/cgil-log/dist/cgLog.min.js
var cgLog_min = __webpack_require__("s0yi");
var cgLog_min_default = /*#__PURE__*/__webpack_require__.n(cgLog_min);

// CONCATENATED MODULE: ./src/components/config.js

var DEV = "production" === 'development';
var BASE_REST_API_URL = DEV ? 'https://mypodp.lausanne.ch/api' : '/api';
var BUILD_DATE = '18-07-2023';
var VERSION = '1.0.10';
var BASE_PATH = DEV ? '' : '';
var config_getLog = function getLog(ModuleName, verbosityDev, verbosityProd) {
  return DEV ? new cgLog_min_default.a(ModuleName, verbosityDev) : new cgLog_min_default.a(ModuleName, verbosityProd);
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var App = ({
  name: 'app',
  components: {},
  data: function data() {
    return {
      isItDevEnv: DEV,
      infoversion: 'ver:' + VERSION + ' ' + BUILD_DATE
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e668e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav',{staticClass:"navbar navbar-inverse navbar-fixed-top"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_c('img',{staticClass:"mainlogo ",attrs:{"src":__webpack_require__("AqYs")}}),_vm._v(" "),_c('h1',{staticClass:"site-name"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_vm._v("PoDP "+_vm._s(_vm.infoversion))])]),_vm._v(" "),_c('ul',{staticClass:"nav navbar-nav"},[_c('li',[_c('router-link',{attrs:{"to":"/demande"}},[_vm._v("Demande")])],1),_vm._v(" "),(_vm.isItDevEnv)?_c('li',[_c('router-link',{attrs:{"to":"/test"}},[_vm._v("Test")])],1):_vm._e()])])])]),_vm._v(" "),_c('main',[_c('div',{staticClass:"container"},[_c('router-view',{key:_vm.$route.fullPath})],1)])])}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("E+6/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ui/goCollapse.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var log = config_getLog('goCollapse', 4, 1);
/* harmony default export */ var goCollapse = ({
  name: 'go-collapse',
  components: {},
  data: function data() {
    return {
      isOpen: this.open
    };
  }, // end of data section
  props: {
    title: {
      type: [String, Function]
    },
    open: {
      type: Boolean,
      default: false
    },
    done: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    open: function open(newVal, oldVal) {
      log.w('## IN goCollapse.watch open title [[' + this.title + ']] old: ' + oldVal + ' new: ' + newVal);
      this.isOpen = newVal;
      if (this.isOpen) {
        this.$emit('gocollapseOpen', this.isOpen);
      }
    }
  },
  computed: {
    colorHeading: function colorHeading() {
      return {
        'panel-primary': this.isOpen,
        'panel-danger': !this.isOpen && !this.done,
        'panel-success': !this.isOpen && this.done,
        disable: this.disabled
      };
    }
  }, // end of computed props section

  mounted: function mounted() {}, // end of computed props section

  methods: {
    toggleOpen: function toggleOpen() {
      log.w('## IN goCollapse.toggleOpen title [[' + this.title + ']] open: ' + this.isOpen + ' disabled: ' + this.disabled);
      if (!this.disabled) {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
          this.$emit('gocollapseOpen', this.isOpen);
        }
      }
    } // end of methods section
  } });
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e3da9e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/goCollapse.vue
var goCollapse_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel",class:_vm.colorHeading},[_c('div',{staticClass:"panel-heading",class:{'go-panel-heading': !_vm.disabled},on:{"click":_vm.toggleOpen}},[_c('h5',{staticClass:"panel-title panel-primary"},[_vm._v(_vm._s(_vm.title)+"\n        "),_c('i',{staticClass:"glyphicon ",class:{'glyphicon-ok': _vm.done}}),_vm._v(" "),_c('i',{staticClass:"glyphicon pull-right",class:{'glyphicon-chevron-down': _vm.isOpen,'glyphicon-chevron-right': !_vm.isOpen }})])]),_vm._v(" "),_c('div',{ref:"panelBody",staticClass:"panel-body",class:{hide: !_vm.isOpen }},[_vm._t("default")],2)])}
var goCollapse_staticRenderFns = []
var goCollapse_esExports = { render: goCollapse_render, staticRenderFns: goCollapse_staticRenderFns }
/* harmony default export */ var ui_goCollapse = (goCollapse_esExports);
// CONCATENATED MODULE: ./src/components/ui/goCollapse.vue
function goCollapse_injectStyle (ssrContext) {
  __webpack_require__("LlZK")
}
var goCollapse_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var goCollapse___vue_template_functional__ = false
/* styles */
var goCollapse___vue_styles__ = goCollapse_injectStyle
/* scopeId */
var goCollapse___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var goCollapse___vue_module_identifier__ = null
var goCollapse_Component = goCollapse_normalizeComponent(
  goCollapse,
  ui_goCollapse,
  goCollapse___vue_template_functional__,
  goCollapse___vue_styles__,
  goCollapse___vue_scopeId__,
  goCollapse___vue_module_identifier__
)

/* harmony default export */ var components_ui_goCollapse = (goCollapse_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Home = ({
  name: 'home',
  components: {
    goCollapse: components_ui_goCollapse
  },
  data: function data() {
    return {
      msg: 'Demande de permis d\'utilisation temporaire du domaine public communal',
      msg2: 'Pour commencer ...',
      isMainOpen: true
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b74b011","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('go-collapse',{attrs:{"title":_vm.msg2,"open":_vm.isMainOpen}},[_c('p',[_vm._v("\n        Le requérant doit contacter le-la surveillant-e du domaine public, en charge du secteur sur lequel il souhaite obtenir un permis temporaire d'occupation du domaine public.\nLors de ce contact, il devra être en possession des informations suivantes :\n      ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("coordonnées complète (y compris adresse e-mail)")]),_vm._v(" "),_c('li',[_vm._v("numéro IDAFF (xxx'xxx), si les travaux sont mandatés par un gestionnaire de réseaux communal")]),_vm._v(" "),_c('li',[_vm._v("localisation des travaux")])]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":__webpack_require__("wEbZ")}}),_vm._v(" "),_c('a',{staticClass:"niceLink",attrs:{"href":"https://www.lausanne.ch/.binaryData/website/path/lausanne/prestations/mobilite-et-amenagements-publics/demande-permis-utilisation-temporaire-domaine-public/contentAutogenerated/autogeneratedContainer/col1/06/linkList/0/websitedownload/plan-des-secteurs-occupation-dp.2022-06-30-10-20-21.pdf"}},[_vm._v("Plan des secteurs et numéros de téléphone")])]),_vm._v(" "),_c('p',[_vm._v("\n        Après ce contact obligatoire, le requérant recevra, par e-mail, un identifiant de demande unique. Ce code est indispensable pour effectuer la demande d'occupation temporaire du domaine public.\n        "),_c('br'),_c('br'),_vm._v("\n        Vous trouverez de plus amples informations, comme par exemple les délais de demande,\n        les tarifs ou encore les conditions d'usage du domaine public, sur le\n        "),_c('a',{attrs:{"href":"https://www.lausanne.ch/prestations/mobilite-et-amenagements-publics/demande-permis-utilisation-temporaire-domaine-public.html"}},[_vm._v("\n          site web de la Ville de Lausanne\n        ")])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n        Si vous avez des questions, n'hésitez pas à nous contacter."),_c('br'),_c('br'),_vm._v("\n        Nous répondons à vos appels du lundi au vendredi, de 08h00 à 11h30 et de 14h00 à 16h00."),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Service de la mobilité et de l’aménagement des espaces publics")]),_c('br'),_vm._v("\n        Surveillance du domaine public"),_c('br'),_c('br'),_vm._v("\n        Téléphones  "),_c('a',{attrs:{"href":"tel:+41213155412"}},[_vm._v("+41 21 315  5412")]),_vm._v(" ou  "),_c('a',{attrs:{"href":"tel:+41213155262"}},[_vm._v("5262")]),_c('br'),_vm._v("\n        E-mail "),_c('a',{attrs:{"href":"mailto:podp@lausanne.ch"}},[_vm._v("podp@lausanne.ch")]),_c('br')])])],1)}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var components_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("5lxg")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  components_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_components_Home = (Home_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.js
var vue_select = __webpack_require__("T1ft");
var vue_select_default = /*#__PURE__*/__webpack_require__.n(vue_select);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ui/goSwitch.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var DEF_CHECKED_COLOR = '#3c763d';
var DEF_UNCHEKED_COLOR = '#a94442';

var DEF_CHECKED_LABEL = 'OUI';
var DEF_UNCHECKED_LABEL = 'NON';

var margin = 3;

var goSwitch_contains = function contains(object, title) {
  return (typeof object === 'undefined' ? 'undefined' : typeof_default()(object)) === 'object' && object.hasOwnProperty(title);
};

/* harmony default export */ var goSwitch = ({
  name: 'goSwitch',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    sync: {
      type: Boolean,
      default: true
    },
    color: {
      type: [String, Object],
      validator: function validator(value) {
        return (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' ? value.checked || value.unchecked : typeof value === 'string';
      }
    },
    labels: {
      type: [Boolean, Object],
      default: true,
      validator: function validator(value) {
        return (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' ? value.checked || value.unchecked : typeof value === 'boolean';
      }
    },
    height: {
      type: Number,
      default: 32
    },
    width: {
      type: Number,
      default: 70
    }
  },
  computed: {
    className: function className() {
      var toggled = this.toggled,
          disabled = this.disabled;


      return ['vue-js-switch', { toggled: toggled, disabled: disabled }];
    },
    ariaChecked: function ariaChecked() {
      return this.toggled.toString();
    },
    style: function style() {
      var width = this.width,
          height = this.height;

      var distance = width - height + margin;

      return {
        '--h': height + 'px',
        '--w': width + 'px',
        '--d': distance + 'px'
      };
    },
    colorChecked: function colorChecked() {
      if (typeof_default()(this.color) !== 'object') {
        return this.color || DEF_CHECKED_COLOR;
      }

      return goSwitch_contains(this.color, 'checked') ? this.color.checked : DEF_CHECKED_COLOR;
    },
    colorUnchecked: function colorUnchecked() {
      return goSwitch_contains(this.color, 'unchecked') ? this.color.unchecked : DEF_UNCHEKED_COLOR;
    },
    colorCurrent: function colorCurrent() {
      return this.toggled ? this.colorChecked : this.colorUnchecked;
    },
    labelChecked: function labelChecked() {
      return goSwitch_contains(this.labels, 'checked') ? this.labels.checked : DEF_CHECKED_LABEL;
    },
    labelUnchecked: function labelUnchecked() {
      return goSwitch_contains(this.labels, 'unchecked') ? this.labels.unchecked : DEF_UNCHECKED_LABEL;
    },
    coreStyle: function coreStyle() {
      return {
        'background-color': this.colorCurrent
      };
    }
  },
  watch: {
    value: function value(_value) {
      if (this.sync) {
        this.toggled = _value;
      }
    }
  },
  data: function data() {
    return {
      toggled: this.value,
      iETrick: ''
    };
  },
  mounted: function mounted() {
    // IE hack to show at least the checkbox
    if ('ActiveXObject' in window) {
      this.iETrick = 'display:inline-block';
    }
  },
  methods: {
    toggle: function toggle(event) {
      this.toggled = !this.toggled;
      this.$emit('input', this.toggled);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb6803c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/goSwitch.vue
var goSwitch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.className,style:(_vm.style),attrs:{"role":"checkbox","title":"Cliquez pour changer la réponse"}},[_c('input',{staticClass:"v-switch-input",style:(_vm.iETrick),attrs:{"type":"checkbox"},on:{"change":function($event){$event.stopPropagation();return _vm.toggle.apply(null, arguments)}}}),_vm._v(" "),_c('span',{staticClass:"v-switch-core",style:(_vm.coreStyle),attrs:{"aria-checked":_vm.ariaChecked}}),_vm._v(" "),(_vm.labels)?_c('div',[(_vm.toggled)?_c('span',{staticClass:"v-switch-label v-left"},[_vm._v(_vm._s(_vm.labelChecked))]):_c('span',{staticClass:"v-switch-label v-right"},[_vm._v(_vm._s(_vm.labelUnchecked))])]):_vm._e()])}
var goSwitch_staticRenderFns = []
var goSwitch_esExports = { render: goSwitch_render, staticRenderFns: goSwitch_staticRenderFns }
/* harmony default export */ var ui_goSwitch = (goSwitch_esExports);
// CONCATENATED MODULE: ./src/components/ui/goSwitch.vue
function goSwitch_injectStyle (ssrContext) {
  __webpack_require__("snlp")
}
var goSwitch_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var goSwitch___vue_template_functional__ = false
/* styles */
var goSwitch___vue_styles__ = goSwitch_injectStyle
/* scopeId */
var goSwitch___vue_scopeId__ = "data-v-fb6803c4"
/* moduleIdentifier (server only) */
var goSwitch___vue_module_identifier__ = null
var goSwitch_Component = goSwitch_normalizeComponent(
  goSwitch,
  ui_goSwitch,
  goSwitch___vue_template_functional__,
  goSwitch___vue_styles__,
  goSwitch___vue_scopeId__,
  goSwitch___vue_module_identifier__
)

/* harmony default export */ var components_ui_goSwitch = (goSwitch_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/map.js
var core_js_map = __webpack_require__("ifoU");
var map_default = /*#__PURE__*/__webpack_require__.n(core_js_map);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/cgil-html-utils/dist/cgHtmlUtils.min.js
var cgHtmlUtils_min = __webpack_require__("3VIH");
var cgHtmlUtils_min_default = /*#__PURE__*/__webpack_require__.n(cgHtmlUtils_min);

// CONCATENATED MODULE: ./src/components/demandePoDP.js








var demandePoDP_log = config_getLog('demandePODP', 4, 1);

var instance = null;
// Demande de Permis Occupation domaine public

var demandePoDP_DemandePoDP = function () {
  function DemandePoDP() {
    classCallCheck_default()(this, DemandePoDP);

    if (!instance) {
      instance = this;
    }
    // to test whether we have singleton or not and store how old is data
    this.time = new Date();
    this.myMap = new map_default.a();
    this.isReady = false;
    this.lastError = null;
    this.lastErrorMsg = null;
    return instance;
  }

  createClass_default()(DemandePoDP, [{
    key: 'getListDemandes',
    value: function getListDemandes(callbackLoaded) {
      var _this = this;

      axios_default.a.get(BASE_REST_API_URL + '/demandes').then(function (resp) {
        _this.lastError = null;
        _this.lastErrorMsg = null;
        demandePoDP_log.l('## IN DemandePoDP.getListDemandesresponse is :', resp.data);
        _this.isReady = true;
        if (Object(cgHtmlUtils_min["functionExist"])(callbackLoaded)) {
          callbackLoaded(resp.data);
        }
      }).catch(function (err) {
        _this.isReady = false;
        demandePoDP_log.e('## ERROR IN DemandePoDP.getListDemandesresponse while retrieving data with axios.get ');
        if (err.response) {
          demandePoDP_log.e(' -- The request was made, but the server responded with a status code > 2xx', err.response);
          _this.lastErrorMsg = ' DemandePoDP.getListDemandesresponse : La requete http a recu en retour un code status=' + err.response.status + ' >2xx ! ';
          _this.lastError = err.response;
        } else if (err.request) {
          demandePoDP_log.e(' -- The request was made, but no response was received from the server', err.request);
          _this.lastErrorMsg = ' DemandePoDP.getListDemandesresponse : La requete http n\'a pas re\xE7u de reponse du serveur ! ';
          _this.lastError = err.request;
        } else {
          demandePoDP_log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
          _this.lastErrorMsg = ' DemandePoDP.getListDemandesresponse : La requete http est erron\xE9e et n\'a pas pu se faire! ';
          _this.lastError = err.message;
        }
        if (Object(cgHtmlUtils_min["functionExist"])(callbackLoaded)) {
          callbackLoaded('## ERROR IN DemandePoDP.getListDemandesresponse while retrieving data with axios.get');
        }
        return false;
      });
    }

    // public method to get initial data for this demand using cached entries if they exist

  }, {
    key: 'getDemandeInitiale',
    value: function getDemandeInitiale(guid, callbackLoaded) {
      if (Object(cgHtmlUtils_min["isNullOrUndefined"])(guid)) {
        demandePoDP_log.w('## ERROR IN DemandePoDP.getDemandeInitiale : guid is ' + guid + '  !');
        this.isReady = false;
        return false;
      }
      if (this.myMap.has(guid)) {
        demandePoDP_log.l('## IN DemandePoDP.getDemandeInitiale(' + guid + ') serving data from cache');
        this.lastError = null;
        this.lastErrorMsg = null;
        this.isReady = true;
        return this.myMap.get(guid);
      } else {
        this.isReady = false;
        demandePoDP_log.l('## IN IN DemandePoDP.getDemandeInitiale(' + guid + ')  retrieving  data from server');
        this._getData(callbackLoaded, guid);
        return false;
      }
    }
  }, {
    key: 'getdemandeEnCours',
    value: function getdemandeEnCours(id, callbackLoaded) {
      var _this2 = this;

      axios_default.a.get(BASE_REST_API_URL + '/demandeencours/' + id).then(function (resp) {
        _this2.lastError = null;
        _this2.lastErrorMsg = null;
        demandePoDP_log.l('## IN DemandePoDP.isDemandeAlreadysaved(' + id + ') response is :', resp.data[0]);
        _this2.isReady = true;
        if (Object(cgHtmlUtils_min["functionExist"])(callbackLoaded)) {
          callbackLoaded(resp.data[0]);
        }
      }).catch(function (err) {
        _this2.isReady = false;
        demandePoDP_log.e('## ERROR IN DemandePoDP.getdemandeEnCours(' + id + ') while retrieving data with axios.get ');
        if (err.response) {
          demandePoDP_log.e(' -- The request was made, but the server responded with a status code > 2xx', err.response);
          _this2.lastErrorMsg = ' DemandePoDP.getdemandeEnCours(' + id + '): La requete http a recu en retour un code status=' + err.response.status + ' >2xx ! ';
          _this2.lastError = err.response;
        } else if (err.request) {
          demandePoDP_log.e(' -- The request was made, but no response was received from the server', err.request);
          _this2.lastErrorMsg = ' DemandePoDP.getdemandeEnCours(' + id + '): La requete http n\'a pas re\xE7u de reponse du serveur ! ';
          _this2.lastError = err.request;
        } else {
          demandePoDP_log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
          _this2.lastErrorMsg = ' DemandePoDP.getdemandeEnCours(' + id + '): La requete http est erron\xE9e et n\'a pas pu se faire! ';
          _this2.lastError = err.message;
        }
        if (Object(cgHtmlUtils_min["functionExist"])(callbackLoaded)) {
          callbackLoaded('## ERROR IN DemandePoDP.isDemandeAlreadysaved(' + id + ') while retrieving data with axios.get');
        }
        return false;
      });
    }
  }, {
    key: 'isDemandeAlreadysaved',
    value: function isDemandeAlreadysaved(id, callbackLoaded) {
      var _this3 = this;

      axios_default.a.get(BASE_REST_API_URL + '/demandesauvee/' + id).then(function (resp) {
        _this3.lastError = null;
        _this3.lastErrorMsg = null;
        demandePoDP_log.l('## IN DemandePoDP.isDemandeAlreadysaved(' + id + ') response is :', resp.data);
        _this3.isReady = true;
        if (Object(cgHtmlUtils_min["functionExist"])(callbackLoaded)) {
          callbackLoaded(resp.data);
        }
      }).catch(function (err) {
        _this3.isReady = false;
        demandePoDP_log.e('## ERROR IN DemandePoDP.isDemandeAlreadysaved(' + id + ') while retrieving data with axios.get ');
        if (err.response) {
          demandePoDP_log.e(' -- The request was made, but the server responded with a status code > 2xx', err.response);
          _this3.lastErrorMsg = ' DemandePoDP.isDemandeAlreadysaved(' + id + '): La requete http a recu en retour un code status=' + err.response.status + ' >2xx ! ';
          _this3.lastError = err.response;
        } else if (err.request) {
          demandePoDP_log.e(' -- The request was made, but no response was received from the server', err.request);
          _this3.lastErrorMsg = ' DemandePoDP.isDemandeAlreadysaved(' + id + '): La requete http n\'a pas re\xE7u de reponse du serveur ! ';
          _this3.lastError = err.request;
        } else {
          demandePoDP_log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
          _this3.lastErrorMsg = ' DemandePoDP.isDemandeAlreadysaved(' + id + '): La requete http est erron\xE9e et n\'a pas pu se faire! ';
          _this3.lastError = err.message;
        }
        if (Object(cgHtmlUtils_min["functionExist"])(callbackLoaded)) {
          callbackLoaded('## ERROR IN DemandePoDP.isDemandeAlreadysaved(' + id + ') while retrieving data with axios.get');
        }
        return false;
      });
    }
  }, {
    key: 'saveDemande',
    value: function saveDemande(guid, data, callbackSaved) {
      var _this4 = this;

      demandePoDP_log.l('## IN DemandePoDP.saveDemande(' + guid + ') will save data to server');
      demandePoDP_log.l('## IN DemandePoDP.saveDemande(' + guid + ') data :', data);
      // axios.post(`${BASE_REST_API_URL}/goposttesting.php`, data)
      // axios.post('https://httpbin.org/post', dataWithSession)
      axios_default.a.post(BASE_REST_API_URL + '/gosavedemande.php', data).then(function (resp) {
        demandePoDP_log.l('## IN DemandePoDP.saveDemande AFTER saving data for guid :' + guid + ' with axios.post', resp.data);
        demandePoDP_log.l('## IN DemandePoDP.saveDemande AFTER saving data response :', resp);
        if (Object(cgHtmlUtils_min["functionExist"])(callbackSaved)) {
          callbackSaved(resp.data);
        }
      }).catch(function (err) {
        _this4.isReady = false;
        if (err.response) {
          demandePoDP_log.e(' -- The request was made, but the server responded with a status code > 2xx', err.response);
          _this4.lastErrorMsg = ' DemandePoDP.saveDemande: La requete http a recu en retour un code status=' + err.response.status + ' >2xx ! ';
          _this4.lastError = err.response;
        } else if (err.request) {
          demandePoDP_log.e(' -- The request was made, but no response was received from the server', err.request);
          _this4.lastErrorMsg = ' DemandePoDP.saveDemande: La requete http n\'a pas re\xE7u de reponse du serveur ! ';
          _this4.lastError = err.request;
        } else {
          demandePoDP_log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
          _this4.lastErrorMsg = ' DemandePoDP.saveDemande: La requete http est erron\xE9e et n\'a pas pu se faire! ';
          _this4.lastError = err.message;
        }
        if (Object(cgHtmlUtils_min["functionExist"])(callbackSaved)) {
          callbackSaved('## ERROR in DemandePoDP.saveDemande while saving data for guid :' + guid + ' !\n              SERVER SAY : ' + stringify_default()(_this4.lastError.data));
        }
        // log.e(`## ERROR IN DemandePoDP.saveDemande while saving data for guid :${guid} with axios.post`, err.response)
        return false;
      });
    }

    /***
     * submitDemande doit etre appeler quand l'utilisateur veut envoyer definitivement le formulaire de demande
     * @param guid
     * @param data
     * @param callbackSaved
     */

  }, {
    key: 'submitDemande',
    value: function submitDemande(guid, data, callbackSaved) {
      var _this5 = this;

      demandePoDP_log.l('## IN DemandePoDP.submitDemande(' + guid + ') will submit data to server');
      demandePoDP_log.l('## IN DemandePoDP.submitDemande(' + guid + ') data :', data);
      // TODO : ici on peu verifier REGLES VALIDATIONS respectees DES QUE STEVE MICHAUD LE CHEF PROJET NOUS LES DONNERA !
      // axios.post(`${BASE_REST_API_URL}/goposttesting.php`, data)
      // axios.post('https://httpbin.org/post', dataWithSession)
      axios_default.a.post(BASE_REST_API_URL + '/gosavedemande.php', data).then(function (resp) {
        demandePoDP_log.l('## IN DemandePoDP.submitDemande AFTER saving data for guid :' + guid + ' with axios.post', resp.data);
        demandePoDP_log.l('## IN DemandePoDP.submitDemande AFTER saving data response :', resp);
        if (Object(cgHtmlUtils_min["functionExist"])(callbackSaved)) {
          callbackSaved(resp.data);
        }
      }).catch(function (err) {
        _this5.isReady = false;
        if (err.response) {
          demandePoDP_log.e(' -- The request was made, but the server responded with a status code > 2xx', err.response);
          _this5.lastErrorMsg = ' DemandePoDP.submitDemande: La requete http a recu en retour un code status=' + err.response.status + ' >2xx ! ';
          _this5.lastError = err.response;
        } else if (err.request) {
          demandePoDP_log.e(' -- The request was made, but no response was received from the server', err.request);
          _this5.lastErrorMsg = ' DemandePoDP.submitDemande: La requete http n\'a pas re\xE7u de reponse du serveur ! ';
          _this5.lastError = err.request;
        } else {
          demandePoDP_log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
          _this5.lastErrorMsg = ' DemandePoDP.submitDemande: La requete http est erron\xE9e et n\'a pas pu se faire! ';
          _this5.lastError = err.message;
        }
        if (Object(cgHtmlUtils_min["functionExist"])(callbackSaved)) {
          callbackSaved('## ERROR in DemandePoDP.submitDemande while saving data for guid :' + guid + ' !\n              SERVER SAY : ' + stringify_default()(_this5.lastError.data));
        }
        // log.e(`## ERROR IN DemandePoDP.saveDemande while saving data for guid :${guid} with axios.post`, err.response)
        return false;
      });
    }
  }, {
    key: 'isDemandeCached',
    value: function isDemandeCached(guid) {
      return this.myMap.has(guid);
    }

    // private method to retrieve data from server

  }, {
    key: '_getData',
    value: function _getData(callbackLoaded, guid) {
      var _this6 = this;

      axios_default.a.get(BASE_REST_API_URL + '/demande/' + guid).then(function (resp) {
        _this6.lastError = null;
        _this6.lastErrorMsg = null;
        _this6.myMap.set(guid, resp.data[0]);
        _this6.isReady = true;
        if (DEV) {
          demandePoDP_log.l('## IN DemandePoDP singleton after finish loading commune data for guid :' + guid);
        }
        if (Object(cgHtmlUtils_min["functionExist"])(callbackLoaded)) {
          callbackLoaded(_this6.myMap.get(guid));
        }
      }).catch(function (err) {
        // https://github.com/mzabriskie/axios#handling-errors
        _this6.isReady = false;
        demandePoDP_log.e('## ERROR IN DemandePoDP._getData while retrieving data for guid :' + guid + ' with axios.get ');
        if (err.response) {
          demandePoDP_log.e(' -- The request was made, but the server responded with a status code > 2xx', err.response);
          _this6.lastErrorMsg = ' DemandePoDP._getData: La requete http a recu en retour un code status=' + err.response.status + ' >2xx ! ';
          _this6.lastError = err.response;
        } else if (err.request) {
          demandePoDP_log.e(' -- The request was made, but no response was received from the server', err.request);
          _this6.lastErrorMsg = ' DemandePoDP._getData: La requete http n\'a pas re\xE7u de reponse du serveur ! ';
          _this6.lastError = err.request;
        } else {
          demandePoDP_log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
          _this6.lastErrorMsg = ' DemandePoDP._getData: La requete http est erron\xE9e et n\'a pas pu se faire! ';
          _this6.lastError = err.message;
        }
        if (Object(cgHtmlUtils_min["functionExist"])(callbackLoaded)) {
          callbackLoaded('## ERROR IN DemandePoDP._getData while retrieving data for guid :' + guid + ' with axios.get');
        }
        return false;
      });
    }
  }]);

  return DemandePoDP;
}();

var demandePoDP = new demandePoDP_DemandePoDP();
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geo/goSelectActeur.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var goSelectActeur_log = config_getLog('goSelectActeur', 4, 1);

/* harmony default export */ var goSelectActeur = ({
  name: 'goSelectActeur',
  components: {
    vSelect: vue_select_default.a,
    goSwitch: components_ui_goSwitch
  },
  props: {
    value: {
      type: Object
      // default: () => {}
      /*
       ici je decide volontairement de pas renvoyer un default
       ca m'economise tout le boulot d'emit quand on change data ici
       et le traitement des evenements dans le parent...
       je sais ce que vous allez dire ! j'utilise le fait que la value est un objet
       et que donc il est passe par reference et que donc quand je le change dans ce composant et ben dans le parent
       l'objet et ben il change aussi vu que c'est le meme objet
       ouaipp  je sais c'est pas bien, mais ca fonctionne pil poil
       faut juste etre au clair et faire gaffe a ce qu'on fait
       et bien definir toute la hierarchie dans le data du parent sinon vuejs ce plante pour les mises a jour
       et il ne peut plus suivre qui change quoi et rafraichir le dom
       promis Docteur : des que j'avance un peu j'implement un joli event changeFieldsValue
       que je traiterais dans le parent pour chaque instance...
       */
    },
    acteurTitle: {
      type: String,
      default: 'Maître d\'ouvrage'
    }
  }, // end of props section
  data: function data() {
    return {
      isItDevEnv: DEV,
      dataActeur: {
        isActeurValid: false,
        isActeurCollapsed: false,
        isActeurPhysique: false,
        IdActeurSelected: null,
        RaisonSociale: null,
        RaisonSocialeIsValid: false,
        RueNumero: null,
        CPVille: null,
        Telephone: null,
        TelephonePortable: null,
        Fax: null,
        Email: null
      },
      dataSelected: null,
      test: null,
      options: []
    };
  }, // end of data section
  computed: {
    isFormValid: function isFormValid() {
      if (this.dataActeur.RaisonSociale) {
        this.dataActeur.isActeurValid = true;
        this.dataActeur.RaisonSocialeIsValid = true;
        return true;
      } else {
        this.dataActeur.isActeurValid = false;
        this.dataActeur.RaisonSocialeIsValid = false;
        return false;
      }
    }
  }, // end of computed props section
  watch: {
    value: function value(val) {
      this.dataActeur = val;
    }
  }, // end of watch props section
  created: function created() {
    goSelectActeur_log.l('## INSIDE goSelectActeur created ');
  },
  mounted: function mounted() {
    goSelectActeur_log.l('## INSIDE goSelectActeur mounted ');
    // this.dataSelected = this.value
  }, // end of mounted props section

  methods: {
    changeSelected: function changeSelected(val) {
      if (val !== null) {
        this._getActeurDataFromRemote(val.value);
      } else {
        this._initDataActeur();
        this.$emit('input', this.dataActeur);
      }
    },
    changeAnyFields: function changeAnyFields(val) {
      this.$emit('input', this.dataActeur);
      goSelectActeur_log.l('## IN goSelectActeur.changeAnyFields\n ->' + val.srcElement.id + '.value=[' + val.srcElement.value + ']');
    },
    saveData: function saveData() {
      goSelectActeur_log.l('## IN goSelectActeur.saveData request emitted ! ');
      this.$emit('saverequest', this.dataActeur);
    },
    _initDataActeur: function _initDataActeur() {
      this.dataActeur = {
        IdActeurSelected: null,
        RaisonSociale: null,
        RueNumero: null,
        CPVille: null,
        Telephone: null,
        TelephonePortable: null,
        Fax: null,
        Email: null
      };
    },
    _getOptions: function _getOptions(search, loading) {
      var _this = this;

      goSelectActeur_log.l('## Entering IN goSelectActeur.getOptions search:' + search);
      // private method to retrieve data from server
      if (search.length > 2) {
        axios_default.a.get(BASE_REST_API_URL + '/acteurs/' + search).then(function (resp) {
          if (resp.data.length > 0) {
            _this.options = resp.data;
          } else {
            if (resp.data[0].value === 0) {
              _this.options = resp.data;
              goSelectActeur_log.w('## IN goSelectActeur.getOptions data IS EMPTY for search:' + search, resp.data);
            }
          }
          if (DEV) {
            goSelectActeur_log.l('## IN goSelectActeur.getOptions after finish loading data for search:' + search);
          }
          loading(false);
        }).catch(function (err) {
          goSelectActeur_log.e('### ERROR IN goSelectActeur.getOptions for search:' + search, err.response);
          loading(false);
        });
      }
    },
    _getActeurDataFromRemote: function _getActeurDataFromRemote(idActeur) {
      var _this2 = this;

      if (idActeur !== 0) {
        axios_default.a.get(BASE_REST_API_URL + '/acteur/' + idActeur).then(function (resp) {
          _this2.dataActeur.IdActeurSelected = resp.data[0]['id'];
          _this2.dataActeur.RaisonSociale = resp.data[0]['nom'];
          _this2.dataActeur.RueNumero = resp.data[0]['rue'] + ' ' + resp.data[0]['numero'];
          _this2.dataActeur.CPVille = resp.data[0]['codepostal'] + ' ' + resp.data[0]['ville'];
          _this2.dataActeur.Telephone = resp.data[0]['telephone'];
          // this.TelephonePortable  = resp.data[0]['nom']
          _this2.dataActeur.Fax = resp.data[0]['fax'];
          _this2.dataActeur.Email = resp.data[0]['email'];
          _this2.$emit('input', _this2.dataActeur);
          if (DEV) {
            goSelectActeur_log.l('## IN goSelectActeur.getActeurData after finish loading data for search:' + idActeur);
          }
        }).catch(function (err) {
          goSelectActeur_log.e('### ERROR IN goSelectActeur.getActeurData for search:' + idActeur, err.response);
        });
      }
    },
    getCurrentData: function getCurrentData() {
      var data = {
        'id': this.IdActeurSelected,
        'RaisonSociale': '"' + this.RaisonSociale + '"',
        'RueNumero': '"' + this.RueNumero + '"',
        'CPVille': '"' + this.CPVille + '"',
        'Telephone': '"' + this.Telephone + '"',
        'TelephonePortable': '"' + this.TelephonePortable + '"',
        'Fax': '"' + this.Fax + '"',
        'Email': '"' + this.Email + '"'
      };
      return data;
    }
  } // end of methods section
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63c9c3cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/geo/goSelectActeur.vue
var goSelectActeur_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-container container-fluid acteurForm"},[_c('div',{staticClass:"col-md-12 center-block acteurTitle"},[_c('h3',[_vm._v(_vm._s(_vm.acteurTitle)+" :"+_vm._s(_vm.dataActeur.RaisonSociale)+"\n      "),_c('span',{staticClass:"pull-right"},[_c('small',[_vm._v("s'agit-il d'une personne physique ?\n        "),_c('go-switch',{model:{value:(_vm.dataActeur.isActeurPhysique),callback:function ($$v) {_vm.$set(_vm.dataActeur, "isActeurPhysique", $$v)},expression:"dataActeur.isActeurPhysique"}})],1),_vm._v("\n          \n      "),_c('button',{staticClass:"btn btn-primary",attrs:{"id":"cmdActeurSave","disabled":!_vm.isFormValid},on:{"click":_vm.saveData}},[_vm._v("SAUVER")])])])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal"},[(!_vm.dataActeur.isActeurPhysique)?[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-sm-3",attrs:{"for":"listActeur"}},[_vm._v("Recherche d'une société: ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"id":"listActeur","tabindex":"-1","debounce":250,"on-search":_vm._getOptions,"options":_vm.options,"placeholder":"Saisissez quelques lettres se trouvant dans le nom d'une société","label":"label","value":_vm.dataSelected,"onChange":_vm.changeSelected,"title":"A partir de la troisième lettre saisie, une recherche de nom de société contenant ces lettres est effectuée... "}})],1)])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group ",class:{'has-success has-feedback':  _vm.dataActeur.RaisonSocialeIsValid,
          'has-warning has-feedback': !_vm.dataActeur.RaisonSocialeIsValid}},[_c('label',{staticClass:"control-label col-sm-3",attrs:{"for":"RaisonSociale"}},[(!_vm.dataActeur.isActeurPhysique)?[_vm._v("Nom de la Société:")]:[_vm._v("Nom et Prénom de la Personne:")]],2),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataActeur.RaisonSociale),expression:"dataActeur.RaisonSociale"}],staticClass:"form-control",attrs:{"id":"RaisonSociale","type":"text","placeholder":"La saisie de ce champ est obligatoire"},domProps:{"value":(_vm.dataActeur.RaisonSociale)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.dataActeur, "RaisonSociale", $event.target.value)},_vm.changeAnyFields]}}),_vm._v(" "),(_vm.dataActeur.RaisonSocialeIsValid)?[_c('span',{staticClass:"glyphicon glyphicon-ok form-control-feedback",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only",attrs:{"id":"inputRaisonSocialeStatus"}},[_vm._v("(success)")])]:[_c('span',{staticClass:"glyphicon glyphicon-warning-sign form-control-feedback",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only",attrs:{"id":"inputRaisonSocialeStatus"}},[_vm._v("(error)")])]],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-sm-3",attrs:{"for":"RueNumero"}},[_vm._v("Adresse : ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataActeur.RueNumero),expression:"dataActeur.RueNumero"}],staticClass:"form-control",attrs:{"id":"RueNumero","type":"text"},domProps:{"value":(_vm.dataActeur.RueNumero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dataActeur, "RueNumero", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-sm-3",attrs:{"for":"CPVille"}},[_vm._v("Code Postal et Ville: ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataActeur.CPVille),expression:"dataActeur.CPVille"}],staticClass:"form-control",attrs:{"id":"CPVille","type":"text"},domProps:{"value":(_vm.dataActeur.CPVille)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dataActeur, "CPVille", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-sm-3",attrs:{"for":"Telephone"}},[_vm._v("Téléphone: ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataActeur.Telephone),expression:"dataActeur.Telephone"}],staticClass:"form-control",attrs:{"id":"Telephone","type":"text"},domProps:{"value":(_vm.dataActeur.Telephone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dataActeur, "Telephone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-sm-3",attrs:{"for":"TelephonePortable"}},[_vm._v("Téléphone portable: ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataActeur.TelephonePortable),expression:"dataActeur.TelephonePortable"}],staticClass:"form-control",attrs:{"id":"TelephonePortable","type":"text"},domProps:{"value":(_vm.dataActeur.TelephonePortable)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dataActeur, "TelephonePortable", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-sm-3",attrs:{"for":"Fax"}},[_vm._v("Fax: ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataActeur.Fax),expression:"dataActeur.Fax"}],staticClass:"form-control",attrs:{"id":"Fax","type":"text"},domProps:{"value":(_vm.dataActeur.Fax)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dataActeur, "Fax", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-sm-3",attrs:{"for":"Email"}},[_vm._v("Courriel du "+_vm._s(_vm.acteurTitle)+": ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dataActeur.Email),expression:"dataActeur.Email"}],staticClass:"form-control",attrs:{"id":"Email","type":"text"},domProps:{"value":(_vm.dataActeur.Email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dataActeur, "Email", $event.target.value)}}})])]),_vm._v(" "),(_vm.dataActeur.RaisonSociale && _vm.isItDevEnv)?_c('p',[_vm._v("Inside goSelect dataActeur is : "),_c('br'),_vm._v(_vm._s(_vm.dataActeur))]):_vm._e()],2)])}
var goSelectActeur_staticRenderFns = []
var goSelectActeur_esExports = { render: goSelectActeur_render, staticRenderFns: goSelectActeur_staticRenderFns }
/* harmony default export */ var geo_goSelectActeur = (goSelectActeur_esExports);
// CONCATENATED MODULE: ./src/components/geo/goSelectActeur.vue
function goSelectActeur_injectStyle (ssrContext) {
  __webpack_require__("h1YY")
}
var goSelectActeur_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var goSelectActeur___vue_template_functional__ = false
/* styles */
var goSelectActeur___vue_styles__ = goSelectActeur_injectStyle
/* scopeId */
var goSelectActeur___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var goSelectActeur___vue_module_identifier__ = null
var goSelectActeur_Component = goSelectActeur_normalizeComponent(
  goSelectActeur,
  geo_goSelectActeur,
  goSelectActeur___vue_template_functional__,
  goSelectActeur___vue_styles__,
  goSelectActeur___vue_scopeId__,
  goSelectActeur___vue_module_identifier__
)

/* harmony default export */ var components_geo_goSelectActeur = (goSelectActeur_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ui/goCollapseActeurRoleDetails.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var goCollapseActeurRoleDetails = ({
  name: 'go-collapse-acteur-role-details',
  components: {},
  data: function data() {
    return {
      isOpen: this.open
    };
  }, // end of data section
  props: {
    open: {
      type: Boolean,
      default: false
    },
    acteurReference: {
      type: Object
    }
  },
  watch: {
    open: function open(val) {
      this.isOpen = val;
    }
  },
  computed: {
    colorHeading: function colorHeading() {
      return {
        'panel-primary': this.isOpen,
        'panel-info': !this.isOpen
      };
    },
    titleMessage: function titleMessage() {
      if (this.isOpen) {
        return 'Cliquez pour cacher le détail';
      } else {
        return 'Cliquez pour voir plus de détail';
      }
    }
  }, // end of computed props section

  mounted: function mounted() {}, // end of computed props section

  filters: {
    convertReturn2Comma: function convertReturn2Comma(value) {
      if (!value) return '';
      value = value.toString();
      return value.replace('\n', ', ');
    }
  },

  methods: {} // end of methods section
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e18160c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/goCollapseActeurRoleDetails.vue
var goCollapseActeurRoleDetails_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.acteurReference.Nom)?_c('div',{staticClass:"panel",class:_vm.colorHeading},[_c('div',{staticClass:"panel-heading go-panel-heading",attrs:{"title":_vm.titleMessage},on:{"click":function($event){_vm.isOpen=!_vm.isOpen}}},[_c('h5',{staticClass:"panel-title panel-primary"},[_c('strong',[_vm._v(_vm._s(_vm.acteurReference.Role)+" :")]),_vm._v(" "+_vm._s(_vm.acteurReference.Nom)+"\n        "),_c('i',{staticClass:"glyphicon pull-right",class:{'glyphicon-chevron-down': _vm.isOpen,'glyphicon-chevron-right': !_vm.isOpen }})])]),_vm._v(" "),_c('div',{ref:"panelBody",staticClass:"panel-body",class:{hide: !_vm.isOpen }},[_vm._v("\n      Nom : "+_vm._s(_vm.acteurReference.Nom)),_c('br'),_vm._v(" "),(_vm.acteurReference.IdActeur)?_c('p',[_vm._v("Identifiant : ["+_vm._s(_vm.acteurReference.IdActeur)+"]")]):_vm._e(),_vm._v(" "),(_vm.acteurReference.AdresseCorresp)?_c('p',[_vm._v("Adresse : "+_vm._s(_vm._f("convertReturn2Comma")(_vm.acteurReference.AdresseCorresp)))]):_vm._e(),_vm._v(" "),(_vm.acteurReference.telephone)?_c('p',[_vm._v("tel : "+_vm._s(_vm.acteurReference.telephone))]):_vm._e(),_vm._v(" "),(_vm.acteurReference.fax)?_c('p',[_vm._v("fax : "+_vm._s(_vm.acteurReference.fax))]):_vm._e(),_vm._v(" "),(_vm.acteurReference.email)?_c('p',[_vm._v("email: "+_vm._s(_vm.acteurReference.email))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)]):_vm._e()}
var goCollapseActeurRoleDetails_staticRenderFns = []
var goCollapseActeurRoleDetails_esExports = { render: goCollapseActeurRoleDetails_render, staticRenderFns: goCollapseActeurRoleDetails_staticRenderFns }
/* harmony default export */ var ui_goCollapseActeurRoleDetails = (goCollapseActeurRoleDetails_esExports);
// CONCATENATED MODULE: ./src/components/ui/goCollapseActeurRoleDetails.vue
function goCollapseActeurRoleDetails_injectStyle (ssrContext) {
  __webpack_require__("UIWc")
}
var goCollapseActeurRoleDetails_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var goCollapseActeurRoleDetails___vue_template_functional__ = false
/* styles */
var goCollapseActeurRoleDetails___vue_styles__ = goCollapseActeurRoleDetails_injectStyle
/* scopeId */
var goCollapseActeurRoleDetails___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var goCollapseActeurRoleDetails___vue_module_identifier__ = null
var goCollapseActeurRoleDetails_Component = goCollapseActeurRoleDetails_normalizeComponent(
  goCollapseActeurRoleDetails,
  ui_goCollapseActeurRoleDetails,
  goCollapseActeurRoleDetails___vue_template_functional__,
  goCollapseActeurRoleDetails___vue_styles__,
  goCollapseActeurRoleDetails___vue_scopeId__,
  goCollapseActeurRoleDetails___vue_module_identifier__
)

/* harmony default export */ var components_ui_goCollapseActeurRoleDetails = (goCollapseActeurRoleDetails_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/parse-float.js
var parse_float = __webpack_require__("5dBV");
var parse_float_default = /*#__PURE__*/__webpack_require__.n(parse_float);

// CONCATENATED MODULE: ./src/components/cgil-vue-olmap/config.js
var config_DEV = "production" === 'development';
// export const BASE_REST_API_URL = DEV ? 'https://map.lausanne.ch/api' : '/api'
var config_BASE_REST_API_URL = config_DEV ? 'https://mygolux.lausanne.ch/goapi/geo/' : '/goapi/geo/';
var geoJSONUrl = config_DEV ? 'https://gomap.lausanne.ch/gomap-api/chantiers' : 'https://gomap.gil.town/gomap-api/chantiers';
// EXTERNAL MODULE: ./node_modules/ol/Collection.js
var Collection = __webpack_require__("A90D");

// EXTERNAL MODULE: ./node_modules/ol/format/WKT.js + 1 modules
var WKT = __webpack_require__("EM5Z");

// EXTERNAL MODULE: ./node_modules/ol/Overlay.js
var Overlay = __webpack_require__("kZ1N");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cgil-vue-olmap/cgil-vue-autocomplete-element-ui.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var MODULE_NAME = 'cgilVueAutoComplete';
var cgil_vue_autocomplete_element_ui_log = config_DEV ? new cgLog_min_default.a(MODULE_NAME, 2) : new cgLog_min_default.a(MODULE_NAME, 1);
var debounceDelay = 350; // in ms
var minChars = 2;
// const cache = {}
axios_default.a.defaults.timeout = 4000;
/* harmony default export */ var cgil_vue_autocomplete_element_ui = ({
  name: 'cgilVueAutoComplete',
  components: {}, // end of components section
  data: function data() {
    return {
      searchText: '',
      previousSearch: '',
      selectedIndex: null,
      isError: false,
      errMsg: '',
      selected: '',
      ajaxDataSource: null,
      isAjaxCallRunning: false,
      showSugestions: false,
      eventListener: null, // pour detecter click en dehor suggestion
      arrAxiosSource: [],
      arrAjaxResults: [], // when isAjaxDataSourceWithFilter is false we keep data here
      arrResults: [{
        id: 0,
        label: 'aucun résultats trouvés...'

      }]
    };
  }, // end of data section
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    idFieldName: {
      type: String,
      default: 'id'
    },
    labelFieldName: {
      type: String,
      default: 'label'
    },
    initialAjaxDataSource: {
      type: String,
      default: ''
    },
    isAjaxDataSourceWithFilter: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'small'
    }
  }, // end of props section
  watch: {
    searchText: function searchText(val) {
      var _this = this;

      var search = val.trim();
      // if (search !== this.selected) {
      // new search begins so reset selected
      // this.selected = ''
      // this.selectedIndex = null
      // }
      if (this.isAjaxDataSourceWithFilter) {
        if (search.length < minChars) {
          this.arrResults = [];
        }
        if (search !== this.previousSearch && this.selected.length < 1) {
          this.previousSearch = search;
          if (search.length > minChars) {
            this.getData(search);
          }
        } else {
          // probably user pressed space
          if (!this.showSugestions && this.arrResults.length > 1) {
            this.showSugestions = true;
          }
        }
      } else {
        // here isAjaxDataSourceWithFilter = false
        // so we are only filtering existing data with search criteria
        if (search !== this.previousSearch) {
          this.previousSearch = search;
          // 'Åland(les Îles) Châtæü éöà☀ … 山田太郎☯ ˵ĈĀŇĂƊǠ˶ ☺' => aland(les iles) chatæu eoa☀ … 山田太郎☯ ˵canaɗa˶ ☺
          var searchNormalized = search.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
          this.arrResults = this.arrAjaxResults.filter(function (o) {
            return o[_this.labelFieldName + '_normalized'].includes(searchNormalized);
          });
        }
      }
    }
  }, // end of watch section
  created: function created() {
    this.ajaxDataSource = this.initialAjaxDataSource;
    cgil_vue_autocomplete_element_ui_log.t('### created src: ' + this.ajaxDataSource + ' , with filter? ' + this.isAjaxDataSourceWithFilter);
    if (!this.isAjaxDataSourceWithFilter) {
      // we can load once the data from remote server and forget about it
      this.getData();
    }
  }, // end of created section
  mounted: function mounted() {
    this.ajaxDataSource = this.initialAjaxDataSource;
    cgil_vue_autocomplete_element_ui_log.t('### mounted src: ' + this.ajaxDataSource + ' , with filter? ' + this.isAjaxDataSourceWithFilter);
  }, // end of created section
  methods: {
    setAjaxDataSource: function setAjaxDataSource(newAjaxDataSource) {
      this.ajaxDataSource = newAjaxDataSource;
      cgil_vue_autocomplete_element_ui_log.t('### setAjaxDataSource src: ' + this.ajaxDataSource + ' , with filter? ' + this.isAjaxDataSourceWithFilter);
    },
    handleSearch: function handleSearch(query, cb) {
      cgil_vue_autocomplete_element_ui_log.l('## In handleSearch', query, cb);
      var search = query.trim();
      if (this.isAjaxDataSourceWithFilter) {
        if (search.length < minChars) {
          this.arrResults = [];
        }
        if (search !== this.previousSearch && this.selected.length < 1) {
          this.previousSearch = search;
          if (search.length > minChars) {
            this.getData(search);
          }
        } else {
          // probably user pressed space
          if (!this.showSugestions && this.arrResults.length > 1) {
            this.showSugestions = true;
          }
        }
      }
    },
    handleSelect: function handleSelect(item) {
      cgil_vue_autocomplete_element_ui_log.l('## In handleSelect', item);
    },
    getData: Object(cgHtmlUtils_min["debounce"])(function () {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var that = this;
      cgil_vue_autocomplete_element_ui_log.t('## in getData ' + this.ajaxDataSource);
      cgil_vue_autocomplete_element_ui_log.l('## In getData debounce CALLBACK : "' + query + '"', query, cb);

      if (that.arrAxiosSource.length > 0) {
        that.arrAxiosSource.map(function (s) {
          s.cancel();
        });
        that.arrAxiosSource = [];
      }
      var CancelToken = axios_default.a.CancelToken;
      var source = CancelToken.source();
      that.arrAxiosSource.push(source);
      that.arrResults = [];
      this.selectedIndex = null;
      that.isAjaxCallRunning = true;
      that.isError = false;
      axios_default.a.get(this.ajaxDataSource, {
        params: { query: query },
        cancelToken: source.token
      }).then(function (response) {
        cgil_vue_autocomplete_element_ui_log.l('#### AJAX CALL SUCCESS: "' + query + '" => num results = ' + response.data.length);
        response.data.forEach(function (record) {
          that.arrResults.push(record);
        });
        that.isAjaxCallRunning = false;
        if (that.arrResults.length > 0) {
          if (that.isAjaxDataSourceWithFilter) {
            that.showSugestions = true;
            that.setEventListener();
          } else {
            that.arrAjaxResults = that.arrResults.map(function (val) {
              var o = {};
              var labelNormalized = val[that.labelFieldName].normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
              o[that.labelFieldName + '_normalized'] = labelNormalized;
              o[that.labelFieldName] = val[that.labelFieldName];
              o[that.idFieldName] = val[that.idFieldName];
              return o;
            });
          }
        }
        that.isError = false;
      }).catch(function (thrown) {
        if (axios_default.a.isCancel(thrown)) {
          cgil_vue_autocomplete_element_ui_log.w('#### AJAX CALL CANCELED : "' + query + '" : ' + thrown.message);
        } else {
          cgil_vue_autocomplete_element_ui_log.e('#### AJAX ERROR on GET  ' + that.ajaxDataSource + query, thrown);
          that.errMsg = 'Un probl\xE8me est survenu pendant l\'appel r\xE9seau AJAX sur : ' + that.ajaxDataSource + query + ' Message d\'erreur re\xE7u : ' + thrown.message;
          if (!window.navigator.onLine) {
            that.errMsg += 'EN CE MOMENT VOUS N\'AVEZ PAS DE RESEAU ! veuillez réessayez quand votre connexion sera rétablie ';
          }
          cgil_vue_autocomplete_element_ui_log.e(that.errMsg);
          that.$emit('errorajax', that.errMsg);
          that.isError = true;
        }
        that.isAjaxCallRunning = false;
      });
    }, debounceDelay), // end of getData
    update: function update(evt) {
      cgil_vue_autocomplete_element_ui_log.t('#Update Event ==> key: ' + evt.key + ', query: "' + this.searchText + '"');
      switch (evt.key) {
        case 'ArrowDown':
        // this.$refs.suggestion.focus()
      }
    },
    itemSelected: function itemSelected(result, evt) {
      cgil_vue_autocomplete_element_ui_log.t('## itemSelected', result, evt);
      var tempObj = {};
      if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(result)) {
        tempObj = extends_default()({}, result);
      } else {
        tempObj[this.idFieldName] = evt.srcElement.data;
        tempObj[this.labelFieldName] = evt.srcElement.innerText;
      }
      // Emit the selected value through the input event
      this.$emit('input', tempObj);
      this.searchText = tempObj[this.labelFieldName];
      this.previousSearch = tempObj[this.labelFieldName];
      // this.selected = tempObj[this.labelFieldName]
      this.selectedIndex = null;
      cgil_vue_autocomplete_element_ui_log.l(' data selected is : ' + tempObj[this.idFieldName]);
      this.close();
    },
    isSelected: function isSelected(key) {
      return key === this.selectedIndex;
    },
    up: function up() {
      if (this.showSugestions) {
        cgil_vue_autocomplete_element_ui_log.t('## up  selectedIndex:' + this.selectedIndex + ' hasVerticalScrollbar: ' + this.hasVerticalScrollbar(this.$refs.suggestion));
        if (this.selectedIndex === 0) {
          this.selectedIndex = this.arrResults.length - 1;
        } else {
          this.selectedIndex = this.selectedIndex - 1;
          if (this.hasVerticalScrollbar(this.$refs.suggestion)) {
            this.scrollVertical(this.$refs.suggestion, -1);
          }
        }
      }
    },
    down: function down() {
      if (this.showSugestions) {
        cgil_vue_autocomplete_element_ui_log.t('## down   selectedIndex:' + this.selectedIndex + ' hasVerticalScrollbar: ' + this.hasVerticalScrollbar(this.$refs.suggestion));
        if (this.selectedIndex === null) {
          this.selectedIndex = 0;
          return;
        }
        if (this.selectedIndex === this.arrResults.length - 1) {
          this.selectedIndex = 0;
        } else {
          this.selectedIndex = this.selectedIndex + 1;
          if (this.hasVerticalScrollbar(this.$refs.suggestion) && this.selectedIndex > 5) {
            this.scrollVertical(this.$refs.suggestion, 1);
          }
        }
      }
    },
    enter: function enter() {
      if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(this.selectedIndex)) {
        this.itemSelected(this.arrResults[this.selectedIndex]);
      }
    },
    gotFocus: function gotFocus() {
      cgil_vue_autocomplete_element_ui_log.t('## gotFocus  ');
      if (!this.isAjaxDataSourceWithFilter) {
        this.showSugestions = true;
        this.setEventListener();
      }
    },
    close: function close() {
      cgil_vue_autocomplete_element_ui_log.t('## close  ');
      this.showSugestions = false;
      this.arrResults = [];
      this.removeEventListener();
    },
    reset: function reset() {
      cgil_vue_autocomplete_element_ui_log.t('## reset  ');
      this.searchText = '';
      this.arrResults = [];
      // let tempObj = {}
      // reset the selected value through the input event
      this.$emit('input', null);
    },
    setEventListener: function setEventListener() {
      cgil_vue_autocomplete_element_ui_log.t('## setEventListener  ');
      if (this.eventListener) {
        return false;
      }
      this.eventListener = true;
      document.addEventListener('click', this.clickOutsideListener, true);
      return true;
    },
    removeEventListener: function removeEventListener() {
      cgil_vue_autocomplete_element_ui_log.t('## removeEventListener  :');
      this.eventListener = false;
      document.removeEventListener('click', this.clickOutsideListener, true);
    },
    clickOutsideListener: function clickOutsideListener(evt) {
      var test = evt.target !== this.$refs.suggestion && evt.target !== this.$refs.search;
      cgil_vue_autocomplete_element_ui_log.t('## clickOutsideListener  :', evt, evt.target, test);
      if (test) {
        this.close();
      }
    },
    hasVerticalScrollbar: function hasVerticalScrollbar(el) {
      return el.scrollHeight > el.clientHeight;
    },
    scrollVertical: function scrollVertical(el, numLines) {
      cgil_vue_autocomplete_element_ui_log.t('## scrollVertical  numLines: ' + numLines);
      cgil_vue_autocomplete_element_ui_log.l('element scrollTop before: ' + el.scrollTop);
      var offsetY = el.children[0].clientHeight || 12;
      el.scrollTop += numLines * offsetY;
      cgil_vue_autocomplete_element_ui_log.l('element scrollTop after : ' + el.scrollTop);
    } // end of methods section
  } });
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b8d98b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cgil-vue-olmap/cgil-vue-autocomplete-element-ui.vue
var cgil_vue_autocomplete_element_ui_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isError)?_c('div',{staticClass:"alert alert-danger",attrs:{"id":"formFeedBack"}},[_c('strong',[_vm._v(_vm._s(_vm.errMsg))])]):_vm._e(),_vm._v(" "),_c('el-input',{ref:"search",class:{isloading : _vm.isAjaxCallRunning},attrs:{"name":"search","size":_vm.size,"prefix-icon":"el-icon-search","clearable":"","placeholder":_vm.placeholder,"required":"required"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.enter.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.close.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.up.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.down.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.close.apply(null, arguments)}],"keyup":_vm.update,"focus":function($event){return _vm.gotFocus()}},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}}),_vm._v(" "),(_vm.showSugestions)?_c('ul',{ref:"suggestion",staticClass:"suggestion",attrs:{"tabindex":"0"}},[_vm._l((_vm.arrResults),function(result,key){return [_c('li',{key:key,staticClass:"suggestion-item",class:{'suggestionitem__selected' : _vm.isSelected(key) },attrs:{"data":result.id},on:{"click":function($event){$event.preventDefault();return _vm.itemSelected(result, $event)}}},[_vm._v(_vm._s(result[_vm.labelFieldName])+"\n            ")])]})],2):_vm._e()],1)}
var cgil_vue_autocomplete_element_ui_staticRenderFns = []
var cgil_vue_autocomplete_element_ui_esExports = { render: cgil_vue_autocomplete_element_ui_render, staticRenderFns: cgil_vue_autocomplete_element_ui_staticRenderFns }
/* harmony default export */ var cgil_vue_olmap_cgil_vue_autocomplete_element_ui = (cgil_vue_autocomplete_element_ui_esExports);
// CONCATENATED MODULE: ./src/components/cgil-vue-olmap/cgil-vue-autocomplete-element-ui.vue
function cgil_vue_autocomplete_element_ui_injectStyle (ssrContext) {
  __webpack_require__("xxwd")
}
var cgil_vue_autocomplete_element_ui_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var cgil_vue_autocomplete_element_ui___vue_template_functional__ = false
/* styles */
var cgil_vue_autocomplete_element_ui___vue_styles__ = cgil_vue_autocomplete_element_ui_injectStyle
/* scopeId */
var cgil_vue_autocomplete_element_ui___vue_scopeId__ = "data-v-6b8d98b8"
/* moduleIdentifier (server only) */
var cgil_vue_autocomplete_element_ui___vue_module_identifier__ = null
var cgil_vue_autocomplete_element_ui_Component = cgil_vue_autocomplete_element_ui_normalizeComponent(
  cgil_vue_autocomplete_element_ui,
  cgil_vue_olmap_cgil_vue_autocomplete_element_ui,
  cgil_vue_autocomplete_element_ui___vue_template_functional__,
  cgil_vue_autocomplete_element_ui___vue_styles__,
  cgil_vue_autocomplete_element_ui___vue_scopeId__,
  cgil_vue_autocomplete_element_ui___vue_module_identifier__
)

/* harmony default export */ var components_cgil_vue_olmap_cgil_vue_autocomplete_element_ui = (cgil_vue_autocomplete_element_ui_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/ol/Map.js + 18 modules
var Map = __webpack_require__("trid");

// EXTERNAL MODULE: ./node_modules/ol/View.js + 2 modules
var View = __webpack_require__("Lfyu");

// EXTERNAL MODULE: ./node_modules/ol/style/Circle.js
var Circle = __webpack_require__("uli1");

// EXTERNAL MODULE: ./node_modules/ol/events/condition.js
var condition = __webpack_require__("MJuv");

// EXTERNAL MODULE: ./node_modules/ol/Feature.js
var Feature = __webpack_require__("nq2H");

// EXTERNAL MODULE: ./node_modules/ol/style/Fill.js
var Fill = __webpack_require__("lUmj");

// EXTERNAL MODULE: ./node_modules/ol/format/GeoJSON.js + 1 modules
var GeoJSON = __webpack_require__("aUhy");

// EXTERNAL MODULE: ./node_modules/ol/interaction/Draw.js + 1 modules
var Draw = __webpack_require__("aUJj");

// EXTERNAL MODULE: ./node_modules/ol/interaction/Modify.js
var Modify = __webpack_require__("M8sr");

// EXTERNAL MODULE: ./node_modules/ol/interaction/Select.js
var Select = __webpack_require__("gsgi");

// EXTERNAL MODULE: ./node_modules/ol/interaction/Translate.js
var Translate = __webpack_require__("sMv5");

// EXTERNAL MODULE: ./node_modules/ol/layer/Vector.js + 21 modules
var Vector = __webpack_require__("Umvz");

// EXTERNAL MODULE: ./node_modules/ol/layer/Tile.js + 3 modules
var Tile = __webpack_require__("Mdwg");

// EXTERNAL MODULE: ./node_modules/ol/control/MousePosition.js
var MousePosition = __webpack_require__("pJul");

// EXTERNAL MODULE: ./node_modules/ol/geom/MultiPolygon.js + 1 modules
var MultiPolygon = __webpack_require__("AT16");

// EXTERNAL MODULE: ./node_modules/ol/geom/MultiPoint.js
var MultiPoint = __webpack_require__("i3aX");

// EXTERNAL MODULE: ./node_modules/ol/control.js + 8 modules
var control = __webpack_require__("eM/O");

// EXTERNAL MODULE: ./node_modules/ol/coordinate.js
var coordinate = __webpack_require__("IZoy");

// EXTERNAL MODULE: ./node_modules/ol/Observable.js
var Observable = __webpack_require__("nxYM");

// EXTERNAL MODULE: ./node_modules/ol/proj.js + 3 modules
var proj = __webpack_require__("yGLh");

// EXTERNAL MODULE: ./node_modules/ol/proj/proj4.js
var proj4 = __webpack_require__("4Asb");

// EXTERNAL MODULE: ./node_modules/ol/proj/Projection.js
var Projection = __webpack_require__("7rnj");

// EXTERNAL MODULE: ./node_modules/ol/source/Vector.js + 2 modules
var source_Vector = __webpack_require__("WMwB");

// EXTERNAL MODULE: ./node_modules/ol/source/WMTS.js + 9 modules
var WMTS = __webpack_require__("Ka2M");

// EXTERNAL MODULE: ./node_modules/ol/style/Stroke.js
var Stroke = __webpack_require__("00zS");

// EXTERNAL MODULE: ./node_modules/ol/style/Style.js
var Style = __webpack_require__("Mjwz");

// EXTERNAL MODULE: ./node_modules/ol/tilegrid/WMTS.js
var tilegrid_WMTS = __webpack_require__("vvTx");

// EXTERNAL MODULE: ./node_modules/proj4/lib/index.js + 90 modules
var proj4_lib = __webpack_require__("nvAS");

// CONCATENATED MODULE: ./src/components/cgil-vue-olmap/2dGeom.js

/*
 Minimal 2d polygonSelfIntersect geometry helper function
 I wrote this one mainly to be used while a user digitize a polygon in openlayers
 to check if a new point can be considered valid and accepted
 code is inspired by work and informations found on :
 1) article from Martin Thoma available here : https://martin-thoma.com/how-to-check-if-two-line-segments-intersect/
 2) https://algs4.cs.princeton.edu/91primitives/

 i did have also a look on this much complete (and complex) package from Elijah Insua :
 https://www.npmjs.com/package/2d-polygon-self-intersections
 but i did not use it because I just need true or false, and don't need any callback
 function on any intersection, nor do i need 2 other dependencies
 */



var PRECISION = 10;
var EPSILON = Number('1e-' + PRECISION); // 1e-10 or 0.0000000001
var _dGeom_MODULE_NAME = 'cgil-2d-geom-utils';
var _dGeom_log = DEV ? new cgLog_min_default.a(_dGeom_MODULE_NAME, 3) : new cgLog_min_default.a(_dGeom_MODULE_NAME, 2);

/**
 * pointsIsEqual allow to know if two array points are equal (difference lower then EPSILON)
 * @param {array} p0 an array [x,y] representing a point in cartesian 2D space
 * @param {array} p1 an array [x,y] representing a point in cartesian 2D space
 * @return {boolean}  true if p0 and p1 are equal false elsewhere
 */
function pointsIsEqual(p0, p1) {
  return Math.abs(p0[0] - p1[0]) <= EPSILON && Math.abs(p0[1] - p1[1]) <= EPSILON;
}

/**
 * distance2Point gives the distance in 2D space between 2 points
 * @param p0 an array [x,y] representing a point in cartesian 2D space
 * @param p1 an array [x,y] representing a point in cartesian 2D space
 * @return {number} the distance in 2D cartesian space between p0 and p1
 */
function distance2Point(p0, p1) {
  return Math.sqrt((p0[0] - p1[0]) * (p0[0] - p1[0]) + (p0[1] - p1[1]) * (p0[1] - p1[1]));
}

/**
 * Simplistic Point class to be used only in polygonSelfIntersect
 */

var _dGeom_Point = function Point(x, y) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  classCallCheck_default()(this, Point);

  this.x = x;
  this.y = y;
  this.name = name; // mainly for debug purpose
};

/**
 * Simplistic Segment class to be used only in polygonSelfIntersect
 */


var _dGeom_Segment = function Segment(p1, p2) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  classCallCheck_default()(this, Segment);

  this.p1 = p1;
  this.p2 = p2;
  this.name = name; // mainly for debug purpose
};

/* 6.1 geometric primitives : https://algs4.cs.princeton.edu/91primitives/
 And  Book : Algorithms in C++ by Robert Sedgewick Addison-Wesley ISBN 0-201-51059-6

 */


function isCcw(p1, p2, p3) {
  return (p2.x - p1.x) * (p3.y - p1.y) - (p3.x - p1.x) * (p2.y - p1.y);
}
// l1 and l2 are segments
function intersects(l1, l2) {
  if (isCcw(l1.p1, l1.p2, l2.p1) * isCcw(l1.p1, l1.p2, l2.p2) > 0) return false;
  if (isCcw(l2.p1, l2.p2, l1.p1) * isCcw(l2.p1, l2.p2, l1.p2) > 0) return false;
  return true;
}
// l1 and l2 are segments a-b and c-d
function getIntersectionPoint(l1, l2) {
  var a = l1.p1;
  var b = l1.p2;
  var c = l2.p1;
  var d = l2.p2;
  var result = {};
  var rNumerator = (a.y - c.y) * (d.x - c.x) - (a.x - c.x) * (d.y - c.y);
  if (rNumerator === 1) {
    result.intersectionExist = false;
    result.msg = 'COLINEAR SEGMENTS';
    result.pointOfIntersection = null;
    return result;
  }
  var rDenominator = (b.x - a.x) * (d.y - c.y) - (b.y - a.y) * (d.x - c.x);
  if (Math.abs(rDenominator - 0) <= EPSILON) {
    result.r_denominator = rDenominator;
    result.intersectionExist = false;
    result.msg = 'PARALLEL SEGMENTS';
    result.pointOfIntersection = null;
    return result;
  }
  // const sNumerator = (a.y - c.y) * (b.x - a.x) - (a.x - c.x) * (b.y - a.y);
  // const sDenominator = rDenominator;
  var r = rNumerator / rDenominator;
  var xIntersect = (a.x + r * (b.x - a.x)).toFixed(4);
  var yIntersect = (a.y + r * (b.y - a.y)).toFixed(4);

  result.intersectionExist = true;
  result.msg = 'SEGMENTS INTERSECTS';
  result.pointOfIntersection = { x: xIntersect, y: yIntersect };
  return result;
}

/**
 * polygonSelfIntersect allows to know if a polygon as a self-intersection
 * @param arr2DPolygonCoords array of x,y coordinates values from the vertices
 * of external ring of a closed Polygon (last two x,y values should be equal to first)
 * @return {object} result:true if there is a self-intersection in the polygon.
 * false elsewhere reason: contains the segment error
 */
function polygonSelfIntersect(arr2DPolygonCoords) {
  var PointSegments = [];
  var Segments = [];
  var getInfoIntersects = { result: false };
  var offset = 0;
  for (var i = 0; i < arr2DPolygonCoords.length / 2; i += 1) {
    offset = i * 2;
    PointSegments.push(new _dGeom_Point(arr2DPolygonCoords[offset], arr2DPolygonCoords[offset + 1], 'P' + (i + 1)));
  }
  // last point is supposed to be equal to first point of polygon (closed polygon)
  PointSegments[PointSegments.length - 1].name = PointSegments[0].name;
  for (var _i = 0; _i < PointSegments.length - 1; _i += 1) {
    Segments.push(new _dGeom_Segment(PointSegments[_i], PointSegments[_i + 1], 'S' + (_i + 1)));
  }
  for (var _i2 = 0; _i2 < Segments.length; _i2 += 1) {
    for (var j = _i2 + 2; j < Segments.length; j += 1) {
      // no need to test adjacent segments
      // console.log(i,j,Segments[i],Segments[j])
      // no need to test connection from first segment with last one
      if (!(_i2 === 0 && j === Segments.length - 1)) {
        if (intersects(Segments[_i2], Segments[j])) {
          getInfoIntersects.msg = 'Segment ' + Segments[_i2].name + ' intersects with ' + Segments[j].name;
          getInfoIntersects.result = true;
          var res = getIntersectionPoint(Segments[_i2], Segments[j]);
          getInfoIntersects.intersection = [res.pointOfIntersection.x, res.pointOfIntersection.y];
          // log.w(`WARNING in polygonSelfIntersect: ${getInfoIntersects.msg}
          //   at ${res.pointOfIntersection.x}, ${res.pointOfIntersection.y}`)
          _dGeom_log.w('WARNING in polygonSelfIntersect: ' + getInfoIntersects.msg + ' at res', res);
          return getInfoIntersects;
        }
        _dGeom_log.l('OK Segment ' + Segments[_i2].name + ' does not intersects with ' + Segments[j].name);
      }
    }
  }
  return getInfoIntersects;
}
// CONCATENATED MODULE: ./src/components/cgil-vue-olmap/OpenLayersSwiss21781.js





















// import OlPolygon from 'ol/geom/polygon'














// we want to limit minimum distance of points of same polygon
var MIN_DISTANCE_BETWEEN_POINTS = 0.5;
var DIGITIZE_PRECISION = 2; // cm is enough in EPSG:21781 inside a browser
var OpenLayersSwiss21781_MODULE_NAME = 'OpenLayersSwiss21781';
var OpenLayersSwiss21781_log = config_DEV ? new cgLog_min_default.a(OpenLayersSwiss21781_MODULE_NAME, 4) : new cgLog_min_default.a(OpenLayersSwiss21781_MODULE_NAME, 2);

var RESOLUTIONS = [50, 20, 10, 5, 2.5, 1, 0.5, 0.25, 0.1, 0.05];
var MAX_EXTENT_LIDAR = [532500, 149000, 545625, 161000]; // lidar 2012
proj4_lib["a" /* default */].defs('EPSG:21781', '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=600000 +y_0=200000 +ellps=bessel +towgs84=674.4,15.1,405.3,0,0,0,0 +units=m +no_defs');
proj4_lib["a" /* default */].defs('EPSG:2056', '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs');

// https://openlayers.org/en/latest/examples/reprojection.html
// https://openlayers.org/en/latest/doc/faq.html#how-do-i-change-the-projection-of-my-map-
// proj4.defs('EPSG:21781','+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=600000 +y_0=200000 +ellps=bessel +towgs84=660.077,13.551,369.344,2.484,1.783,2.939,5.66 +units=m +no_defs');

Object(proj4["a" /* register */])(proj4_lib["a" /* default */]);
var olSwissProjection = Object(proj["l" /* get */])('EPSG:21781');
// olSwissProjection.setExtent([485071.54, 75346.36, 828515.78, 299941.84]);
olSwissProjection.setExtent(MAX_EXTENT_LIDAR);

var swissProjection = new Projection["a" /* default */]({
  code: Object(proj["l" /* get */])('EPSG:21781'),
  extent: MAX_EXTENT_LIDAR,
  units: 'm'
});
Object(proj["d" /* addProjection */])(swissProjection);
/*
      // https://golux.lausanne.ch/goeland/objet/pointfixe.php?idobjet=111351
      const coordPfa180Stfrancois = [538224.21, 152378.17] // PFA3 180 - St-Francois
      console.log(`PFA3 180 - St-Francois en 21781 : ${coordPfa180Stfrancois[0]}, ${coordPfa180Stfrancois[1]}`)
      const pfa180In4326 = Conv21781To4326(coordPfa180Stfrancois[0], coordPfa180Stfrancois[1])
      console.log(`PFA3 180 - St-Francois en 4326  : ${pfa180In4326.x}, ${pfa180In4326.y} `)
*/
function Conv21781To4326(x, y) {
  var projSource = new proj4_lib["a" /* default */].Proj('EPSG:21781');
  var projDest = new proj4_lib["a" /* default */].Proj('EPSG:4326');
  return proj4_lib["a" /* default */].transform(projSource, projDest, [x, y]);
}
// 2056 MN95 new Swiss Projection
function Conv21781To2056(x, y) {
  var projSource = new proj4_lib["a" /* default */].Proj('EPSG:21781');
  var projDest = new proj4_lib["a" /* default */].Proj('EPSG:2056');
  return proj4_lib["a" /* default */].transform(projSource, projDest, [x, y]);
}

function Conv4326To21781(x, y) {
  var projSource = new proj4_lib["a" /* default */].Proj('EPSG:4326');
  var projDest = new proj4_lib["a" /* default */].Proj('EPSG:21781');
  return proj4_lib["a" /* default */].transform(projSource, projDest, [x, y]);
}

function Conv3857To21781(x, y) {
  var projSource = new proj4_lib["a" /* default */].Proj('EPSG:3857');
  var projDest = new proj4_lib["a" /* default */].Proj('EPSG:21781');
  return proj4_lib["a" /* default */].transform(projSource, projDest, [x, y]);
}

// eslint-disable-next-line no-unused-vars
var overlayStyle = function () {
  /* jshint -W069 */
  var styles = {};
  styles['Polygon'] = [new Style["c" /* default */]({
    fill: new Fill["a" /* default */]({
      color: [255, 255, 255, 0.5]
    })
  }), new Style["c" /* default */]({
    stroke: new Stroke["a" /* default */]({
      color: [255, 255, 255, 1],
      width: 5
    })
  }), new Style["c" /* default */]({
    stroke: new Stroke["a" /* default */]({
      color: [0, 153, 255, 1],
      width: 3
    })
  })];
  styles['MultiPolygon'] = styles['Polygon'];

  styles['LineString'] = [new Style["c" /* default */]({
    stroke: new Stroke["a" /* default */]({
      color: [255, 255, 255, 1],
      width: 5
    })
  }), new Style["c" /* default */]({
    stroke: new Stroke["a" /* default */]({
      color: [0, 153, 255, 1],
      width: 3
    })
  })];
  styles['MultiLineString'] = styles['LineString'];

  styles['Point'] = [new Style["c" /* default */]({
    image: new Circle["a" /* default */]({
      radius: 7,
      fill: new Fill["a" /* default */]({
        color: [0, 153, 255, 1]
      }),
      stroke: new Stroke["a" /* default */]({
        color: [255, 255, 255, 0.75],
        width: 1.5
      })
    }),
    zIndex: 100000
  })];
  styles['MultiPoint'] = styles['Point'];

  styles['GeometryCollection'] = styles['Polygon'].concat(styles['Point']);

  return function (feature, resolution) {
    return styles[feature.getGeometry().getType()];
  };
  /* jshint +W069 */
}();

function initWmtsLayers(initialBaseLayer) {
  var useInternalWmts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  OpenLayersSwiss21781_log.t('# in initWmtsLayers(baselayer=' + initialBaseLayer);
  var internalBaseWmtsUrl = 'https://tiles01.lausanne.ch/tiles';
  var externalBaseWmtsUrl = 'https://map.lausanne.ch/tiles';
  var arrayWmts = [];
  var baseWmtsUrl = useInternalWmts ? internalBaseWmtsUrl : externalBaseWmtsUrl;

  /**
  * Allow to retrieve a valid OpenLayers WMTS source object
  * @param {string} layer  : the name of the WMTS layer
  * @param {object} options
  * @return {ol.source.WMTS} : a valid OpenLayers WMTS source
  */
  function wmtsLausanneSource(layer, options) {
    var resolutions = RESOLUTIONS;
    OpenLayersSwiss21781_log.t('# in wmtsLausanneSource(baseWmtsUrl=' + baseWmtsUrl + ', layer=' + layer);
    if (Array.isArray(options.resolutions)) {
      resolutions = options.resolutions;
    }
    var tileGrid = new tilegrid_WMTS["b" /* default */]({
      origin: [420000, 350000],
      resolutions: resolutions,
      matrixIds: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    });
    var extension = options.format || 'png';
    var timestamp = options.timestamps;
    var url = baseWmtsUrl + '/1.0.0/{Layer}/default/' + timestamp + '/swissgrid_05/{TileMatrix}/{TileRow}/{TileCol}.' + extension;
    url = url.replace('http:', location.protocol);
    // noinspection ES6ModulesDependencies
    return new WMTS["a" /* default */]( /** @type {olx.source.WMTSOptions} */{
      // crossOrigin: 'anonymous',
      attributions: '&copy;<a "href=\'http://www.lausanne.ch/cadastre>Cadastre\'>SGLEA-C Lausanne</a>',
      url: url,
      tileGrid: tileGrid,
      layer: layer,
      requestEncoding: 'REST'
    });
  }

  arrayWmts.push(new Tile["a" /* default */]({
    title: 'Plan ville couleur',
    type: 'base',
    visible: initialBaseLayer === 'fonds_geo_osm_bdcad_couleur',
    source: wmtsLausanneSource('fonds_geo_osm_bdcad_couleur', {
      timestamps: [2015],
      format: 'png'
    })
  }));
  arrayWmts.push(new Tile["a" /* default */]({
    title: 'Plan cadastral (gris)',
    type: 'base',
    visible: initialBaseLayer === 'fonds_geo_osm_bdcad_gris',
    source: wmtsLausanneSource('fonds_geo_osm_bdcad_gris', {
      timestamps: [2015],
      format: 'png'
    })
  }));
  arrayWmts.push(new Tile["a" /* default */]({
    title: 'Orthophoto 2012',
    type: 'base',
    visible: initialBaseLayer === 'orthophotos_ortho_lidar_2012',
    source: wmtsLausanneSource('orthophotos_ortho_lidar_2012', {
      timestamps: [2012],
      format: 'png'
    })
  }));
  arrayWmts.push(new Tile["a" /* default */]({
    title: 'Orthophoto 2016',
    type: 'base',
    visible: initialBaseLayer === 'orthophotos_ortho_lidar_2016',
    source: wmtsLausanneSource('orthophotos_ortho_lidar_2016', {
      timestamps: [2016],
      format: 'png'
    })
  }));
  if (useInternalWmts) {
    arrayWmts.push(new Tile["a" /* default */]({
      title: 'Plan cadastral souterrain (gris)',
      type: 'base',
      visible: initialBaseLayer === 'fonds_geo_conduites',
      source: wmtsLausanneSource('fonds_geo_conduites', {
        timestamps: [2018],
        format: 'png'
      })
    }));
  }
  arrayWmts.push(new Tile["a" /* default */]({
    title: 'Carte Nationale',
    type: 'base',
    visible: initialBaseLayer === 'fonds_geo_carte_nationale_msgroup',
    source: wmtsLausanneSource('fonds_geo_carte_nationale_msgroup', {
      timestamps: [2014],
      format: 'png'
    })
  }));
  return arrayWmts;
}

/**
 * creates an OpenLayers View Object
 * @param {array} centerView : an array [x,y] representing initial initial center of the view
 * @param {number} zoomView : an integer from 1 to 12 representing the level of zoom
 * @returns {ol.View} : the OpenLayers View object
 */
function getOlView() {
  var centerView = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [537892.8, 152095.7];
  var zoomView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;

  return new View["a" /* default */]({
    projection: swissProjection,
    center: centerView,
    minZoom: 1,
    maxZoom: 10,
    extent: MAX_EXTENT_LIDAR,
    zoom: zoomView
  });
}

function getOlMap(divMap, olView) {
  var baseLayer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'fonds_geo_osm_bdcad_couleur';
  var geojsonData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var clickCallback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var useInternalWMTS = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  OpenLayersSwiss21781_log.t('In getOlMap(' + divMap + ', .. baseLayer= ' + baseLayer + ', geojsonData');
  var olMousePosition = new MousePosition["a" /* default */]({
    coordinateFormat: Object(coordinate["d" /* createStringXY */])(1),
    projection: 'EPSG:2181'
    /*
    className: 'map-mouse-position',
    target: document.getElementById('mousepos'),
    undefinedHTML: '&nbsp;'
    */
  });
  var arrLayers = initWmtsLayers(baseLayer, useInternalWMTS);

  var newVectorLayer = null;
  if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(geojsonData)) {
    OpenLayersSwiss21781_log.l('# will load GeoJSON Polygon Layer( geojsondata:' + geojsonData.features.lenght, geojsonData);
    var vectorSource = OpenLayersSwiss21781_getVectorSourceGeoJson(geojsonData, false);
    newVectorLayer = new Vector["a" /* default */]({
      title: 'ol_vector_layer_geojsondata',
      name: 'ol_vector_layer_geojsondata',
      source: vectorSource,
      style: OpenLayersSwiss21781_getPolygonStyle
    });
    OpenLayersSwiss21781_log.l('Layer Features : ' + getNumberFeaturesInLayer(newVectorLayer), newVectorLayer);
    arrLayers.push(newVectorLayer);
  }
  var myMap = new Map["a" /* default */]({
    target: divMap,
    loadTilesWhileAnimating: true,
    // projection: swissProjection,
    controls: Object(control["a" /* defaults */])({
      attributionOptions: {
        collapsible: false
      }
    }).extend([olMousePosition]),
    layers: arrLayers,
    view: olView
  });
  myMap.set('ol_vector_layer_geojsondata', newVectorLayer);
  return myMap;
}

function fetchStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return promise_default.a.resolve(response);
  }
  return promise_default.a.reject(new Error(response.statusText));
}

function OpenLayersSwiss21781_getVectorSourceGeoJson(geoJsonData) {
  var removeInvalidFeatures = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  OpenLayersSwiss21781_log.t('## in getVectorSourceGeoJson ');
  var tempSource = new source_Vector["a" /* default */]({
    format: new GeoJSON["a" /* default */]({
      defaultDataProjection: 'EPSG:21781',
      projection: 'EPSG:21781'
    }),
    features: new GeoJSON["a" /* default */]().readFeatures(geoJsonData)
  });
  if (removeInvalidFeatures) {
    // filter out any invalid polygon
    var arrFeatures = tempSource.getFeatures();
    arrFeatures.forEach(function (feature) {
      if (!isValidFeature(feature)) {
        OpenLayersSwiss21781_log.w('WARNING in getVectorSourceGeoJson removing INVALID feature :\n' + dumpFeatureToString(feature));
        tempSource.removeFeature(feature);
      }
    });
  }
  return tempSource;
}

function OpenLayersSwiss21781_getPolygonStyle(feature, resolution) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    fill_color: 'rgba(255, 0, 0, 0.8)',
    stroke_color: '#191aff',
    stroke_width: 3
  };

  OpenLayersSwiss21781_log.t('## Entering getStyle with feature :', feature);
  OpenLayersSwiss21781_log.l('resolution : ' + resolution);

  var props = null;
  var theStyle = null;
  if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(feature) && !Object(cgHtmlUtils_min["isNullOrUndefined"])(feature.getProperties())) {
    props = feature.getProperties();
    var id = Object(cgHtmlUtils_min["isNullOrUndefined"])(props.id) ? '#INCONNU#' : props.id;
    OpenLayersSwiss21781_log.l('id : ' + id);
    theStyle = new Style["c" /* default */]({
      fill: new Fill["a" /* default */]({
        color: Object(cgHtmlUtils_min["isNullOrUndefined"])(props.fill_color) ? options.fill_color : props.fill_color
      }),
      stroke: new Stroke["a" /* default */]({
        color: Object(cgHtmlUtils_min["isNullOrUndefined"])(props.stroke_color) ? options.stroke_color : props.stroke_color,
        width: Object(cgHtmlUtils_min["isNullOrUndefined"])(props.stroke_width) ? options.stroke_width : props.stroke_width
      }),
      image: new Circle["a" /* default */]({
        radius: Object(cgHtmlUtils_min["isNullOrUndefined"])(props.stroke_width) ? options.stroke_width : props.stroke_width,
        fill: new Fill["a" /* default */]({
          color: Object(cgHtmlUtils_min["isNullOrUndefined"])(props.fill_color) ? options.fill_color : props.fill_color
        })
      })
    });
  } else {
    theStyle = new Style["c" /* default */]({
      fill: new Fill["a" /* default */]({
        color: options.fill_color // 'rgba(255, 0, 0, 0.8)',
      }),
      stroke: new Stroke["a" /* default */]({
        color: options.stroke_color, // '#191aff',
        width: options.stroke_width
      }),
      image: new Circle["a" /* default */]({
        radius: 9,
        fill: new Fill["a" /* default */]({
          color: '#ffcc33'
        })
      })
    });
  }
  return theStyle;
}

function loadGeoJsonUrlPolygonLayer(olMap, geojsonUrl) {
  var loadCompleteCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var layerName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'ol_vector_layer_geojsonurl';

  OpenLayersSwiss21781_log.t('# in loadGeoJsonUrlPolygonLayer creating Layer : ' + geojsonUrl);
  fetch(geojsonUrl).then(fetchStatus).then(function (response) {
    return response.json();
  }).then(function (json) {
    OpenLayersSwiss21781_log.t('# in loadGeoJSONPolygonLayer then((json) => : ', json);
    var vectorSource = OpenLayersSwiss21781_getVectorSourceGeoJson(json);
    var newLayer = new Vector["a" /* default */]({
      name: layerName,
      title: layerName,
      source: vectorSource,
      style: OpenLayersSwiss21781_getPolygonStyle
    });
    OpenLayersSwiss21781_log.l('Layer Features : ' + getNumberFeaturesInLayer(newLayer), newLayer);
    olMap.addLayer(newLayer);
    var extent = newLayer.getSource().getExtent();
    olMap.getView().fit(extent, olMap.getSize());
    if (Object(cgHtmlUtils_min["functionExist"])(loadCompleteCallback)) {
      loadCompleteCallback(newLayer);
    }
  }).catch(function (error) {
    // maybe find a better way to send back this error to the client
    OpenLayersSwiss21781_log.e('loadGeoJSONPolygonLayer # FETCH REQUEST FAILED with url: ' + geojsonUrl, error);
  });
}

function addGeoJSONPolygonLayer(olMap, geojsonUrl, loadCompleteCallback) {
  OpenLayersSwiss21781_log.t('# in addGeoJSONPolygonLayer creating Layer : ' + geojsonUrl);
  var vectorSource = new source_Vector["a" /* default */]({
    url: geojsonUrl,
    format: new GeoJSON["a" /* default */]({
      defaultDataProjection: 'EPSG:21781',
      projection: 'EPSG:21781'
    })
  });
  /*
   https://openlayers.org/en/latest/examples/draw-and-modify-features.html
   https://openlayers.org/en/latest/examples/modify-features.html
   TODO use a property of the geojson query to display color
   or a style function  : http://openlayersbook.github.io/ch06-styling-vector-layers/example-07.html
   */
  var newLayer = new Vector["a" /* default */]({
    source: vectorSource,
    style: new Style["c" /* default */]({
      fill: new Fill["a" /* default */]({
        color: 'rgba(255, 0, 0, 0.8)'
      }),
      stroke: new Stroke["a" /* default */]({
        color: '#ffcc33',
        width: 3
      }),
      image: new Circle["a" /* default */]({
        radius: 9,
        fill: new Fill["a" /* default */]({
          color: '#ffcc33'
        })
      })
    })
  });
  var listenerKey = vectorSource.on('change', function (e) {
    if (vectorSource.getState() === 'ready') {
      // TODO maybe add "loading icon" and here where to hide it
      // retrieve extent of all features to zoom only when loading of the layer via Ajax XHR is complete
      var extent = newLayer.getSource().getExtent();
      if (config_DEV) {
        OpenLayersSwiss21781_log.l('# Finished Loading Layer : ' + geojsonUrl, e);
      }
      olMap.getView().fit(extent, olMap.getSize());
      // and unregister the "change" listener
      Observable["default"].unByKey(listenerKey);
      if (Object(cgHtmlUtils_min["functionExist"])(loadCompleteCallback)) {
        loadCompleteCallback(newLayer);
      }
    }
  });
  return newLayer;
}

function initNewFeaturesLayer(olMap, olFeatures) {
  var newFeaturesLayer = new Vector["a" /* default */]({
    name: 'ol_newFeaturesLayer',
    source: new source_Vector["a" /* default */]({ features: olFeatures }),
    style: new Style["c" /* default */]({
      fill: new Fill["a" /* default */]({
        color: 'rgba(255, 0, 0, 0.3)'
      }),
      stroke: new Stroke["a" /* default */]({
        color: '#ffee00',
        width: 5
      }),
      image: new Circle["a" /* default */]({
        radius: 10,
        fill: new Fill["a" /* default */]({
          color: '#ff4f22'
        })
      })
    })
  });
  // newFeaturesLayer.setMap(olMap) // use this to have an overlay
  olMap.addLayer(newFeaturesLayer);
  return newFeaturesLayer;
}

function setCreateMode(olMap, olFeatures, arrInteractionsStore, baseCounter, endCreateCallback) {
  OpenLayersSwiss21781_log.t('# in setCreateMode baseCounter : ' + baseCounter);
  var modify = new Modify["a" /* default */]({
    features: olFeatures,
    // the SHIFT key must be pressed to delete vertices, so
    // that new vertices can be drawn at the same position
    // of existing vertices
    deleteCondition: function deleteCondition(event) {
      return Object(condition["k" /* shiftKeyOnly */])(event) && Object(condition["l" /* singleClick */])(event);
    }
  });
  olMap.addInteraction(modify);
  arrInteractionsStore.push(modify);
  // var currentNumCoords = 0
  var draw = new Draw["a" /* default */]({
    features: olFeatures, // vectorSource.getFeatures(),
    type: 'Polygon' /** @type {ol.geom.GeometryType} */
    /*
      geometryFunction: function (coords, geom) {
        if (isNullOrUndefined(geom)) { geom = new OlPolygon(null) }
        if (!isNullOrUndefined(coords[0])) {
          let numCoords = coords[0].length
          if (numCoords > currentNumCoords) {
            currentNumCoords = numCoords
            if (numCoords > 3) {
              let tmpCoords = coords[0].slice(0)
              tmpCoords.push(coords[0][0])
              let flatCoords = tmpCoords.reduce((r, s) => r.push(s[0], s[1]) && r, [])
              // flatCoords = flatCoords.map((p) => p.map((v) => parseFloat(Number(v).toFixed(DIGITIZE_PRECISION))))
              let bad = polygonSelfIntersect(flatCoords)
              // console.log(`%c IN setCreateMode geometryFunction callback :`, 'background: #F4D03F; color: #111', coords, geom, bad, flatCoords)
              if (bad) {
                console.log(`%c WARNING SELF_INTERSECT in setCreateMode geometryFunction callback `, 'background: #f00; color: #fff', coords, geom, flatCoords)
                this.removeLastPoint()
                // coords[0].pop() // on retire la derniere coord qui est pas ok
              } else {
                console.log(`%c in setCreateMode geometryFunction callback `, 'background: #0f0; color: #000', coords, geom, flatCoords)
              }
            }
          }
        }
        geom.setCoordinates(coords)
        return geom
      }
      */
  });
  var id = baseCounter;
  draw.on('change', function (e) {
    OpenLayersSwiss21781_log.t('IN setCreateMode EVENT.change :', e);
  });
  draw.on('change:active', function (e) {
    if (config_DEV) {
      console.log('%c IN setCreateMode EVENT.change:active :', 'background: #F4D03F; color: #111', e);
    }
  });
  draw.on('drawstart', function (e) {
    id += 1;
    e.feature.setId(id);
    e.feature.setProperties({ 'id': id });
    if (config_DEV) {
      console.log('%c IN setCreateMode EVENT.drawstart: baseCounter : ' + baseCounter + ' \n ' + dumpFeatureToString(e.feature), 'background: #F4D03F; color: #111', e);
    }
  });
  draw.on('drawend', function (e) {
    // let multiPolygon = new OlMultiPolygon([])
    var currentFeature = e.feature; // this is the feature fired the event
    currentFeature.setId(id);
    currentFeature.setProperties({ 'id': id });
    if (isValidFeature(currentFeature)) {
      currentFeature.setProperties({ 'title': 'POLYGONE [' + id + '] VALIDE' });
    } else {
      currentFeature.setProperties({ 'title': 'POLYGONE [' + id + '] INVALIDE' });
    }
    OpenLayersSwiss21781_log.t('INSIDE setCreateMode event drawend currentFeature: ' + dumpFeatureToString(currentFeature));
    var currentPolygon = currentFeature.getGeometry();
    var exteriorRingCoords = currentPolygon.getLinearRing(0).getCoordinates().map(function (p) {
      return p.map(function (v) {
        return parseFloat(Number(v).toFixed(DIGITIZE_PRECISION));
      });
    });
    currentPolygon.setCoordinates([exteriorRingCoords], 'XY');
    if (Object(cgHtmlUtils_min["functionExist"])(endCreateCallback)) {
      endCreateCallback(currentFeature);
    }
  });
  olMap.addInteraction(draw);
  arrInteractionsStore.push(draw);
  return draw;
} // end of setCreateMode

function setModifyMode(olMap, olLayer2Edit, arrInteractionsStore, baseCounter, endModifyCallback) {
  OpenLayersSwiss21781_log.t('# in setModifyMode baseCounter : ' + baseCounter);

  var modifyStyles = [
  /* We are using two different styles for the polygons:
   *  - The first style is for the polygons themselves.
   *  - The second style is to draw the vertices of the polygons.
   *    In a custom `geometry` function the vertices of a polygon are
   *    returned as `MultiPoint` geometry, which will be used to render
   *    the style.
   */
  new Style["c" /* default */]({
    stroke: new Stroke["a" /* default */]({
      color: 'blue',
      width: 3
    }),
    fill: new Fill["a" /* default */]({
      color: 'rgba(0, 0, 255, 0.1)'
    })
  }), new Style["c" /* default */]({
    image: new Circle["a" /* default */]({
      radius: 7,
      fill: new Fill["a" /* default */]({
        color: 'orange'
      })
    }),
    geometry: function geometry(feature) {
      // return the coordinates of the first ring of the polygon
      var coordinates = feature.getGeometry().getCoordinates()[0];
      return new MultiPoint["a" /* default */](coordinates);
    }
  })];

  var select = new Select["a" /* default */]({
    layers: [olLayer2Edit],
    wrapX: false,
    style: modifyStyles // overlayStyle
  });
  /*
    The modify interaction does not listen to geometry change events.
    Changing the feature coordinates will make the modify interaction
    unaware of the actual feature coordinates.
    A possible fix: Maintain a collection used by Modify, so we can reload
    the features manually. This collection will always contain the same
    features as the select interaction.
  */
  var selectSource = new Collection["a" /* default */]();
  select.on('select', function (evt) {
    evt.selected.forEach(function (feature) {
      selectSource.push(feature);
    });
    evt.deselected.forEach(function (feature) {
      selectSource.remove(feature);
    });
  });
  var modify = new Modify["a" /* default */]({
    features: selectSource, // use our custom collection instead of select.getFeatures()
    // the SHIFT key must be pressed to delete vertices, so
    // that new vertices can be drawn at the same position
    // of existing vertices
    deleteCondition: function deleteCondition(event) {
      return Object(condition["k" /* shiftKeyOnly */])(event) && Object(condition["l" /* singleClick */])(event);
    }
  });
  var originalCoordinates = {};
  modify.on('modifystart', function (evt) {
    evt.features.forEach(function (feature) {
      originalCoordinates[feature] = feature.getGeometry().getCoordinates();
    });
  });
  modify.on('modifyend', function (e) {
    var currentFeatures = e.features.getArray();
    OpenLayersSwiss21781_log.t('-->INSIDE setModifyMode event modifyend : ', e);
    var newPoint = e.mapBrowserEvent.coordinate; // point of last click

    var formatWKT = new WKT["a" /* default */]();
    currentFeatures.forEach(function (feature) {
      var isItValid = isValidPolygon(feature, newPoint);
      OpenLayersSwiss21781_log.l('--> in modifyend featureWKTGeometry=\n' + dumpFeatureToString(feature));
      if (feature in originalCoordinates && !isItValid) {
        feature.getGeometry().setCoordinates(originalCoordinates[feature]);
        delete originalCoordinates[feature];
        // remove and re-add the feature to make Modify reload it's geometry
        selectSource.remove(feature);
        selectSource.push(feature);
      }
      var id = feature.getProperties()['id'] || 0;
      if (isValidFeature(feature)) {
        feature.setProperties({ 'title': 'POLYGONE [' + id + '] VALIDE' });
      } else {
        feature.setProperties({ 'title': 'POLYGONE [' + id + '] INVALIDE' });
      }
      if (Object(cgHtmlUtils_min["functionExist"])(endModifyCallback)) {
        endModifyCallback(feature);
      }
      var featureWKTGeometry = formatWKT.writeFeature(feature);
      OpenLayersSwiss21781_log.l('--> in modifyend featureWKTGeometry= ' + featureWKTGeometry);
    });
  });
  olMap.addInteraction(select);
  olMap.addInteraction(modify);
  arrInteractionsStore.push(select);
  arrInteractionsStore.push(modify);
}

function setTranslateMode(olMap, olLayer2Translate, arrInteractionsStore) {
  OpenLayersSwiss21781_log.t('# in setTranslateMode ');
  var select = new Select["a" /* default */]({
    layers: [olLayer2Translate]
  });
  var translate = new Translate["a" /* default */]({
    features: select.getFeatures()
  });
  olMap.addInteraction(select);
  olMap.addInteraction(translate);
  arrInteractionsStore.push(select);
  arrInteractionsStore.push(translate);
}

function setDeleteMode(olMap, olLayer2Delete, arrInteractionsStore, baseCounter) {
  OpenLayersSwiss21781_log.t('# in setModifyMode baseCounter : ' + baseCounter);
  var select = new Select["a" /* default */]({
    layers: [olLayer2Delete]
  });
  var selectSource = new Collection["a" /* default */]();
  select.on('select', function (evt) {
    evt.selected.forEach(function (feature) {
      selectSource.push(feature);
      OpenLayersSwiss21781_log.l(' Feature selected 4 delete ' + dumpFeatureToString(feature));
      olLayer2Delete.getSource().removeFeature(feature);
    });
    evt.deselected.forEach(function (feature) {
      selectSource.remove(feature);
    });
  });
  olMap.addInteraction(select);
  arrInteractionsStore.push(select);
}

function findFeaturebyId(olLayer, idFieldName, id) {
  var source = olLayer.getSource();
  var arrFeatures = source.getFeatures();
  for (var i = 0; i < arrFeatures.length; i++) {
    if (arrFeatures[i].getProperties()[idFieldName] === id) {
      return arrFeatures[i];
    }
  }
  return null;
}

function getFeatureExtentbyId(olLayer, idFieldName, id) {
  var feature = this.findFeaturebyId(olLayer, idFieldName, id);
  if (feature != null) {
    return feature.getGeometry().getExtent();
  } else {
    return null;
  }
}

function getNumberFeaturesInLayer(olLayer) {
  if (Object(cgHtmlUtils_min["isNullOrUndefined"])(olLayer)) {
    return 0;
  } else {
    var source = olLayer.getSource();
    var arrFeatures = source.getFeatures();
    return arrFeatures.length;
  }
}

function getGeoJSONGeomFromFeature(olFeature) {
  var formatGeoJSON = new GeoJSON["a" /* default */]();
  var geom = olFeature.getGeometry();
  var geometryType = geom.getType().toUpperCase();
  if (geometryType === 'POLYGON') {
    var exteriorRingCoords = geom.getLinearRing(0).getCoordinates().map(function (p) {
      return p.map(function (v) {
        return parseFloat(Number(v).toFixed(DIGITIZE_PRECISION));
      });
    });
    geom.setCoordinates([exteriorRingCoords], 'XY');
  } else {
    OpenLayersSwiss21781_log.w('WARNING IN ' + OpenLayersSwiss21781_MODULE_NAME + '.getGeoJSONGeomFromFeature() : only POLYGON ARE SUPPORTED FOR NOW');
  }
  return formatGeoJSON.writeFeature(olFeature);
}

function getWktGeomFromFeature(olFeature) {
  OpenLayersSwiss21781_log.t('in getWktGeometryFeaturesInLayer ');
  var formatWKT = new WKT["a" /* default */]();
  var geom = olFeature.getGeometry();
  var geometryType = geom.getType().toUpperCase();
  if (geometryType === 'POLYGON') {
    var exteriorRingCoords = geom.getLinearRing(0).getCoordinates().map(function (p) {
      return p.map(function (v) {
        return parseFloat(Number(v).toFixed(DIGITIZE_PRECISION));
      });
    });
    geom.setCoordinates([exteriorRingCoords], 'XY');
  } else {
    OpenLayersSwiss21781_log.w('WARNING IN ' + OpenLayersSwiss21781_MODULE_NAME + '.getWktGeomFromFeature() : only POLYGON ARE SUPPORTED FOR NOW');
  }
  return formatWKT.writeFeature(olFeature);
}

function getWktGeometryFeaturesInLayer(olLayer) {
  if (Object(cgHtmlUtils_min["isNullOrUndefined"])(olLayer)) {
    return null;
  } else {
    OpenLayersSwiss21781_log.t('in getWktGeometryFeaturesInLayer ');
    var source = olLayer.getSource();
    var arrFeatures = source.getFeatures();
    OpenLayersSwiss21781_log.l('--> found ' + arrFeatures.length + ' Features');
    var strGeom = '';
    if (arrFeatures.length > 0) {
      for (var i = 0; i < arrFeatures.length; i++) {
        var featureString = dumpFeatureToString(arrFeatures[i]);
        strGeom += featureString;
      }
    }
    return strGeom;
  }
}

function isValidFeature(olFeature) {
  var geometryType = olFeature.getGeometry().getType().toUpperCase();
  var isValid = true;
  switch (geometryType) {
    case 'MULTIPOLYGON':
      isValid = isValidMultiPolygon(olFeature);
      break;
    case 'POLYGON':
      isValid = isValidPolygon(olFeature);
      break;
    default:
      OpenLayersSwiss21781_log.w('## isValidFeature : only MULTIPOLYGON and POLYGON are supported for now');
  }
  return isValid;
}

/**
 * Allow to get a string representation of the feature
 * @param {ol.Feature} olFeature : the feature of geometry type Polygon you want to dump
 * @return {string} : the string representation of this feature
 */
function dumpFeatureToString(olFeature) {
  OpenLayersSwiss21781_log.t('in dumpFeatureToString ');
  var featureWKTGeometry = getWktGeomFromFeature(olFeature);
  var geometryType = olFeature.getGeometry().getType().toUpperCase();
  var rev = olFeature.getRevision();
  var id = olFeature.getId();
  var featureProps = olFeature.getProperties();
  var isValid = isValidFeature(olFeature) ? 'VALID' : 'INVALID';
  var featurePropsDump = '';
  if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(featureProps)) {
    featurePropsDump = Object(cgHtmlUtils_min["dumpObject2String"])(featureProps);
  }
  var featureString = '\n' + isValid + ' ' + geometryType + ' Feature id=' + id + '  : (rev ' + rev + ')\n  \n# PROPERTIES:\n' + featurePropsDump + '\n  \n# WKT GEOMETRY:\n' + featureWKTGeometry + '\n';
  return featureString;
}

function getMultiPolygonWktGeometryFromPolygonFeaturesInLayer(olLayer) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (Object(cgHtmlUtils_min["isNullOrUndefined"])(olLayer)) {
    return null;
  } else {
    OpenLayersSwiss21781_log.t('--> getMultiPolygonWktGeometryFromFeaturesInLayer ');
    var source = olLayer.getSource();
    var arrFeatures = source.getFeatures();
    OpenLayersSwiss21781_log.l('--> found ' + arrFeatures.length + ' Features');
    var tmpMultiPolygon = new MultiPolygon["a" /* default */]([]);
    if (arrFeatures.length > 0) {
      for (var i = 0; i < arrFeatures.length; i++) {
        var geom = arrFeatures[i].getGeometry();
        var geometryType = geom.getType().toUpperCase();
        if (geometryType === 'POLYGON') {
          var exteriorRingCoords = geom.getLinearRing(0).getCoordinates().map(function (p) {
            return p.map(function (v) {
              return parseFloat(Number(v).toFixed(DIGITIZE_PRECISION));
            });
          });
          geom.setCoordinates([exteriorRingCoords], 'XY');
          tmpMultiPolygon.appendPolygon(geom);
        }
      }
      var multiPolygonFeature = new Feature["a" /* default */]({
        geometry: tmpMultiPolygon
      });
      multiPolygonFeature.setId(id);
      var featureWKTGeometry = getWktGeomFromFeature(multiPolygonFeature);
      if (config_DEV) {
        console.log('%c WKT : ' + featureWKTGeometry + ' ', 'background: #ffff00; color: #111');
      }
      return featureWKTGeometry;
    }
  }
}

function getBBFromWktPolygon(wktGeometry) {
  // let BoundingBox = null
  var formatWKT = new WKT["a" /* default */]();
  var feature = formatWKT.readFeature(wktGeometry, {
    dataProjection: 'EPSG:21781',
    featureProjection: 'EPSG:21781'
  });
  var geometry = feature.getGeometry();
  return geometry.getExtent();
}

function addWktPolygonToLayer(olLayer, wktGeometry, baseCounter) {
  if (Object(cgHtmlUtils_min["isNullOrUndefined"])(olLayer)) {
    return null;
  } else {
    var id = baseCounter;
    var source = olLayer.getSource();
    var formatWKT = new WKT["a" /* default */]();
    var feature = formatWKT.readFeature(wktGeometry, {
      dataProjection: 'EPSG:21781',
      featureProjection: 'EPSG:21781'
    });
    var geometryType = feature.getGeometry().getType().toUpperCase();
    // TODO if layer contain already features check for identical features and do not add them twice
    switch (geometryType) {
      case 'MULTIPOLYGON':
        // let's add the polygons
        feature.getGeometry().getPolygons().forEach(function (polygon) {
          // console.log('## addWktPolygonToLayer found polygon :', polygon)
          var polygonFeature = new Feature["a" /* default */]({
            geometry: polygon
          });
          if (isValidPolygon(polygonFeature)) {
            // TODO call isPolygonsFeaturesEqual for all existing other polygon
            id += 1; // increment counter
            polygonFeature.setId(id);
            polygonFeature.setProperties({ 'id': id });
            polygonFeature.setProperties({ 'title': 'POLYGONE [' + id + '] VALIDE' });
            source.addFeature(polygonFeature);
          } else {
            OpenLayersSwiss21781_log.e('## Error in addWktPolygonToLayer : MULTIPOLYGON IS NOT VALID');
            OpenLayersSwiss21781_log.e('## Error in addWktPolygonToLayer : invalid polygon is this one:', dumpFeatureToString(polygonFeature));
            return null;
          }
        });
        break;
      case 'POLYGON':
        if (isValidPolygon(feature)) {
          // let's use this one as it is
          id += 1; // increment counter
          feature.setId(id);
          feature.setProperties({ 'id': id });
          feature.setProperties({ 'title': 'POLYGONE [' + id + '] VALIDE' });
          source.addFeature(feature);
        } else {
          OpenLayersSwiss21781_log.e('## Error in addWktPolygonToLayer : POLYGON IS NOT VALID');
          OpenLayersSwiss21781_log.e('## Error in addWktPolygonToLayer : invalid polygon is this one:', dumpFeatureToString(feature));
          return null;
        }
        break;
      default:
        OpenLayersSwiss21781_log.e('## Error only MULTIPOLYGON and POLYGON are supported here');
        return null;
    }
    return id;
  }
}
// this function expects only the geometry part of the geojson
// TODO may be write a function that also can add a complete GeoJSON with attributes
function addGeoJsonPolygonToLayer(olLayer, GeoJSONGeometry, baseCounter) {
  OpenLayersSwiss21781_log.t('## IN addGeoJsonPolygonToLayer ', GeoJSONGeometry);
  if (Object(cgHtmlUtils_min["isNullOrUndefined"])(olLayer)) {
    return null;
  } else {
    var id = baseCounter;
    var source = olLayer.getSource();
    var formatGeoJSON = new GeoJSON["a" /* default */]();
    var feature = formatGeoJSON.readFeature(GeoJSONGeometry, {
      dataProjection: 'EPSG:21781',
      featureProjection: 'EPSG:21781'
    });
    var geometryType = feature.getGeometry().getType().toUpperCase();
    // TODO if layer contain already features check for identical features and do not add them twice
    switch (geometryType) {
      case 'MULTIPOLYGON':
        // let's add the polygons
        feature.getGeometry().getPolygons().forEach(function (polygon) {
          // console.log('## addWktPolygonToLayer found polygon :', polygon)
          var polygonFeature = new Feature["a" /* default */]({
            geometry: polygon
          });
          if (isValidPolygon(polygonFeature)) {
            id += 1; // increment counter
            polygonFeature.setId(id);
            polygonFeature.setProperties({ 'id': id });
            polygonFeature.setProperties({ 'title': 'POLYGONE [' + id + '] VALIDE' });
            source.addFeature(polygonFeature);
          } else {
            OpenLayersSwiss21781_log.e('## Error in addGeoJsonPolygonToLayer : MULTIPOLYGON IS NOT VALID');
            OpenLayersSwiss21781_log.e('## Error in addGeoJsonPolygonToLayer : invalid polygon is this one:', dumpFeatureToString(polygonFeature));
            return null;
          }
        });
        break;
      case 'POLYGON':
        if (isValidPolygon(feature)) {
          // let's use this one as it is
          id += 1; // increment counter
          feature.setId(id);
          feature.setProperties({ 'id': id });
          feature.setProperties({ 'title': 'POLYGONE [' + id + '] VALIDE' });
          source.addFeature(feature);
        } else {
          OpenLayersSwiss21781_log.e('## Error in addWktPolygonToLayer : POLYGON IS NOT VALID');
          OpenLayersSwiss21781_log.e('## Error in addWktPolygonToLayer : invalid polygon is this one:', dumpFeatureToString(feature));
          return null;
        }
        break;
      default:
        OpenLayersSwiss21781_log.e('## Error only MULTIPOLYGON and POLYGON are supported here');
        return null;
    }
    return id;
  }
}

function isPointDistanceOkForPolygon(p0, p1) {
  var distance = distance2Point(p0, p1);
  if (distance <= EPSILON) return true; // comparing same point, probably start and end point
  if (distance > MIN_DISTANCE_BETWEEN_POINTS) return true;
  return false;
}

/**
 * Allow to check if an OpenLayers Polygon is valid:
 * 0) the feature is of type Polygon
 * 1) No point of the polygons are nearest then MIN_DISTANCE_BETWEEN_POINTS of another point of this polygon
 * 2) No self-intersection etc like topologically valid, according to the OGC SFS specification
 * 3) No point of the polygons are inside another polygon (NOT DONE IN THIS VERSION)
 * @param {ol.Feature} olFeature : the feature of geometry type Polygon you want to check
 * @param {array} clickPoint : 2d array with x,y coordinates of last point modified
 * @return {boolean} : true if the polygon is valid
 */
function isValidPolygon(olFeature) {
  var clickPoint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var removeDuplicates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var debugThis = false;
  var geometry = olFeature.getGeometry();
  var geometryType = geometry.getType().toUpperCase();
  if (geometryType === 'POLYGON') {
    // let's check first condition 1 no point are nearest then tolerance
    // TODO try to do it without clickPoint
    var coordsPolygon = [];
    var exteriorRingCoords = geometry.getLinearRing(0).getCoordinates().map(function (p) {
      return p.map(function (v) {
        return parseFloat(Number(v).toFixed(DIGITIZE_PRECISION));
      });
    });
    if (debugThis) OpenLayersSwiss21781_log.l('## isValidPolygon : Polygon exteriorRingCoords', exteriorRingCoords);
    if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(clickPoint)) {
      var newCoord = clickPoint.map(function (v) {
        return parseFloat(Number(v).toFixed(DIGITIZE_PRECISION));
      });
      if (debugThis) OpenLayersSwiss21781_log.l('## isValidPolygon : newCoord', newCoord);
      for (var i = 0; i < exteriorRingCoords.length; i++) {
        var p = exteriorRingCoords[i];
        // let's store only distinct points to take into account fake points in create mode
        if (i === 0) {
          coordsPolygon.push(p[0], p[1]);
        } else {
          if (distance2Point(p, exteriorRingCoords[i - 1]) >= EPSILON) {
            coordsPolygon.push(p[0], p[1]);
          }
        }
        OpenLayersSwiss21781_log.l('Point ' + i + ' [' + p[0] + ',' + p[1] + '] = [' + newCoord[0] + ',' + newCoord[1] + '] is ' + pointsIsEqual(p, newCoord));
        OpenLayersSwiss21781_log.l(' distance is ' + distance2Point(p, newCoord).toFixed(DIGITIZE_PRECISION));
        if (isPointDistanceOkForPolygon(p, newCoord)) {
          if (debugThis) OpenLayersSwiss21781_log.l('++++ POINT IS OKAY ++++');
        } else {
          if (debugThis) OpenLayersSwiss21781_log.w('---- POINT NOT OKAY ---', newCoord);
          return false;
        }
      }
    }
    // let's check condition 2
    var IntersectInfo = { result: false };
    if (coordsPolygon.length > 0) {
      if (debugThis) OpenLayersSwiss21781_log.l('## isValidPolygon : Polygon purified Coords', coordsPolygon);
      IntersectInfo = polygonSelfIntersect(coordsPolygon);
    } else {
      IntersectInfo = polygonSelfIntersect(exteriorRingCoords.reduce(function (r, s) {
        return r.push(s[0], s[1]) && r;
      }, []));
    }
    if (IntersectInfo.result) {
      OpenLayersSwiss21781_log.e('## isValidPolygon : THIS POLYGON IS NOT VALID reason : ' + IntersectInfo.msg + ' at (' + IntersectInfo.intersection[0] + ',' + IntersectInfo.intersection[1] + ')');
      return false;
    }
    // let's implement the check condition 3 in some future because it depends on all other polygons

    return true;
  } else {
    OpenLayersSwiss21781_log.e('## isValidPolygon : only POLYGON features can be tested here');
    return false;
  }
}

function isValidMultiPolygon(olFeature) {
  // const debugThis = false
  var geometry = olFeature.getGeometry();
  var geometryType = geometry.getType().toUpperCase();
  var checkResultIsValid = true;
  if (geometryType === 'MULTIPOLYGON') {
    geometry.getPolygons().forEach(function (polygon) {
      // console.log('## addWktPolygonToLayer found polygon :', polygon)
      var polygonFeature = new Feature["a" /* default */]({ geometry: polygon });
      if (isValidPolygon(polygonFeature)) {
        // TODO call isPolygonsFeaturesEqual for all existing other polygon

      } else {
        OpenLayersSwiss21781_log.e('## Error in isValidMultiPolygon : MULTIPOLYGON IS NOT VALID');
        checkResultIsValid = false;
        return false;
      }
    });
    // if we are here all polygon ok
    return checkResultIsValid;
  } else {
    OpenLayersSwiss21781_log.e('## isValidMultiPolygon : only MULTIPOLYGON features can be tested here');
    return false;
  }
}

function isPolygonsFeaturesEqual(olFeature1, olFeature2) {
  var arrFeature1 = getArrVerticesPolygonFeature(olFeature1);
  var arrFeature2 = getArrVerticesPolygonFeature(olFeature2);
  for (var i = 0; i < arrFeature1.length; i++) {
    OpenLayersSwiss21781_log.l('## isPolygonsFeaturesEqual ' + i + ': ' + arrFeature1[i] + ', ' + arrFeature2[i], arrFeature1[i], arrFeature2[i]);
    if (isPointDistanceOkForPolygon(arrFeature1[i], arrFeature2[i])) {
      return false;
    }
  }
  return true;
}

function getArrVerticesPolygonFeature(olFeature) {
  var removeDuplicates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(olFeature)) {
    var geometry = olFeature.getGeometry();
    var geometryType = geometry.getType().toUpperCase();
    OpenLayersSwiss21781_log.l('## getArrVerticesPolygonFeature : geometryType is ' + geometryType);
    if (geometryType === 'POLYGON') {
      var coordsPolygon = [];
      var exteriorRingCoords = geometry.getLinearRing(0).getCoordinates().map(function (p) {
        return p.map(function (v) {
          return parseFloat(Number(v).toFixed(DIGITIZE_PRECISION));
        });
      });
      for (var i = 0; i < exteriorRingCoords.length; i++) {
        var p = exteriorRingCoords[i];
        // let's store only distinct points to take into account fake points in create mode
        if (i === 0) {
          coordsPolygon.push(p[0], p[1]);
        } else {
          if (distance2Point(p, exteriorRingCoords[i - 1]) >= EPSILON) {
            coordsPolygon.push(p[0], p[1]);
          }
        }
      }
      if (removeDuplicates) {
        return coordsPolygon;
      } else {
        return exteriorRingCoords;
      }
    } else {
      OpenLayersSwiss21781_log.e('## getArrVerticesPolygonFeature : only POLYGON features can be tested here');
      return null;
    }
  } else {
    OpenLayersSwiss21781_log.e('## getArrVerticesPolygonFeature : olFeature was null or undefined');
    return null;
  }
}

function getNumVerticesPolygonFeature(olFeature) {
  var removeDuplicates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var tmpArray = getArrVerticesPolygonFeature(olFeature, removeDuplicates);
  if (Object(cgHtmlUtils_min["isNullOrUndefined"])(tmpArray)) {
    return null;
  } else {
    return tmpArray.length;
  }
}

function flyTo(finalLocation, finalZoom, theOlView, done) {
  var duration = 2000;
  var zoom = theOlView.getZoom();
  var parts = 4;
  var called = false;
  function callback(complete) {
    --parts;
    if (called) {
      return;
    }
    if (parts === 0 || !complete) {
      called = true;
      done(complete);
    }
  }
  theOlView.animate({
    center: finalLocation,
    duration: duration
  }, callback);
  theOlView.animate({
    zoom: zoom - 4,
    duration: duration / 2
  }, {
    zoom: finalZoom,
    duration: duration / 2
  }, callback);
}
// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/parse-int.js
var parse_int = __webpack_require__("gBtx");
var parse_int_default = /*#__PURE__*/__webpack_require__.n(parse_int);

// EXTERNAL MODULE: ./node_modules/ol/layer/Image.js + 2 modules
var Image = __webpack_require__("czjk");

// EXTERNAL MODULE: ./node_modules/ol/source/ImageWMS.js + 4 modules
var ImageWMS = __webpack_require__("j0xK");

// EXTERNAL MODULE: ./node_modules/ol/format/WMTSCapabilities.js + 5 modules
var format_WMTSCapabilities = __webpack_require__("8Rls");

// EXTERNAL MODULE: ./node_modules/ol/style/Icon.js + 1 modules
var Icon = __webpack_require__("zOBh");

// EXTERNAL MODULE: ./node_modules/ol-layerswitcher/dist/ol-layerswitcher.js
var ol_layerswitcher = __webpack_require__("fDp+");
var ol_layerswitcher_default = /*#__PURE__*/__webpack_require__.n(ol_layerswitcher);

// EXTERNAL MODULE: ./node_modules/ol-popup/dist/ol-popup.js
var ol_popup = __webpack_require__("13SB");
var ol_popup_default = /*#__PURE__*/__webpack_require__.n(ol_popup);

// EXTERNAL MODULE: ./node_modules/ol/geom/Point.js
var geom_Point = __webpack_require__("T18w");

// CONCATENATED MODULE: ./src/components/cgil-vue-olmap/tools.js
var maxCouches = 32; // nombre de bits pour stocker les combinaison de couches
var hexToArr = function hexToArr(n) {
  return parseInt(n, 16).toString(2).padStart(maxCouches, '0').split('').map(function (x) {
    return x === '1';
  }).reverse();
};

var arrBoolToHex = function arrBoolToHex(arrBool) {
  return parseInt(arrBool.reverse().map(function (x) {
    return x ? '1' : '0';
  }).join('').padStart(maxCouches, '0'), 2).toString(16);
};
// EXTERNAL MODULE: ./src/components/cgil-vue-olmap/ol.css
var ol = __webpack_require__("/EkY");
var ol_default = /*#__PURE__*/__webpack_require__.n(ol);

// EXTERNAL MODULE: ./src/components/cgil-vue-olmap/ol-layerswitcher.css
var cgil_vue_olmap_ol_layerswitcher = __webpack_require__("xFzx");
var cgil_vue_olmap_ol_layerswitcher_default = /*#__PURE__*/__webpack_require__.n(cgil_vue_olmap_ol_layerswitcher);

// EXTERNAL MODULE: ./src/components/cgil-vue-olmap/ol-popup.css
var cgil_vue_olmap_ol_popup = __webpack_require__("9Hc+");
var cgil_vue_olmap_ol_popup_default = /*#__PURE__*/__webpack_require__.n(cgil_vue_olmap_ol_popup);

// CONCATENATED MODULE: ./src/components/cgil-vue-olmap/ol-lausanne-map-mn95.js





var getWMTSCapabilitiesFromUrl = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(url) {
    var response, message, WMTSCapabilities;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url);

          case 2:
            response = _context.sent;

            if (response.ok) {
              _context.next = 6;
              break;
            }

            message = '###!### ERROR in getWMTSCapabilitiesFromUrl when doing fetch(' + url + ': http status: ' + response.status;
            throw new Error(message);

          case 6:
            _context.next = 8;
            return response.text();

          case 8:
            WMTSCapabilities = _context.sent;
            return _context.abrupt('return', WMTSCapabilities);

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getWMTSCapabilitiesFromUrl(_x3) {
    return _ref.apply(this, arguments);
  };
}();

// eslint-disable-next-line no-unused-vars
var getConfederateReframeMN03 = function () {
  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(x, y) {
    var url, response, message, data, pointMN03;
    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            ol_lausanne_map_mn95_log.l('## ENTERING getConfederateReframeMN03 x:' + x + ',y:' + y);
            url = getReframeUrl('lv95tolv03', x, y);
            _context2.next = 4;
            return fetch(url, { mode: 'cors' });

          case 4:
            response = _context2.sent;

            if (response.ok) {
              _context2.next = 8;
              break;
            }

            message = '###!### ERROR in getConfederateReframeMN03 when doing fetch(' + url + ': http status: ' + response.status;
            throw new Error(message);

          case 8:
            _context2.next = 10;
            return response.json();

          case 10:
            data = _context2.sent;
            pointMN03 = [parse_float_default()(data.easting, 10), parse_float_default()(data.northing, 10)];

            ol_lausanne_map_mn95_log.l('## after await response.text getConfederateReframeMN03 x,y = ' + pointMN03[0] + ',' + pointMN03[0] + ' data: ', data);
            return _context2.abrupt('return', pointMN03);

          case 14:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getConfederateReframeMN03(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
// eslint-disable-next-line no-unused-vars


var getConfederateReframeMN95 = function () {
  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(x, y) {
    var url, response, message, data, pointMN03;
    return regenerator_default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            ol_lausanne_map_mn95_log.l('## ENTERING getConfederateReframeMN03 x:' + x + ',y:' + y);
            url = getReframeUrl('lv03tolv95', x, y);
            _context3.next = 4;
            return fetch(url, { mode: 'cors' });

          case 4:
            response = _context3.sent;

            if (response.ok) {
              _context3.next = 8;
              break;
            }

            message = '###!### ERROR in getConfederateReframeMN03 when doing fetch(' + url + ': http status: ' + response.status;
            throw new Error(message);

          case 8:
            _context3.next = 10;
            return response.json();

          case 10:
            data = _context3.sent;
            pointMN03 = [parse_float_default()(data.easting, 10), parse_float_default()(data.northing, 10)];

            ol_lausanne_map_mn95_log.l('## after await response.text getConfederateReframeMN03 x,y = ' + pointMN03[0] + ',' + pointMN03[0] + ' data: ', data);
            return _context3.abrupt('return', pointMN03);

          case 14:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getConfederateReframeMN95(_x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

var getWmtsBaseLayers = function () {
  var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(url) {
    var arrWmtsLayers, WMTSCapabilities, WMTSCapabilitiesASIT, WMTSCapabilitiesSWISSTOPO, WMTSCapabilitiesParsed, WMTSCapabilitiesParsedASIT, WMTSCapabilitiesParsedSWISSTOPO, message;
    return regenerator_default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            arrWmtsLayers = [];
            _context4.prev = 1;
            _context4.next = 4;
            return getWMTSCapabilitiesFromUrl(url);

          case 4:
            WMTSCapabilities = _context4.sent;
            _context4.next = 7;
            return getWMTSCapabilitiesFromUrl(urlASITVD);

          case 7:
            WMTSCapabilitiesASIT = _context4.sent;
            _context4.next = 10;
            return getWMTSCapabilitiesFromUrl(urlSWISSTOPO);

          case 10:
            WMTSCapabilitiesSWISSTOPO = _context4.sent;
            WMTSCapabilitiesParsed = parser.read(WMTSCapabilities);

            console.log('## in getWmtsBaseLayers(' + url + ' : WMTSCapabilitiesParsed : \n', WMTSCapabilitiesParsed);
            WMTSCapabilitiesParsedASIT = parser.read(WMTSCapabilitiesASIT);

            console.log('## in getWmtsBaseLayers(' + urlASITVD + ' : WMTSCapabilitiesParsedASIT : \n', WMTSCapabilitiesParsedASIT);
            WMTSCapabilitiesParsedSWISSTOPO = parser.read(WMTSCapabilitiesSWISSTOPO);

            console.log('## in getWmtsBaseLayers(' + urlSWISSTOPO + ' : WMTSCapabilitiesParsed_SWISSTOPO : \n', WMTSCapabilitiesParsedSWISSTOPO);
            arrWmtsLayers.push(createBaseOlLayerTile(WMTSCapabilitiesParsedASIT, 'Fond Cadastral ASIT VD', 'asitvd.fond_cadastral', defaultBaseLayer === 'asitvd.fond_cadastral'));
            arrWmtsLayers.push(createBaseOlLayerTile(WMTSCapabilitiesParsedSWISSTOPO, 'Carte Nationale 1:25\'000 (SWISSTOPO)', 'ch.swisstopo.pixelkarte-farbe-pk25.noscale', defaultBaseLayer === 'ch.swisstopo.pixelkarte-farbe-pk25.noscale'));
            arrWmtsLayers.push(createBaseOlLayerTile(WMTSCapabilitiesParsedSWISSTOPO, 'SwissImage 2020 10cm (SWISSTOPO)', 'ch.swisstopo.swissimage', defaultBaseLayer === 'ch.swisstopo.swissimage'));
            arrWmtsLayers.push(createBaseOlLayerTile(WMTSCapabilitiesParsed, 'Orthophoto 2016 (Lausanne)', 'orthophotos_ortho_lidar_2016', defaultBaseLayer === 'orthophotos_ortho_lidar_2016'));
            arrWmtsLayers.push(createBaseOlLayerTile(WMTSCapabilitiesParsed, 'Fond cadastral (Lausanne)', 'fonds_geo_osm_bdcad_gris', defaultBaseLayer === 'fonds_geo_osm_bdcad_gris'));
            arrWmtsLayers.push(createBaseOlLayerTile(WMTSCapabilitiesParsed, 'Plan ville (Lausanne)', 'fonds_geo_osm_bdcad_couleur', defaultBaseLayer === 'fonds_geo_osm_bdcad_couleur'));
            return _context4.abrupt('return', arrWmtsLayers);

          case 26:
            _context4.prev = 26;
            _context4.t0 = _context4['catch'](1);
            message = '###!### ERROR in getWmtsBaseLayers occured with url:' + url + ': error is: ' + _context4.t0;

            console.warn(message);
            return _context4.abrupt('return', []);

          case 31:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this, [[1, 26]]);
  }));

  return function getWmtsBaseLayers(_x9) {
    return _ref4.apply(this, arguments);
  };
}();































var ol_lausanne_map_mn95_MODULE_NAME = 'ol-lausanne-map-mn95';
var ol_lausanne_map_mn95_log = config_getLog(ol_lausanne_map_mn95_MODULE_NAME, 4, 4);
// const PFP3_314 = [2538008.374, 1151705.117]; // MN03 Y=538'008.790 X=151'704.680
// const PFP3_1322 = [2534664.684, 1152646.677]; // MN03 Y=534'665.120 X=152'646.210
// const PFP3_3823 = [2535025.023, 1152846.991]; // MN03 Y=534'665.120 X=152'646.210

var baseWmsUrl = DEV ? 'https://map.lausanne.ch/mapserv_proxy?' : 'https://map.lausanne.ch/mapserv_proxy?';
var urlASITVD = 'https://ows.asitvd.ch/wmts/1.0.0/WMTSCapabilities.xml';
var urlSWISSTOPO = 'https://wmts.geo.admin.ch/EPSG/2056/1.0.0/WMTSCapabilities.xml?lang=fr';
var urlLausanneMN95 = 'https://tilesmn95.lausanne.ch/tiles/1.0.0/LausanneWMTS.xml';
var defaultBaseLayer = 'fonds_geo_osm_bdcad_couleur';
var MaxExtent = [2532500, 1149000, 2545625, 1161000];
// const MAX_EX  = [532500, 149000, 545625, 161000]; // lidar 2012
var lausanneGare = [2537968.5, 1152088.0];
// const MAX_EXTENT_ASIT_VD = [2420000, 130000, 2900000, 1350000];
proj4_lib["a" /* default */].defs('EPSG:2056', '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs');
proj4_lib["a" /* default */].defs('EPSG:21781', '+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=600000 +y_0=200000 +ellps=bessel +towgs84=674.4,15.1,405.3,0,0,0,0 +units=m +no_defs');

Object(proj4["a" /* register */])(proj4_lib["a" /* default */]);
var ol_lausanne_map_mn95_swissProjection = new Projection["a" /* default */]({
  code: 'EPSG:2056',
  extent: MaxExtent,
  units: 'm'
});
var parser = new format_WMTSCapabilities["a" /* default */]();

var thousandSep = function thousandSep(x) {
  return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '\'');
};
// Conv4326In21781 : convert x,y Point in WGS84 Lon,Lat in MN03 (ancien systeme CH) array [x,y]
var ol_lausanne_map_mn95_Conv4326In21781 = function Conv4326In21781(x, y) {
  var projSource = new proj4_lib["a" /* default */].Proj('EPSG:4326');
  var projDest = new proj4_lib["a" /* default */].Proj('EPSG:21781');
  var Pos = proj4_lib["a" /* default */].transform(projSource, projDest, [x, y]);
  return [Pos.x, Pos.y];
};
// Conv4326In2056 : convert x,y Point in WGS84 Lon,Lat in MN95  array [x,y]
var ol_lausanne_map_mn95_Conv4326In2056 = function Conv4326In2056(x, y) {
  var projSource = new proj4_lib["a" /* default */].Proj('EPSG:4326');
  var projDest = new proj4_lib["a" /* default */].Proj('EPSG:2056');
  var Pos = proj4_lib["a" /* default */].transform(projSource, projDest, [x, y]);
  return [Pos.x, Pos.y];
};
var ol_lausanne_map_mn95_Conv2056In4326 = function Conv2056In4326(x, y) {
  console.log('#in Conv2056In4326(' + x + ', ' + y + ')');
  var projSource = new proj4_lib["a" /* default */].Proj('EPSG:2056');
  var projDest = new proj4_lib["a" /* default */].Proj('EPSG:4326');
  var Pos = proj4_lib["a" /* default */].transform(projSource, projDest, [x, y]);
  return [Pos.x, Pos.y];
};
var ol_lausanne_map_mn95_Conv2056In21781 = function Conv2056In21781(x, y) {
  console.log('#in Conv2056In21781(' + x + ', ' + y + ')');
  var projSource = new proj4_lib["a" /* default */].Proj('EPSG:2056');
  var projDest = new proj4_lib["a" /* default */].Proj('EPSG:21781');
  var Pos = proj4_lib["a" /* default */].transform(projSource, projDest, [x, y]);
  return [Pos.x, Pos.y];
};
var ol_lausanne_map_mn95_Conv21781In2056 = function Conv21781In2056(x, y) {
  console.log('#in Conv21781In2056(' + x + ', ' + y + ')');
  var xNumber = parse_int_default()(x, 10);
  var yNumber = parse_int_default()(y, 10);
  console.log('#in Conv21781In2056 Real number(' + xNumber + ', ' + yNumber + ')');
  var projSource = new proj4_lib["a" /* default */].Proj('EPSG:21781');
  var projDest = new proj4_lib["a" /* default */].Proj('EPSG:2056');
  var Pos = proj4_lib["a" /* default */].transform(projSource, projDest, [xNumber, yNumber]);
  return [Pos.x, Pos.y];
};
var ol_lausanne_map_mn95_Conv21781In4326 = function Conv21781In4326(x, y) {
  var projSource = new proj4_lib["a" /* default */].Proj('EPSG:21781');
  var projDest = new proj4_lib["a" /* default */].Proj('EPSG:4326');
  var Pos = proj4_lib["a" /* default */].transform(projSource, projDest, [x, y]);
  return [Pos.x, Pos.y];
};

var isItMN03 = function isItMN03(point) {
  ol_lausanne_map_mn95_log.t('point x,y : ' + point[0] + ',' + point[1]);
  var minX = 2479000.0;
  var minY = 1070000.0;
  if (point[0] < minX) return true;
  if (point[1] < minY) return true;
  return false;
};

var ol_lausanne_map_mn95_dumpLayersInfo = function dumpLayersInfo(olMap) {
  ol_lausanne_map_mn95_log.t('## ENTERING dumpLayersInfo olMap:', olMap);
  var arrLayers = [];
  olMap.getLayers().forEach(function (layer) {
    var type = Object(cgHtmlUtils_min["isNullOrUndefined"])(layer.get('type')) ? layer.type : layer.get('type');
    // const source = layer.getSource();
    // WARNING BIG DANGER: DOES NOT EXIST AFTER A BUILD
    // const sourceType = source.constructor.name;
    var title = layer.get('title');
    var infoLayer = '[' + type + '] title: ' + title + ' isvisible: ' + layer.get('visible');
    arrLayers.push(infoLayer);
  });
  arrLayers.reverse();
  ol_lausanne_map_mn95_log.t('## dumpLayersInfo:arrLayers : ', arrLayers.join('\n'));
  return arrLayers;
};

var ol_lausanne_map_mn95_getWMSVisibleLayersArray = function getWMSVisibleLayersArray(olMap) {
  ol_lausanne_map_mn95_log.t('## ENTERING getWMSVisibleLayersArray olMap:', olMap);
  var localDebug = false;
  var arrWMSVisibleLayers = [];
  olMap.getLayers().forEach(function (layer) {
    var type = Object(cgHtmlUtils_min["isNullOrUndefined"])(layer.get('type')) ? layer.type : layer.get('type');
    var source = layer.getSource();
    // WARNING BIG DANGER: DOES NOT EXIST AFTER A BUILD
    // const sourceType = source.constructor.name;
    var title = layer.get('title');
    if (type === 'wms' && !Object(cgHtmlUtils_min["isNullOrUndefined"])(title)) {
      arrWMSVisibleLayers.push(layer.getVisible());
      if (localDebug) {
        ol_lausanne_map_mn95_log.w('[' + source.constructor.name + '] title: ' + layer.get('title') + ' isvisible: ' + layer.get('visible'), layer, source);
      }
    }
  });
  arrWMSVisibleLayers.reverse();
  ol_lausanne_map_mn95_log.t('## getWMSVisibleLayersArray:arrWMSVisibleLayers : ', arrWMSVisibleLayers);
  return arrWMSVisibleLayers;
};

function getCoordinatesInfo(x, y) {
  var pos4326 = ol_lausanne_map_mn95_Conv2056In4326(x, y);
  var pos21781 = ol_lausanne_map_mn95_Conv2056In21781(x, y);
  var info = 'MN95 \t: [' + thousandSep(x.toFixed(2)) + ', ' + thousandSep(y.toFixed(2)) + '],\n';
  info += 'MN03 \t: [' + pos21781[0].toFixed(2) + ', ' + pos21781[1].toFixed(2) + '],\n';
  info += 'WGS84\t: [' + pos4326[0].toFixed(5) + ', ' + pos4326[1].toFixed(5) + ']';
  return info;
}

function getCoordinatesPoint(x, y) {
  var pos4326 = ol_lausanne_map_mn95_Conv2056In4326(x, y);
  var pos21781 = ol_lausanne_map_mn95_Conv2056In21781(x, y);
  var info = {
    x: +x.toFixed(2),
    y: +y.toFixed(2),
    mn03_x: +pos21781[0].toFixed(2),
    mn03_y: +pos21781[1].toFixed(2),
    wgs84_lon: +pos4326[0].toFixed(5),
    wgs84_lat: +pos4326[1].toFixed(5)
  };
  return info;
}

function getCoordinatesInfoHtml(x, y, lvisibles) {
  var baseLayer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultBaseLayer;

  var pos4326 = ol_lausanne_map_mn95_Conv2056In4326(x, y);
  var pos21781 = ol_lausanne_map_mn95_Conv2056In21781(x, y);
  var urlCenter = '?x=' + x.toFixed(2) + '&y=' + y.toFixed(2) + '&zoom=7&lvisibles=' + lvisibles + '&baselayer=' + baseLayer;
  // @46.5378031,6.6381231,110m/data=!3m1!1e3
  var urlGoogle = 'https://www.google.ch/maps/@' + pos4326[1] + ',' + pos4326[0] + ',110m/data=!3m1!1e3';
  var info = '<table><tbody><tr><td style="width: 9rem">';
  info += '<a target="_blank" href="https://www.swisstopo.admin.ch/fr/connaissances-faits/mensuration-geodesie/cadres-de-reference/local/mn95.html">CH1903+/LV95</a>&nbsp;:';
  info += '</td><td>';
  info += '<a title="recentrer ici" href="' + urlCenter + '">';
  info += thousandSep(x.toFixed(2)) + ', ' + thousandSep(y.toFixed(2)) + '</a>\n';
  info += '</td></tr><tr><td>';
  info += '<a target="_blank" href="https://www.swisstopo.admin.ch/fr/connaissances-faits/mensuration-geodesie/cadres-de-reference/local/mn03.html">CH1903/LV03</a>&nbsp;:';
  info += '</td><td>';
  info += pos21781[0].toFixed(2) + ', ' + pos21781[1].toFixed(2) + '\n';
  info += '</td></tr><tr><td>';
  info += '<a target="_blank" href="https://en.wikipedia.org/wiki/World_Geodetic_System">WGS84&nbsp;(lat,lon)</a>&nbsp;:';
  info += '</td><td>';
  info += '<a target="google" title="google maps" href="' + urlGoogle + '">' + pos4326[1].toFixed(6) + ',&nbsp;' + pos4326[0].toFixed(6) + '</a>';
  info += '</td></tr></tbody></table>';
  return info;
}

var ol_lausanne_map_mn95_getPolygonStyle = function getPolygonStyle(feature, resolution) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    fill_color: 'rgba(255, 0, 0, 0.8)',
    stroke_color: '#191aff',
    stroke_width: 3
  };

  var localDebug = false;
  if (localDebug) ol_lausanne_map_mn95_log.t('## Entering getPolygonStyle with feature :', feature);
  if (localDebug) ol_lausanne_map_mn95_log.l('resolution : ' + resolution);

  var props = null;
  var theStyle = null;
  if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(feature) && !Object(cgHtmlUtils_min["isNullOrUndefined"])(feature.getProperties())) {
    props = feature.getProperties();
    var id = Object(cgHtmlUtils_min["isNullOrUndefined"])(props.id) ? '#INCONNU#' : props.id;
    if (localDebug) ol_lausanne_map_mn95_log.l('id : ' + id);
    theStyle = new Style["c" /* default */]({
      fill: new Fill["a" /* default */]({
        color: Object(cgHtmlUtils_min["isNullOrUndefined"])(props.fill_color) ? options.fill_color : props.fill_color
      }),
      stroke: new Stroke["a" /* default */]({
        color: Object(cgHtmlUtils_min["isNullOrUndefined"])(props.stroke_color) ? options.stroke_color : props.stroke_color,
        width: Object(cgHtmlUtils_min["isNullOrUndefined"])(props.stroke_width) ? options.stroke_width : props.stroke_width
      }),
      image: new Circle["a" /* default */]({
        radius: Object(cgHtmlUtils_min["isNullOrUndefined"])(props.stroke_width) ? options.stroke_width : props.stroke_width,
        fill: new Fill["a" /* default */]({
          color: Object(cgHtmlUtils_min["isNullOrUndefined"])(props.fill_color) ? options.fill_color : props.fill_color
        })
      })
    });
  } else {
    theStyle = new Style["c" /* default */]({
      fill: new Fill["a" /* default */]({
        color: options.fill_color // 'rgba(255, 0, 0, 0.8)',
      }),
      stroke: new Stroke["a" /* default */]({
        color: options.stroke_color, // '#191aff',
        width: options.stroke_width
      }),
      image: new Circle["a" /* default */]({
        radius: 9,
        fill: new Fill["a" /* default */]({
          color: '#ffcc33'
        })
      })
    });
  }
  return theStyle;
};

var ol_lausanne_map_mn95_setBaseLayer = function setBaseLayer(olMap, baseLayerName) {
  ol_lausanne_map_mn95_log.t('setBaseLayer(' + baseLayerName + ')');
  var localDebug = false;
  var isBaseLayerNameFound = false;
  olMap.getLayers().forEach(function (layer) {
    var type = Object(cgHtmlUtils_min["isNullOrUndefined"])(layer.get('type')) ? layer.type : layer.get('type');
    var source = layer.getSource();
    if (type === 'base') {
      var currentBaseLayer = source.getLayer();
      if (currentBaseLayer === baseLayerName) {
        layer.setVisible(true);
        isBaseLayerNameFound = true;
      } else {
        layer.setVisible(false);
      }
      if (localDebug) {
        ol_lausanne_map_mn95_log.w('layers : ' + currentBaseLayer + ' [' + type + ']\n                 title : ' + layer.get('title') + '\n                 isvisible: ' + layer.get('visible'), layer, source);
      }
    }
  });
  if (!isBaseLayerNameFound) {
    ol_lausanne_map_mn95_log.w('WARNING : The layer ' + baseLayerName + ' was not found ! SETTING DEFAULT ' + defaultBaseLayer + ' TO VISIBLE ');
    setBaseLayer(olMap, defaultBaseLayer);
  }
};

var ol_lausanne_map_mn95_GotoExtent = function GotoExtent(olMap, arrExtent) {
  var localDebug = true;
  if (localDebug) ol_lausanne_map_mn95_log.t('# gotoExtent', arrExtent);
  if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(arrExtent)) {
    if (localDebug) {
      ol_lausanne_map_mn95_log.t('# gotoExtent MIN(x,y) = (' + arrExtent[0] + ',' + arrExtent[1] + ')\n        Max(x,y) = (' + arrExtent[2] + ',' + arrExtent[3] + ')');
    }
    // just in case ...
    var extent = [parse_int_default()(arrExtent[0], 10), parse_int_default()(arrExtent[1], 10), parse_int_default()(arrExtent[2], 10), parse_int_default()(arrExtent[3], 10)];
    if (localDebug) ol_lausanne_map_mn95_log.t('# gotoExtent', extent);
    olMap.getView().fit(extent, olMap.getSize());
  }
};

function getReframeUrl(paramreframe, x, y) {
  var xNumber = parse_float_default()(x);
  var yNumber = parse_float_default()(y);
  return 'https://geodesy.geo.admin.ch/reframe/' + paramreframe + '?easting=' + xNumber + '&northing=' + yNumber + '&format=json';
}

function getWmtsSource(WMTSCapabilitiesParsed, layerName) {
  var localDebug = false;
  if (localDebug) ol_lausanne_map_mn95_log.t('layerName: ' + layerName);
  var WMTSOptions = Object(WMTS["b" /* optionsFromCapabilities */])(WMTSCapabilitiesParsed, {
    layer: layerName,
    matrixSet: 'EPSG2056',
    format: 'image/png',
    style: 'default',
    crossOrigin: 'anonymous'
  });
  return new WMTS["a" /* default */](WMTSOptions);
}

function createBaseOlLayerTile(parsedWmtsCapabilities, title, layerName) {
  var visible = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  return new Tile["a" /* default */]({
    title: title,
    type: 'base',
    visible: visible,
    source: getWmtsSource(parsedWmtsCapabilities, layerName)
  });
}

var ol_lausanne_map_mn95_createNewWMSLayer = function createNewWMSLayer(layerName, layerTitle, isVisible) {
  var serverUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : baseWmsUrl;

  if (Object(cgHtmlUtils_min["isNullOrUndefined"])(layerName) || Object(cgHtmlUtils_min["isNullOrUndefined"])(layerTitle)) {
    ol_lausanne_map_mn95_log.e('## ERROR in createNewWMSLayer the parameters layerName, layerTitle should not be null or undefined !\n    layerName = ' + layerName + ' and layerTitle =' + layerTitle);
    return null;
  }
  var tmpLayer = new Image["a" /* default */]({
    title: layerTitle,
    type: 'wms',
    visible: isVisible,
    source: new ImageWMS["a" /* default */]({
      crossOrigin: 'anonymous',
      params: { LAYERS: layerName, ogcserver: 'source for image/png' },
      serverType: 'mapserver',
      url: serverUrl
    })
  });
  // log.t(`## IN createNewWMSLayer(${layerName})`, tmpLayer);
  return tmpLayer;
};

var ol_lausanne_map_mn95_createIconStyleCenterCenter = function createIconStyleCenterCenter(imagePath) {
  return new Style["c" /* default */]({
    image: new Icon["a" /* default */]({ // http://openlayers.org/en/latest/apidoc/ol.style.Icon.html
      src: imagePath,
      opacity: 1.0,
      anchor: [0.5, 0.5] // we want the marker to be centered
    })
  });
};

var getLayerByName = function getLayerByName(olMap, layerName) {
  var layerFound = [];
  olMap.getLayers().forEach(function (layer) {
    if (layer.get('name') !== undefined && layer.get('name') === layerName) {
      layerFound.push(layer);
    }
  });
  if (layerFound.length > 0) {
    return layerFound[0];
  }
  return null;
};

var ol_lausanne_map_mn95_getVectorSourceGeoJson = function getVectorSourceGeoJson(geoJsonData) {
  ol_lausanne_map_mn95_log.t('## in getVectorSourceGeoJson ');
  return new source_Vector["a" /* default */]({
    format: new GeoJSON["a" /* default */]({
      defaultDataProjection: 'EPSG:2056',
      projection: 'EPSG:2056'
    }),
    features: new GeoJSON["a" /* default */]().readFeatures(geoJsonData)
  });
};

var ol_lausanne_map_mn95_loadWMSLayers = function loadWMSLayers(olMap, layersconfig) {
  ol_lausanne_map_mn95_log.t('## ENTERING loadWMSLayers layersconfig:', layersconfig);
  if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(layersconfig.wmsLayers)) {
    var numLayers = layersconfig.wmsLayers.length;
    ol_lausanne_map_mn95_log.l('Found ' + numLayers + ' wms layers to load ');
    for (var i = numLayers - 1; i > -1; i -= 1) {
      var wmslayer = layersconfig.wmsLayers[i];
      olMap.addLayer(ol_lausanne_map_mn95_createNewWMSLayer(wmslayer.layers, wmslayer.title, wmslayer.isVisible));
    }
  }
};

var createLausanneMap = function () {
  var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6(divOfMap) {
    var centerOfMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : lausanneGare;
    var zoomLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
    var iddiv = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var mapExtent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var displayPointInfo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    var _this = this;

    var layersconfig = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    var callbackClick = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    var realCenter, arrBaseLayers, map, layerCenterPoint, layerSwitcher, popup, minPoint, maxPoint, realmapExtent, newPlace, lausanneBaseLayer, layerForQuery, visibleWMSLayers, lvisibles, divToc;
    return regenerator_default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            ol_lausanne_map_mn95_log.t('createLausanneMap(x,y: [' + centerOfMap[0] + ',' + centerOfMap[1] + ']  zoom:' + zoomLevel + ')', mapExtent, layersconfig);
            realCenter = centerOfMap;

            if (isItMN03(centerOfMap)) {
              realCenter = ol_lausanne_map_mn95_Conv21781In2056(centerOfMap[0], centerOfMap[1]);
              ol_lausanne_map_mn95_log.w('POINT WAS GIVEN  IN MN03 so converrted in MN95: realCenter : (' + realCenter[0] + ',' + realCenter[1] + ')');
              // realCenter = await getConfederateReframeMN95(centerOfMap[0], centerOfMap[1]);
              // const posMN95 = await getConfederateReframeMN03(2537911.454, 1152755.107);
              // log.w(`CONVERSION MN03-MN95 : 2537911.454,1152755.107 -> : (${posMN95[0]},${posMN95[1]})`);
            }
            _context6.next = 5;
            return getWmtsBaseLayers(urlLausanneMN95);

          case 5:
            arrBaseLayers = _context6.sent;

            if (!(arrBaseLayers === null || arrBaseLayers.length < 1)) {
              _context6.next = 9;
              break;
            }

            ol_lausanne_map_mn95_log.w('arrBaseLayers cannot be null or empty to be able to see a nice map !');
            return _context6.abrupt('return', null);

          case 9:
            map = new Map["a" /* default */]({
              target: divOfMap,
              layers: arrBaseLayers,
              view: new View["a" /* default */]({
                projection: ol_lausanne_map_mn95_swissProjection,
                center: realCenter,
                zoom: zoomLevel
              })
            });
            layerCenterPoint = new Vector["a" /* default */]({
              type: 'center',
              source: new source_Vector["a" /* default */]({
                features: []
              })
            });
            layerSwitcher = new ol_layerswitcher_default.a({
              tipLabel: 'Légende', // Optional label for button
              groupSelectStyle: 'children' // Can be 'children' [default], 'group' or 'none'
            });

            map.addControl(layerSwitcher);
            popup = new ol_popup_default.a();

            map.addOverlay(popup);
            if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(mapExtent)) {
              if (isItMN03([mapExtent[0], mapExtent[1]])) {
                minPoint = ol_lausanne_map_mn95_Conv21781In2056(mapExtent[0], mapExtent[1]);
                maxPoint = ol_lausanne_map_mn95_Conv21781In2056(mapExtent[2], mapExtent[3]);
                realmapExtent = [minPoint[0], minPoint[1], maxPoint[0], maxPoint[1]];

                ol_lausanne_map_mn95_GotoExtent(map, realmapExtent);
              } else {
                ol_lausanne_map_mn95_GotoExtent(map, mapExtent);
              }
            } else {
              ol_lausanne_map_mn95_log.l('-->CenterPoint choosed : realCenter(' + realCenter[0] + ',' + realCenter[1] + ')');
              layerCenterPoint.getSource().clear();
              newPlace = new Feature["a" /* default */](new geom_Point["a" /* default */](realCenter));

              newPlace.setStyle(ol_lausanne_map_mn95_createIconStyleCenterCenter(BASE_PATH + 'clic_point.png'));
              layerCenterPoint.getSource().addFeature(newPlace);
            }
            lausanneBaseLayer = defaultBaseLayer;
            layerForQuery = 'bdcad_bf_parc_pol,bdcad_bf_parc_pol_dp,bdcad_bf_parc_pol_ddp,bdcad_cs_bati_pol,bdcad_cs_bati_pol_sout';

            if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(layersconfig)) {
              layerForQuery = ol_lausanne_map_mn95_createNewWMSLayer(layersconfig.layerForQueryInit, 'Query', false);
              if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(layersconfig.baseLayer)) {
                lausanneBaseLayer = layersconfig.baseLayer;
              }
              ol_lausanne_map_mn95_setBaseLayer(map, lausanneBaseLayer);
              ol_lausanne_map_mn95_loadWMSLayers(map, layersconfig);
            }
            map.VDL_layerForQuery = layerForQuery;
            map.addLayer(layerCenterPoint);
            ol_lausanne_map_mn95_dumpLayersInfo(map);
            visibleWMSLayers = ol_lausanne_map_mn95_getWMSVisibleLayersArray(map);
            lvisibles = arrBoolToHex(visibleWMSLayers);
            // MAP EVENTS

            map.on('click', function () {
              var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(evt) {
                var x, y, pos2056, info, posMn03, newPlace, pointCoordInfo, infoHTML;
                return regenerator_default.a.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        x = Number(evt.coordinate[0]);
                        y = Number(evt.coordinate[1]);
                        pos2056 = [x, y];
                        info = getCoordinatesInfo(x, y);
                        // const posMn03 = await getConfederateReframeMN03(x, y);

                        posMn03 = ol_lausanne_map_mn95_Conv2056In21781(x, y);

                        ol_lausanne_map_mn95_log.l('#in olmap.click at x,y : [' + x.toFixed(2) + ', ' + y.toFixed(2) + ']\n' + info, posMn03);
                        layerCenterPoint.getSource().clear();
                        newPlace = new Feature["a" /* default */](new geom_Point["a" /* default */](pos2056));

                        newPlace.setStyle(ol_lausanne_map_mn95_createIconStyleCenterCenter('clic_point.png'));
                        layerCenterPoint.getSource().addFeature(newPlace);
                        pointCoordInfo = getCoordinatesPoint(x, y);
                        // on recupere les infos plus precises de reframe de la confed
                        // eslint-disable-next-line prefer-destructuring

                        pointCoordInfo.mn03_x = posMn03[0];
                        // eslint-disable-next-line prefer-destructuring
                        pointCoordInfo.mn03_y = posMn03[1];
                        if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(callbackClick)) {
                          if (Object(cgHtmlUtils_min["functionExist"])(callbackClick)) {
                            callbackClick(pointCoordInfo);
                          }
                        }
                        if (displayPointInfo) {
                          infoHTML = getCoordinatesInfoHtml(x, y, lvisibles, lausanneBaseLayer);

                          popup.show(pos2056, '<div id=\'map-popup\'><h4>Coordonn\xE9es:</h4>' + infoHTML + '</div>');
                        }

                      case 15:
                      case 'end':
                        return _context5.stop();
                    }
                  }
                }, _callee5, _this);
              }));

              return function (_x19) {
                return _ref6.apply(this, arguments);
              };
            }());

            if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(iddiv)) {
              ol_lausanne_map_mn95_log.l('iddiv : ', iddiv);
              divToc = Object(cgHtmlUtils_min["getEl"])(iddiv);

              ol_lausanne_map_mn95_log.l('divToc : ', divToc, map);
              ol_layerswitcher_default.a.renderPanel(map, divToc);
            }
            // on ajoute la ref a layerswitcher a l'objet olMap['myref2LayerSwitcher'] pour usage ultérieur
            map.myref2LayerSwitcher = layerSwitcher;

            return _context6.abrupt('return', map);

          case 28:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function createLausanneMap(_x11) {
    return _ref5.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ./src/components/cgil-vue-olmap/communesBBLidar2012.js
var communesBBLidar2012_data = [{
  'ofs': 0,
  'label': '_ Toutes les communes _'
}, {
  'ofs': 5621,
  'label': 'Aclens'
}, {
  'ofs': 5421,
  'label': 'Apples'
}, {
  'ofs': 5511,
  'label': 'Assens'
}, {
  'ofs': 5581,
  'label': 'Belmont-sur-Lausanne'
}, {
  'ofs': 5471,
  'label': 'Bettens'
}, {
  'ofs': 5513,
  'label': 'Bioley-Orjulaz'
}, {
  'ofs': 5514,
  'label': 'Bottens'
}, {
  'ofs': 5613,
  'label': 'Bourg-en-Lavaux'
}, {
  'ofs': 5472,
  'label': 'Bournens'
}, {
  'ofs': 5473,
  'label': 'Boussens'
}, {
  'ofs': 5622,
  'label': 'Bremblens'
}, {
  'ofs': 5515,
  'label': 'Bretigny-sur-Morrens'
}, {
  'ofs': 5624,
  'label': 'Bussigny'
}, {
  'ofs': 5625,
  'label': 'Bussy-Chardonney'
}, {
  'ofs': 5882,
  'label': 'Chardonne'
}, {
  'ofs': 5475,
  'label': 'Chavannes-le-Veyron'
}, {
  'ofs': 5627,
  'label': 'Chavannes-près-Renens'
}, {
  'ofs': 5582,
  'label': 'Cheseaux-sur-Lausanne'
}, {
  'ofs': 5476,
  'label': 'Chevilly'
}, {
  'ofs': 5601,
  'label': 'Chexbres'
}, {
  'ofs': 5628,
  'label': 'Chigny'
}, {
  'ofs': 5629,
  'label': 'Clarmont'
}, {
  'ofs': 5785,
  'label': 'Corcelles-le-Jorat'
}, {
  'ofs': 5883,
  'label': 'Corseaux'
}, {
  'ofs': 5884,
  'label': 'Corsier-sur-Vevey'
}, {
  'ofs': 5477,
  'label': 'Cossonay'
}, {
  'ofs': 5478,
  'label': 'Cottens (Vaud)'
}, {
  'ofs': 5583,
  'label': 'Crissier'
}, {
  'ofs': 5479,
  'label': 'Cuarnens'
}, {
  'ofs': 5516,
  'label': 'Cugy (Vaud)'
}, {
  'ofs': 5480,
  'label': 'Daillens'
}, {
  'ofs': 5631,
  'label': 'Denens'
}, {
  'ofs': 5632,
  'label': 'Denges'
}, {
  'ofs': 5481,
  'label': 'Dizy'
}, {
  'ofs': 5518,
  'label': 'Echallens'
}, {
  'ofs': 5633,
  'label': 'Echandens'
}, {
  'ofs': 5634,
  'label': 'Echichens'
}, {
  'ofs': 5635,
  'label': 'Ecublens (Vaud)'
}, {
  'ofs': 5584,
  'label': 'Epalinges'
}, {
  'ofs': 5788,
  'label': 'Essertes'
}, {
  'ofs': 5521,
  'label': 'Etagnières'
}, {
  'ofs': 5604,
  'label': 'Forel (Lavaux)'
}, {
  'ofs': 5523,
  'label': 'Froideville'
}, {
  'ofs': 5484,
  'label': 'Gollion'
}, {
  'ofs': 5485,
  'label': 'Grancy'
}, {
  'ofs': 5673,
  'label': 'Hermenches'
}, {
  'ofs': 5885,
  'label': 'Jongny'
}, {
  'ofs': 5804,
  'label': 'Jorat-Menthue'
}, {
  'ofs': 5806,
  'label': 'Jorat-Mézières'
}, {
  'ofs': 5585,
  'label': 'Jouxtens-Mézery'
}, {
  'ofs': 5474,
  'label': 'La Chaux (Cossonay)'
}, {
  'ofs': 5498,
  'label': 'La Sarraz'
}, {
  'ofs': 5586,
  'label': 'Lausanne'
}, {
  'ofs': 5587,
  'label': 'Le Mont-sur-Lausanne'
}, {
  'ofs': 5638,
  'label': 'Lonay'
}, {
  'ofs': 5639,
  'label': 'Lully (Vaud)'
}, {
  'ofs': 5487,
  'label': 'Lussery-Villars'
}, {
  'ofs': 5640,
  'label': 'Lussy-sur-Morges'
}, {
  'ofs': 5606,
  'label': 'Lutry'
}, {
  'ofs': 5790,
  'label': 'Maracon'
}, {
  'ofs': 5489,
  'label': 'Mex (Vaud)'
}, {
  'ofs': 5490,
  'label': 'Moiry'
}, {
  'ofs': 5540,
  'label': 'Montilliez'
}, {
  'ofs': 5792,
  'label': 'Montpreveyres'
}, {
  'ofs': 5642,
  'label': 'Morges'
}, {
  'ofs': 5527,
  'label': 'Morrens (Vaud)'
}, {
  'ofs': 5805,
  'label': 'Oron'
}, {
  'ofs': 5529,
  'label': 'Oulens-sous-Echallens'
}, {
  'ofs': 5494,
  'label': 'Pampigny'
}, {
  'ofs': 5588,
  'label': 'Paudex'
}, {
  'ofs': 5495,
  'label': 'Penthalaz'
}, {
  'ofs': 5496,
  'label': 'Penthaz'
}, {
  'ofs': 5533,
  'label': 'Poliez-Pittet'
}, {
  'ofs': 5589,
  'label': 'Prilly'
}, {
  'ofs': 5643,
  'label': 'Préverenges'
}, {
  'ofs': 5607,
  'label': 'Puidoux'
}, {
  'ofs': 5590,
  'label': 'Pully'
}, {
  'ofs': 5591,
  'label': 'Renens (Vaud)'
}, {
  'ofs': 5644,
  'label': 'Reverolle'
}, {
  'ofs': 5609,
  'label': 'Rivaz'
}, {
  'ofs': 5592,
  'label': 'Romanel-sur-Lausanne'
}, {
  'ofs': 5645,
  'label': 'Romanel-sur-Morges'
}, {
  'ofs': 5798,
  'label': 'Ropraz'
}, {
  'ofs': 5535,
  'label': 'Saint-Barthélemy (Vaud)'
}, {
  'ofs': 5888,
  'label': 'Saint-Légier-La Chiésaz'
}, {
  'ofs': 5646,
  'label': 'Saint-Prex'
}, {
  'ofs': 5610,
  'label': 'Saint-Saphorin (Lavaux)'
}, {
  'ofs': 5648,
  'label': 'Saint-Sulpice (Vaud)'
}, {
  'ofs': 5611,
  'label': 'Savigny'
}, {
  'ofs': 5499,
  'label': 'Senarclens'
}, {
  'ofs': 5799,
  'label': 'Servion'
}, {
  'ofs': 5501,
  'label': 'Sullens'
}, {
  'ofs': 5688,
  'label': 'Syens'
}, {
  'ofs': 5500,
  'label': 'Sévery'
}, {
  'ofs': 5649,
  'label': 'Tolochenaz'
}, {
  'ofs': 5650,
  'label': 'Vaux-sur-Morges'
}, {
  'ofs': 5890,
  'label': 'Vevey'
}, {
  'ofs': 5651,
  'label': 'Villars-Sainte-Croix'
}, {
  'ofs': 5692,
  'label': 'Vucherens'
}, {
  'ofs': 5503,
  'label': 'Vufflens-la-Ville'
}, {
  'ofs': 5653,
  'label': 'Vufflens-le-Château'
}, {
  'ofs': 5803,
  'label': 'Vulliens'
}, {
  'ofs': 5654,
  'label': 'Vullierens'
}];
/* harmony default export */ var communesBBLidar2012 = (communesBBLidar2012_data);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cgil-vue-olmap/cgil-vue-olmap.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */













// this.$Vue.components(Container.name, Container)

var positionGareLausanne = [537892.8, 152095.7];
var SMALL_SCREEN_WIDTH = 638; // smaller then the xs at <768 but at purpose !
var MEDIUM_SCREEN_WIDTH = 992;
var MIN_HEIGHT = 600;
var TOOLBARHEIGHT = 34;
var cgil_vue_olmap_MODULE_NAME = 'cgilVueOlMap';
var cgil_vue_olmap_log = config_DEV ? new cgLog_min_default.a(cgil_vue_olmap_MODULE_NAME, 4) : new cgLog_min_default.a(cgil_vue_olmap_MODULE_NAME, 5);

/* harmony default export */ var cgil_vue_olmap = ({
  name: 'vue2MapOlSwiss2056',
  components: { cgVueAutoComplete: components_cgil_vue_olmap_cgil_vue_autocomplete_element_ui },
  data: function data() {
    return {
      DEV: config_DEV,
      toolbarHeight: TOOLBARHEIGHT + 'px',
      mapHeight: MIN_HEIGHT + 'px',
      isSmallScreen: false,
      showConfig: false,
      sizeOfControl: 'small',
      uiMode: 'NAVIGATE',
      ol_interaction_draw: null,
      ol_map: null,
      maxFeatureIdCounter: 0, // to give an id to polygon features
      ol_newFeatures: null, // ol collection of features used as vector source for CREATE mode
      ol_newFeaturesLayer: null, // Vector Layer for storing new features
      ol_GeoJsonFeaturesLayer: null, // Vector Layer for storing external GeoJson
      ol_Overlay: null, // Overlay to display tooltip
      ol_Active_Interactions: [],
      activeLayer: 'fonds_geo_osm_bdcad_couleur',
      addressFound: null, // selected address to search
      currentOfsFilter: 0,
      arrListCities: [],
      geoAdrUrl: config_BASE_REST_API_URL + 'adresses/search_position?ofs=' + this.ofsFilter, // backend to find address
      modeOptions: [{
        value: 'NAVIGATE',
        label: 'Naviguer'
      }, {
        value: 'CREATE',
        label: 'Créer'
      }, {
        value: 'EDIT',
        label: 'Editer'
      }, {
        value: 'TRANSLATE',
        label: 'Déplacer'
      }, {
        value: 'DELETE',
        label: 'Supprimer'
      }],
      layerOptions: [{
        value: 'fonds_geo_osm_bdcad_couleur',
        label: 'Plan ville couleur'
      }, {
        value: 'fonds_geo_osm_bdcad_gris',
        label: 'Plan cadastral (gris)'
      }, {
        value: 'orthophotos_ortho_lidar_2016',
        label: 'Orthophotos 2016'
      }, {
        value: 'orthophotos_ortho_lidar_2012',
        label: 'Orthophotos 2012'
      }]
    };
  },

  props: {
    zoom: {
      type: Number,
      default: 13
    },
    center: {
      type: Array,
      default: function _default() {
        return positionGareLausanne;
      }
    },
    baselayer: {
      type: String,
      default: 'fonds_geo_osm_bdcad_couleur'
    },
    useInternalWmts: { // will use lausanne internal 'https://tiles01.lausanne.ch/tiles' instead of public one
      type: Boolean,
      default: false
    },
    editGeomEnabled: { // goign from true to false will triger a call to clearNewFeatures to reset mode to navigate and clear current editing
      type: Boolean,
      default: false
    },
    searchEnabled: {
      type: Boolean,
      default: false
    },
    geomWkt: { // this geometry in WKT format wil be editable
      type: String,
      default: null
    },
    geomGeoJSON: { // this geometry in geomJSON format wil be editable
      type: Object,
      default: null
    },
    geojsonurl: { // this one allows to add an url to get remote geojson layer , stored in ol_vector_layer_geojsonurl
      type: String,
      default: ''
    },
    ofsFilter: {
      type: Number,
      default: 0 // 0 to allow search address on all cities in city area, 5586 use lausanne only,
    },
    geojsondata: { //read only layer for geojson vector data display on the map, stored in ol_vector_layer_geojsondata
      type: Object,
      default: null
    }
  },
  watch: {
    geomWkt: function geomWkt() {
      // TODO : here is a good place to see if change is really a different geometry from previous
      this._updateGeometry();
    },
    geomGeoJSON: function geomGeoJSON() {
      this._updateGeometry();
    },
    geojsondata: function geojsondata(newValue, oldValue) {
      cgil_vue_olmap_log.t('## in geojsondata watch old: ' + oldValue + ', new: ' + newValue);
    },
    editGeomEnabled: function editGeomEnabled(newValue, oldValue) {
      cgil_vue_olmap_log.t('## in editGeomEnabled watch old: ' + oldValue + ', new: ' + newValue);
      if (newValue === false && oldValue === true) this.clearNewFeatures();
    }
  },
  computed: {
    getNumPolygons: function getNumPolygons() {
      return getNumberFeaturesInLayer(this.ol_newFeaturesLayer);
    }
  },
  updated: function updated() {
    cgil_vue_olmap_log.t('## in updated $nextTick');
    this.$nextTick(function () {
      this.updateScreen();
      // Code that will run only after the
      // entire view has been re-rendered
    });
  },
  methods: {
    runFunction: function runFunction(name) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var fn = this[name];
      if (typeof fn !== 'function') return;
      fn.apply(this, params);
    },

    editDisabled: function editDisabled(mode) {
      if (mode == 'NAVIGATE' || mode == 'CREATE') {
        return false;
      } else {
        var isEditDisabled = this.getNumPolygons < 1;
        // log.t(`## in editDisabled computed is EditValid: ${isEditDisabled}`)
        return isEditDisabled;
      }
    },
    _updateGeometry: function _updateGeometry() {
      cgil_vue_olmap_log.t('# in _updateGeometry geomWkt : ' + this.geomWkt + '\n geomGeoJSON: ' + this.geomGeoJSON);
      if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(this.geomWkt) && this.geomWkt.length > 5) {
        cgil_vue_olmap_log.t('# in _updateGeometry for geomWkt', this.geomWkt);
        // TODO check for identical features and do not add them twice or clear layer before ?
        var numFeaturesAdded = addWktPolygonToLayer(this.ol_newFeaturesLayer, this.geomWkt, this.maxFeatureIdCounter);
        if (Object(cgHtmlUtils_min["isNullOrUndefined"])(numFeaturesAdded)) {
          cgil_vue_olmap_log.w('# ERROR tying to add this invalid Geom from geomWkt : ' + this.geomWkt, this.geomWkt);
        } else {
          cgil_vue_olmap_log.l('Successfully added this geomWkt to layer now layer has ' + numFeaturesAdded + ' features !');
          this.maxFeatureIdCounter += numFeaturesAdded;
        }
      }
      if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(this.geomGeoJSON)) {
        // TODO check for identical features and do not add them twice or clear layer before ?
        cgil_vue_olmap_log.t('# in _updateGeometry for geomGeoJSON', this.geomGeoJSON);
        var _numFeaturesAdded = addGeoJsonPolygonToLayer(this.ol_newFeaturesLayer, this.geomGeoJSON, this.maxFeatureIdCounter);
        if (Object(cgHtmlUtils_min["isNullOrUndefined"])(_numFeaturesAdded)) {
          cgil_vue_olmap_log.e('# ERROR in _updateGeometry tying to add this invalid Geom from geomGeoJSON: ' + this.geomGeoJSON, this.geomGeoJSON);
        } else {
          cgil_vue_olmap_log.l('in _updateGeometry successfully added this geomGeoJSON to layer now layer has ' + _numFeaturesAdded + ' features !');
          this.maxFeatureIdCounter += _numFeaturesAdded;
        }
      }
      if (getNumberFeaturesInLayer(this.ol_newFeaturesLayer) > 0) {
        cgil_vue_olmap_log.t('# in _updateGeometry adjusting view to extent of features:');
        // cgil added 2 lines of code to recenter the view to the actual geometry layer
        var extent = this.ol_newFeaturesLayer.getSource().getExtent();
        cgil_vue_olmap_log.l('# in _updateGeometry extent :', extent);
        this.ol_map.getView().fit(extent, this.ol_map.getSize());
      }
    },
    _testCommand: function _testCommand() {
      this.gotoNewPos([535895.58, 153129.57]);
      var olLayers = this.ol_map.getLayers();
      olLayers.forEach(function (layer, i, a) {
        if (layer.type == 'VECTOR') {
          var numFeatures = getNumberFeaturesInLayer(layer);
          cgil_vue_olmap_log.w('# in _testCommand Layer(' + i + ') type: ' + layer.type + ' name: ' + layer.get('name') + ' num:' + numFeatures, layer);
        }
      });

      //const t = this.ol_map.features.map(o => o.properties);
    },
    changeLayer: function changeLayer(event) {
      var selectedLayer = null;
      if (Object(cgHtmlUtils_min["isNullOrUndefined"])(event.target)) {
        selectedLayer = this.activeLayer;
      } else {
        selectedLayer = event.target.value;
      }
      var layers = this.ol_map.getLayers();
      layers.forEach(function (layer) {
        cgil_vue_olmap_log.l('## in changeLayer layers.forEach: layer = ' + layer.get('title'), layer);
        var layerName = layer.get('source').layer_;
        if (layer.get('type') === 'base') {
          if (layerName === selectedLayer) {
            layer.setVisible(true);
          } else {
            layer.setVisible(false);
          }
        }
      });
    },
    changeMode: function changeMode(event) {
      var _this = this;

      var selectedMode = null;
      if (Object(cgHtmlUtils_min["isNullOrUndefined"])(event.target)) {
        selectedMode = this.uiMode;
      } else {
        selectedMode = event.target.value;
      }
      if (config_DEV) cgil_vue_olmap_log.l('## in changeMode selectedMode = ' + selectedMode);
      this.ol_Active_Interactions.forEach(function (Interaction) {
        _this.ol_map.removeInteraction(Interaction);
      });
      switch (selectedMode) {
        case 'NAVIGATE':
          break;
        case 'CREATE':
          // TODO TEST VALIDITY OF NEW GEOMETRY IN CREATE MODE, not only when editing
          this.ol_interaction_draw = setCreateMode(this.ol_map, this.ol_newFeatures, this.ol_Active_Interactions, this.maxFeatureIdCounter, function (newGeom) {
            // here is a good place to save geometry
            var formatWKT = new WKT["a" /* default */]();
            var featureWKTGeometry = formatWKT.writeFeature(newGeom);
            if (isValidFeature(newGeom)) {
              cgil_vue_olmap_log.t('## in changeMode CREATE callback for setCreateMode  OK GEOM VALID ' + dumpFeatureToString(newGeom));
              _this.maxFeatureIdCounter += 1;
            } else {
              cgil_vue_olmap_log.e('## in changeMode CREATE callback for setCreateMode  KO GEOM INVALID ' + dumpFeatureToString(newGeom));
              _this.showMessage('ATTENTION : Ce dernier polygone est INVALIDE ! Veuillez le corriger SVP ', 'error');
            }
            var wkt = getMultiPolygonWktGeometryFromPolygonFeaturesInLayer(_this.ol_newFeaturesLayer);
            _this.$emit('gomapgeomchanged', wkt);
          });
          break;
        case 'EDIT':
          setModifyMode(this.ol_map, this.ol_newFeaturesLayer, this.ol_Active_Interactions, this.maxFeatureIdCounter, function (newGeom) {
            cgil_vue_olmap_log.t('## in changeMode EDIT callback for setModifyMode ' + dumpFeatureToString(newGeom), newGeom);
            if (isValidFeature(newGeom)) {
              cgil_vue_olmap_log.t('## in changeMode EDIT callback for setModifyMode  OK GEOM VALID ' + dumpFeatureToString(newGeom));
            } else {
              cgil_vue_olmap_log.e('## in changeMode EDIT callback for setCreateMode  KO GEOM INVALID ' + dumpFeatureToString(newGeom));
              _this.showMessage('ATTENTION : Ce dernier polygone est INVALIDE ! Veuillez le corriger SVP ', 'error');
            }
            var wkt = getMultiPolygonWktGeometryFromPolygonFeaturesInLayer(_this.ol_newFeaturesLayer);
            _this.$emit('gomapgeomchanged', wkt);
            cgil_vue_olmap_log.l('## in changeMode EDIT callback for setModifyMode\n              ** BEGIN LAYER CONTENTS **\n' + getWktGeometryFeaturesInLayer(_this.ol_newFeaturesLayer) + '\n** END LAYER CONTENTS **');
          });
          break;
        case 'TRANSLATE':
          setTranslateMode(this.ol_map, this.ol_newFeaturesLayer, this.ol_Active_Interactions);
          break;
        case 'DELETE':
          setDeleteMode(this.ol_map, this.ol_newFeaturesLayer, this.ol_Active_Interactions, this.maxFeatureIdCounter);
          break;
        default:
          if (config_DEV) cgil_vue_olmap_log.w('## in changeMode selectedMode = ' + selectedMode + ' NOT IMPLEMENTED');
      }
    },
    clearNewFeatures: function clearNewFeatures() {
      var _this2 = this;

      cgil_vue_olmap_log.t('## in clearNewFeatures');
      if (this.ol_newFeatures !== null) {
        this.ol_newFeatures.clear();
        this.ol_Active_Interactions.forEach(function (Interaction) {
          _this2.ol_map.removeInteraction(Interaction);
        });
        this.uiMode = 'NAVIGATE';
      }
    },
    saveNewFeatures: function saveNewFeatures() {
      if (this.ol_newFeatures !== null) {
        var wkt = getMultiPolygonWktGeometryFromPolygonFeaturesInLayer(this.ol_newFeaturesLayer);
        this.$emit('gomapSaveGeomClick', wkt);
      }
    },
    showMessage: function showMessage(message) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';

      var h = this.$createElement;
      this.$message({
        message: h('p', null, [h('span', null, message), h('i', { style: 'color: teal' }, 'VNode')]),
        type: type
      });
    },

    gotoNewPos: function gotoNewPos(arrCoordPos) {
      var zoomLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;

      if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(arrCoordPos)) {
        cgil_vue_olmap_log.t('# gotoNewPos x,y = (' + arrCoordPos[0] + ',' + arrCoordPos[1] + ') zoom = ' + zoomLevel);
        if (isItMN03(arrCoordPos)) {
          var pointMN95 = ol_lausanne_map_mn95_Conv21781In2056(arrCoordPos[0], arrCoordPos[1]);
          this.ol_map.getView().setCenter(pointMN95);
        } else {
          this.ol_map.getView().setCenter(arrCoordPos);
        }
        this.ol_map.getView().setZoom(zoomLevel);
      }
    },

    gotoSelectedAdr: function gotoSelectedAdr(objSelected) {
      cgil_vue_olmap_log.t('# gotoSelectedAdr', objSelected);
      if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(objSelected)) {
        // this.arrSelectionsAdresse.push(objSelected)
        if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(objSelected.id)) {
          var arrCoords = objSelected.id.split('_');
          var newPos = [parse_float_default()(arrCoords[0]), parse_float_default()(arrCoords[1])];
          if (isItMN03([newPos[0], newPos[1]])) {
            var p1 = ol_lausanne_map_mn95_Conv21781In2056(newPos[0], newPos[1]);
            newPos[0] = p1[0];
            newPos[1] = p1[1];
          }
          this.gotoNewPos(newPos, 9);
        }
      }
    },
    aNetworkProblemHappened: function aNetworkProblemHappened(msg) {
      cgil_vue_olmap_log.e('aNetworkProblemHappened --> ' + msg);
      this.showMessage('ATTENTION : Il y a eut un probl\xE8me r\xE9seau ' + msg, 'error');
    },
    toggleConfig: function toggleConfig() {
      this.showConfig = !this.showConfig;
      this.toolbarHeight = this.showConfig ? '166px' : '34px';
    },
    updateOfsFilter: function updateOfsFilter(val) {
      cgil_vue_olmap_log.t('# updateOfsFilter new citiy filter :' + this.currentOfsFilter, val);
      this.geoAdrUrl = config_BASE_REST_API_URL + 'adresses/search_position?ofs=' + this.currentOfsFilter;
      this.$refs.mysearch.setAjaxDataSource(this.geoAdrUrl);
    },
    updateScreen: function updateScreen() {
      cgil_vue_olmap_log.l('## Entering updateScreen screen main WxH: ' + this.$refs.mainzone.clientWidth + ' x ' + this.$refs.mainzone.clientHeight, this.$refs.mainzone);
      if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(this.$refs.mainzone)) {
        /*
        log.t(
        `# updateScreen screen mainzone Width x Height : ${this.$refs.mainzone.clientWidth} x ${this.$refs.mainzone.clientHeight}`)
        */
        this.$refs.mymap.style.height = this.$refs.mainzone.clientHeight - TOOLBARHEIGHT - 15 + 'px';
        this.$refs.mymap.style.width = this.$refs.mainzone.clientWidth - 11 + 'px';
        if (this.$refs.mainzone.clientWidth > 0) {
          //log.l(`# updateScreen screen this.$refs.mymap.clientWidth ${ this.$refs.mymap.clientWidth}`)
          if (this.$refs.mymap.clientWidth < SMALL_SCREEN_WIDTH) {
            this.isSmallScreen = true;
            this.sizeOfControl = 'mini';
          } else {
            this.isSmallScreen = false;
            this.sizeOfControl = 'small';
          }
          if (this.$refs.mymap.clientWidth > MEDIUM_SCREEN_WIDTH) {
            if (this.showConfig === true) {
              // this.toggleConfig()
            }
          }
          this.ol_map.updateSize();
        } else {
          cgil_vue_olmap_log.l('## ELSE updateScreen screen main WxH: ' + this.$refs.mainzone.clientWidth + ' x ' + this.$refs.mainzone.clientHeight, this.$refs.mainzone);
          cgil_vue_olmap_log.l('## ELSE updateScreen screen mymap WxH: ' + this.$refs.mymap.clientWidth + ' x ' + this.$refs.mymap.clientHeight, this.$refs.mymap);
          var refThis = this;
          /*
            window.setTimeout(function () {
            log.l(`### setTimeout in updateScreen main WxH: ${refThis.$refs.mainzone.clientWidth} x ${refThis.$refs.mainzone.clientHeight}`)
            log.l(`### setTimeout in updateScreen mymap WxH: ${refThis.$refs.mymap.clientWidth} x ${refThis.$refs.mymap.clientHeight}`)
            //let x = (refThis.ol_map).renderer.canvas_;
            refThis.$refs.mainzone.style.display = 'block';
            refThis.$refs.mymap.style.display = 'block';
            // next line because of : https://github.com/openlayers/openlayers/issues/4817
            // and of : https://github.com/openlayers/openlayers/issues/8888
            // thank you so much ol for doing such "strange" things like putting display:none in your canvas...
            // can also do : m=document.getElementById('mymap'); m.getElementsByTagName('canvas')[0].style.display=''
            if (!isNullOrUndefined(refThis.$refs.mymap.getElementsByTagName('canvas'))) {
              refThis.$refs.mymap.getElementsByTagName('canvas')[0].style.display = ''
            }
            refThis.ol_map.render();
            refThis.ol_map.updateSize()
          }, 2500)
          */
        }
      } else {
        cgil_vue_olmap_log.t('# updateScreen this.$refs.mainzone IS NULL screen Width x Height : this.$refs.mainzone is undefined', this.$refs.mainzone);
      }
    }
  }, // end of methods section
  mounted: function mounted() {
    var _this3 = this;

    cgil_vue_olmap_log.t('## in mounted ');
    this.currentOfsFilter = this.ofsFilter; // on fixe la valeur initiale de la commune
    this.geoAdrUrl = config_BASE_REST_API_URL + 'adresses/search_position?ofs=' + this.currentOfsFilter;
    // this.$refs.mysearch.setAjaxDataSource(this.geoAdrUrl)
    this.arrListCities = communesBBLidar2012;
    if (this.useInternalWmts) {
      this.layerOptions.push({
        value: 'fonds_geo_conduites',
        label: 'Plan cadastral souterrain (gris)'
      });
    }
    if (this.$refs.mymap.clientWidth < 626) {
      this.isSmallScreen = true;
      this.sizeOfControl = 'mini';
    } else {
      this.isSmallScreen = false;
      this.sizeOfControl = 'small';
    }
    this.activeLayer = this.baselayer;
    createLausanneMap(this.$refs.mymap, this.center, this.zoom, null, this.extent, this.displayPoint, this.layersConfig, function (pCoordInfo) {
      cgil_vue_olmap_log.l('in mounted click callback pCoordInfo :', pCoordInfo);
      // callParentCode(pCoordInfo);
      _this3.$emit('pointclick', pCoordInfo);
    }).then(function (OMap) {
      _this3.ol_map = OMap;
      if (_this3.geojsonurl.length > 4) {
        cgil_vue_olmap_log.l('will enter in loadGeoJsonUrlPolygonLayer(geojsonurl:' + _this3.geojsonurl);
        loadGeoJsonUrlPolygonLayer(_this3.ol_map, _this3.geojsonurl, function (newOlLayer) {
          cgil_vue_olmap_log.l('callback for loadGeoJsonUrlPolygonLayer layer:', newOlLayer);
        }, 'ol_vector_layer_geojsonurl');
      }
      _this3.ol_newFeatures = new Collection["a" /* default */]();
      _this3.ol_newFeaturesLayer = initNewFeaturesLayer(_this3.ol_map, _this3.ol_newFeatures);
      _this3._updateGeometry();
      _this3.updateScreen();
      // OVERLAY FOR TOOLTIP
      _this3.ol_Overlay = new Overlay["default"]({
        element: _this3.$refs.tooltip,
        offset: [10, 0],
        positioning: 'bottom-center'
      });
      _this3.ol_map.addOverlay(_this3.ol_Overlay);

      // ## EVENTS ##
      _this3.ol_map.on('pointermove', function (evt) {
        var localDebug = false;
        if (_this3.uiMode === 'CREATE') return;
        var features = [];
        var x = Number(evt.coordinate[0]).toFixed(2);
        var y = Number(evt.coordinate[1]).toFixed(2);
        var info = {
          coordinates: [x, y],
          numFeaturesDetected: 0
        };
        var lastfeature = _this3.ol_map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
          var layerName = '';
          if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(layer)) {
            layerName = layer.get('name');
            if (localDebug) cgil_vue_olmap_log.l('feature found in layer : "' + layerName + '"');
          }
          var feature_props = feature.getProperties();
          if (localDebug) cgil_vue_olmap_log.l('# GoMap pointermove EVENT, feature detected :\n' + dumpFeatureToString(feature));
          if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(feature_props)) {
            var feature_info = {
              id: feature_props.id,
              feature: feature,
              layer: layerName,
              data: feature_props
              //log.l(`Feature id : ${feature_props.id}, info:`, info);
            };features.push(feature_info);
          } else {
            features.push({
              id: 0,
              feature: feature,
              layer: layerName
            });
          }
          //return feature
        }); //end of forEachFeatureAtPixel
        if (features.length > 0) {
          if (localDebug) cgil_vue_olmap_log.l('GoMap pointermove EVENT ->Array of features found :', features);
          info.numFeaturesDetected = features.length;
          info.features = features;
          var strToolTip = '';
          features.forEach(function (feat_info) {
            var currentTitle = feat_info.data.title;
            if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(currentTitle)) {
              strToolTip += currentTitle.replace(/(<([^>]+)>)/ig, "") + '<br>';
              if (!isValidFeature(feat_info.feature)) {
                strToolTip += '<em> ## ATTENTION CETTE GEOMETRIE EST INVALIDE ! ##</em><br>';
              }
            }
          });
          if (strToolTip.length > 0) {
            _this3.ol_Overlay.setPosition(evt.coordinate);
            _this3.$refs.tooltip.style.display = '';
            _this3.$refs.tooltip.innerHTML = strToolTip;
          } else {
            _this3.$refs.tooltip.innerHTML = '';
            _this3.$refs.tooltip.style.display = 'none';
          }
        } else {
          info.numFeaturesDetected = 0;
          info.features = null;
          _this3.$refs.tooltip.style.display = 'none';
        }
      });
      _this3.ol_map.on('click', function (evt) {
        var x = Number(evt.coordinate[0]).toFixed(2);
        var y = Number(evt.coordinate[1]).toFixed(2);
        var info = {
          coordinates: [x, y],
          numFeaturesDetected: 0
        };
        var features = [];
        if (config_DEV) {
          cgil_vue_olmap_log.t('## BEGIN GoMap click callback : ' + x + ',' + y);
          // log.l(`** BEGIN LAYER CONTENTS **\n${getWktGeometryFeaturesInLayer(this.ol_newFeaturesLayer)}\n** END LAYER CONTENTS **`)
          // let wkt = getMultiPolygonWktGeometryFromPolygonFeaturesInLayer(this.ol_newFeaturesLayer)
          // log.l(wkt)
        }
        if (_this3.uiMode === 'NAVIGATE') {
          var lastfeature = _this3.ol_map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
            var layerName = '';
            if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(layer)) {
              layerName = layer.get('name');
              cgil_vue_olmap_log.l('feature found in layer : "' + layerName + '"');
            }
            var feature_props = feature.getProperties();
            cgil_vue_olmap_log.l('# GoMap click in NAVIGATE mode, feature detected :\n\n                ' + dumpFeatureToString(feature));
            _this3.$emit('selfeature', feature);
            var wkt = getWktGeomFromFeature(feature);
            if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(feature_props)) {
              var feature_info = {
                id: feature_props.id,
                layer: layerName,
                geometryWKT: wkt,
                data: feature_props
              };
              cgil_vue_olmap_log.l('Feature id : ' + feature_props.id + ', info:', info);
              features.push(feature_info);
            }
            //return feature
          });
          if (features.length > 0) {
            cgil_vue_olmap_log.l('->Array of features found :', features);
            info.numFeaturesDetected = features.length;
            info.features = features;
          } else {
            info.numFeaturesDetected = 0;
            info.features = null;
          }
          _this3.$emit('mapclick', info);

          if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(lastfeature)) {
            cgil_vue_olmap_log.l('->Feature found :', lastfeature);
            /*const val = feature.getProperties();
            if (!isNullOrUndefined(val)) {
              const info = {coordinates: [x, y], id: val.id, data: val};
              log.l(`Feature id : ${val.id}, info:`, info);
              this.$emit('mapclick', info);
              // case of an iframe containing a function getMapClickCoordsXY
              // removed for now beacaused it get called also when no iln -sframe
              // if (typeof (window.parent.getMapClickCoordsXY) !== 'undefined') {
              //  window.parent.getMapClickCoordsXY(info);
              // }
              // case of a function getMapClickCoordsXY in global context in window
              if (typeof (window.getMapClickCoordsXY) !== 'undefined') {
                window.getMapClickCoordsXY(info);
              }
            }*/
          }
        } else {
          if (_this3.uiMode === 'CREATE') {
            if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(_this3.ol_interaction_draw)) {
              if (_this3.ol_interaction_draw.getActive() === true) {
                var numVertices = getNumVerticesPolygonFeature(_this3.ol_interaction_draw.currentFeature);
                cgil_vue_olmap_log.t('## GoMap click in CREATE MODE ' + x + ',' + y + ' nombre sommets : ' + numVertices);
                /* j'enleve ce code qui bloque la création de certain polygones qui seront au final correct
                // on controle si le polygone est valide uniquement à la fin
                 if (numVertices > 3) {
                   let ok = isValidPolygon(this.ol_interaction_draw.currentFeature, evt.coordinate)
                   if (ok) {
                     log.t(`## GoMap click in CREATE MODE ${dumpFeatureToString(this.ol_interaction_draw.currentFeature)}`, this.ol_interaction_draw.currentFeature)
                   } else {
                     log.w(`## WARNING SELF-INTERSECT GoMap click in CREATE MODE ${dumpFeatureToString(this.ol_interaction_draw.currentFeature)}`, this.ol_interaction_draw.currentFeature)
                     this.ol_interaction_draw.removeLastPoint()
                   }
                 }
                 */
              }
            }
          }
          _this3.$emit('gomapclick', evt.coordinate);
        }
        cgil_vue_olmap_log.t('## END GoMap click callback : ' + Number(evt.coordinate[0]).toFixed(2) + ',' + Number(evt.coordinate[1]).toFixed(2));
      });
      window.onresize = function () {
        cgil_vue_olmap_log.l('## GoMap IN onresize client Width x Height : ' + _this3.$refs.mainzone.clientWidth + ' x ' + _this3.$refs.mainzone.clientHeight);
        _this3.ol_map.updateSize();
        _this3.updateScreen();
      };
      // window.onclick = (e) => { log.l(`## GoMap IN windowonclick client Width x Height : `, e) }
      _this3.ol_map.updateSize();
      _this3.updateScreen();
    }); // end of then for the async createLausanneMap...
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a18105c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cgil-vue-olmap/cgil-vue-olmap.vue
var cgil_vue_olmap_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mainzone",staticClass:"main"},[_vm._t("default"),_vm._v(" "),_c('el-container',{staticStyle:{"height":"100%"}},[_c('el-header',{attrs:{"height":_vm.toolbarHeight}},[_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex","justify":"space-between","gutter":1}},[_c('el-col',{attrs:{"xs":18,"sm":17,"md":14,"lg":14,"xl":13}},[(_vm.editGeomEnabled)?_c('div',{staticClass:"grid-content bg-edit-toolbar"},[_c('el-button-group',[(_vm.isSmallScreen)?_c('el-select',{attrs:{"id":"modeSelector","size":_vm.sizeOfControl,"title":"Cliquez pour sélectionner le mode de travail"},on:{"change":_vm.changeMode},model:{value:(_vm.uiMode),callback:function ($$v) {_vm.uiMode=$$v},expression:"uiMode"}},_vm._l((_vm.modeOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.isSmallScreen)?_c('el-radio-group',{attrs:{"size":_vm.sizeOfControl,"title":"Cliquez pour sélectionner le mode de travail"},on:{"change":_vm.changeMode},model:{value:(_vm.uiMode),callback:function ($$v) {_vm.uiMode=$$v},expression:"uiMode"}},_vm._l((_vm.modeOptions),function(item){return _c('el-radio-button',{key:item.value,attrs:{"label":item.value,"border":"","size":_vm.sizeOfControl,"disabled":_vm.editDisabled(item.value)}},[_vm._v(_vm._s(item.label)+"\n                ")])}),1):_vm._e()],1),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.editGeomEnabled ),expression:"editGeomEnabled "}],attrs:{"id":"cmdSave","type":"warning","size":_vm.sizeOfControl,"disabled":!(_vm.getNumPolygons > 0)},on:{"click":_vm.saveNewFeatures}},[_vm._v("Sauver\n            ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:((_vm.getNumPolygons > 0) && !_vm.isSmallScreen),expression:"(getNumPolygons > 0) && !isSmallScreen"}],staticClass:"gostatus"},[_vm._v(_vm._s(_vm.getNumPolygons)+" Polygones")]),_vm._v(" "),(_vm.DEV)?[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-star-off","size":"mini","circle":""},on:{"click":_vm._testCommand}})]:_vm._e()],2):_vm._e(),_vm._v(" "),(!_vm.editGeomEnabled && _vm.searchEnabled)?_c('div',{staticClass:"grid-content"},[_c('cg-vue-auto-complete',{ref:"mysearch",attrs:{"placeholder":"Recherchez la position d'une adresse en entrant quelques caractères de celle-ci...","size":_vm.sizeOfControl,"initial-ajax-data-source":_vm.geoAdrUrl},on:{"input":_vm.gotoSelectedAdr,"errorajax":_vm.aNetworkProblemHappened},model:{value:(_vm.addressFound),callback:function ($$v) {_vm.addressFound=$$v},expression:"addressFound"}})],1):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":0,"sm":4,"md":6,"lg":6,"xl":8}},[(_vm.editGeomEnabled)?_c('div',{staticClass:"grid-content bg-purple-light"},[_c('cg-vue-auto-complete',{ref:"mysearch",attrs:{"placeholder":"Recherchez la position d'une adresse en entrant quelques caractères de celle-ci...","size":_vm.sizeOfControl,"initial-ajax-data-source":_vm.geoAdrUrl},on:{"input":_vm.gotoSelectedAdr,"errorajax":_vm.aNetworkProblemHappened},model:{value:(_vm.addressFound),callback:function ($$v) {_vm.addressFound=$$v},expression:"addressFound"}})],1):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"xs":1,"sm":1,"md":1,"lg":1,"xl":1}},[_c('div',{staticClass:"grid-content",staticStyle:{"margin-right":"auto","margin-left":"auto"}},[_c('el-button',{staticStyle:{"float":"right","right":"1px"},attrs:{"size":_vm.sizeOfControl,"type":"primary","icon":"el-icon-setting"},on:{"click":function($event){return _vm.toggleConfig()}}})],1)])],1),_vm._v(" "),(_vm.showConfig)?[_c('el-card',{staticClass:"box-card"},[_c('el-form',{attrs:{"label-position":"left","size":_vm.sizeOfControl}},[_c('el-form-item',{attrs:{"label":"Commune (adresse):","size":_vm.sizeOfControl}},[_c('el-select',{staticStyle:{"float":"right","right":"1px"},attrs:{"placeholder":"Select","size":_vm.sizeOfControl},on:{"change":_vm.updateOfsFilter},model:{value:(_vm.currentOfsFilter),callback:function ($$v) {_vm.currentOfsFilter=$$v},expression:"currentOfsFilter"}},_vm._l((_vm.arrListCities),function(item){return _c('el-option',{key:item.ofs,attrs:{"label":item.label,"value":item.ofs}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Fond de plan :","size":_vm.sizeOfControl}},[_c('el-select',{staticStyle:{"float":"right","right":"1px"},attrs:{"size":_vm.sizeOfControl,"title":"Cliquez pour sélectionner le fond de plan"},on:{"change":_vm.changeLayer},model:{value:(_vm.activeLayer),callback:function ($$v) {_vm.activeLayer=$$v},expression:"activeLayer"}},_vm._l((_vm.layerOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1)],1)]:_vm._e()],2),_vm._v(" "),_c('el-main',{staticStyle:{"padding":"0"}},[_c('div',{ref:"mymap",staticClass:"map-content",attrs:{"id":"mymap"}},[_c('div',{ref:"tooltip",staticClass:"tooltip"})])])],1)],2)}
var cgil_vue_olmap_staticRenderFns = []
var cgil_vue_olmap_esExports = { render: cgil_vue_olmap_render, staticRenderFns: cgil_vue_olmap_staticRenderFns }
/* harmony default export */ var cgil_vue_olmap_cgil_vue_olmap = (cgil_vue_olmap_esExports);
// CONCATENATED MODULE: ./src/components/cgil-vue-olmap/cgil-vue-olmap.vue
function cgil_vue_olmap_injectStyle (ssrContext) {
  __webpack_require__("uuFV")
}
var cgil_vue_olmap_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var cgil_vue_olmap___vue_template_functional__ = false
/* styles */
var cgil_vue_olmap___vue_styles__ = cgil_vue_olmap_injectStyle
/* scopeId */
var cgil_vue_olmap___vue_scopeId__ = "data-v-0a18105c"
/* moduleIdentifier (server only) */
var cgil_vue_olmap___vue_module_identifier__ = null
var cgil_vue_olmap_Component = cgil_vue_olmap_normalizeComponent(
  cgil_vue_olmap,
  cgil_vue_olmap_cgil_vue_olmap,
  cgil_vue_olmap___vue_template_functional__,
  cgil_vue_olmap___vue_styles__,
  cgil_vue_olmap___vue_scopeId__,
  cgil_vue_olmap___vue_module_identifier__
)

/* harmony default export */ var components_cgil_vue_olmap_cgil_vue_olmap = (cgil_vue_olmap_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/build.js
var build = __webpack_require__("XILU");
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/goelandFormPodp.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















var goelandFormPodp_log = config_getLog('goelandFormPODP', 4, 1);

// const pos = [538127.1, 151624.1] // Av Acacacias Lausanne
var pos = [2537874.0, 1152109.0]; // gare lausanne
// const pos = [538350.5, 152669.0] // cathedrale Lausanne
var baseLayerSelected = Object(cgHtmlUtils_min["getStringParam"])('baselayer', 'fonds_geo_osm_bdcad_gris');
var layersVisibility = Object(cgHtmlUtils_min["getStringParam"])('lvisibles', '41');
var arrLayersVisibility = hexToArr('0x' + layersVisibility);
goelandFormPodp_log.w('layersVisibility:' + layersVisibility + ' => arrLayersVisibility: ' + arrLayersVisibility);

/* harmony default export */ var goelandFormPodp = ({
  name: 'goelandFormPodp',
  components: {
    cgilOlMap: components_cgil_vue_olmap_cgil_vue_olmap,
    goSwitch: components_ui_goSwitch,
    vSelect: vue_select_default.a,
    goCollapse: components_ui_goCollapse,
    goCollapseActeurRoleDetails: components_ui_goCollapseActeurRoleDetails,
    goSelectActeur: components_geo_goSelectActeur,
    Datepicker: build_default.a
  },
  props: {
    guid: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      isItDevEnv: DEV,
      center: pos,
      isGuidNull: null,
      data_json: null, // Ref sur le contenu de la demande distante initiale provenant de la db goeland
      // GESTION DES ETATS DE CHARGEMENTS
      isDemandeInitialeROLoaded: false, // chargement des donnees initiales distante data_json initiale est-il termine
      isIdDemandeValid: false,
      isDemandeAlreadysaved: null, // est-ce que la demande en cours contient deja des données ?
      isdemandeDataEnCoursLoaded: false, // est-ce que les données de la demande en cours sont chargées ?
      isSubmitToLocalDatabaseSuccessfull: false, // on a envoye le formulaire et il est sauve dans la BD  postgresql locale
      isGuidValid: null,
      // GESTION ERREUR SAUVEGARDE
      isSavingError: false,
      lastSavingError: '',
      goodStreetIds: [], // pour stocker ids des rues du chantier pour controle securite
      step1Msg: '1. identification',
      // une fois que l'utilisateur indique au moins une rue en relation avec cette demande
      // on considere cette etape 1 d'identification  comme terminee et on passe a la suivante
      step1IsDone: false,
      step2Msg: '2. informations générales',
      /* dans cette etape on affice les informations en lecture uniquement de la demande initiale
       on verifie dans la BD locale si un debut de demande existe si c'est le cas on rafraichi les donnee
       si ce ne'est pas le cas alors l'utilisateur doit :
               a) [IsContactPoliceDone] : confirmer qu'il a pris contact avec la police
               b) responsablePolice : indiquer le responsable police avec qui il a discuté
               c) IsConditionGeneralAccepted: confirmer qu'il accepte les Conditions generales
          une fois que ces 3 conditions sont remplies l'Etape 2 est terminee [step2IsDone=true]
          on sauve l'etat de la demande en cours demandeDataEnCours
       */

      step2arrContactPolice: ['Anouk Louvet-Jardin', 'Frédéric Vauthey', 'Martial Maillard'],
      step3Msg: '3. interlocuteurs',
      step3arrActeurFacturationOptions: ['Bénéficiaire du permis', 'Maitre d\'ouvrage', 'Mandataire', 'Autre'],
      step4Msg: '3. localisation',
      step4ValidationType: 'info',
      showMap: false,
      isPolygonAlreadyPresentInGoeland: null,
      dateDebutDisabled: { to: null, from: null },
      dateFinDisabled: { to: null, from: null },
      datePickerHighlighted: { to: null, from: null },
      step5Msg: '4. fouilles',
      dateDebutDisabled_fouille: { to: null, from: null },
      dateFinDisabled_fouille: { to: null, from: null },
      datePickerHighlighted_fouille: { to: null, from: null },
      step5ValidationType: 'info',
      step6Msg: '5. occupation',
      step6ValidationType: 'info',
      step7Msg: '6. places de stationnement',
      step7ValidationType: 'info',
      // pour les controles datepicker min max
      dateDebutDisabled_StationnementNumMacarons: { to: null, from: null },
      dateFinDisabled_StationnementNumMacarons: { to: null, from: null },
      datePickerHighlighted_StationnementNumMacarons: { to: null, from: null },
      dateDebutDisabled_StationnementNumAutres: { to: null, from: null },
      dateFinDisabled_StationnementNumAutres: { to: null, from: null },
      datePickerHighlighted_StationnementNumAutres: { to: null, from: null },
      step8Msg: '7. envoi de la demande',
      step8ValidationType: 'info',
      stepRequestSendedMsg: 'Votre demande a été envoyée',
      idDemande: null, // pour permetre evt saisie manuellecacheInitialData id affaire (securite)
      streetSelected: null, // pour stocker rue selectionne par utilisateur (securite)
      streetName: '',
      streetList: [],
      geometrieChantiersSaisiePrecedement: '',
      // ############ informations initiales recues via Goeland sur cette demande
      demandeInitialeRO: {
        id: 0, // READONLY data_json["IdAffaire"]  identifiant externe de cette demande id affaire goeland
        nomAffaire: null, // NEW data_json["NomAffaire"] titre affaire goéland
        datecreated: null, // date de creation des donnees distante demande initiale
        responsableVdL: null, //  data_json["ResponsableVdL"] le user qui saisit la demande
        itWasUnAuthorizedOccupacy: null, // data_json["BRegularisation"] s'agit itl d'une regularisation
        BPayant: null, // data_json["BPayant"] le permis est payant
        // infos provenant de coordination chantier
        IdAffCoordChantier: null, // data_json["IdAffCoordChantier"]
        nomAffCoordChantier: null, // data_json["NomAffCoordChantier"]
        UOLeaderAffCoordChantier: null, // data_json["UOLeaderAffCoordChantier"]
        geomAffCoordChantier: null, // data_json["GeomAffCoordChantier"]
        // infos concernant les acteurs liés reçus data_json["ActeurL": [{...}]
        // on doit recevoir au moins 1 entree dans ActeurL
        isBeneficiaireGiven: false,
        isMandataireGiven: false,
        Beneficiaire: {
          idActeur: null,
          Role: null,
          Nom: null,
          AdresseCorresp: null,
          Telephone: null,
          TelephonePortable: null,
          Fax: null,
          Email: null
        },
        Mandataire: {
          idActeur: null,
          Role: null,
          Nom: null,
          AdresseCorresp: null,
          Telephone: null,
          TelephonePortable: null,
          Fax: null,
          Email: null
        },
        // cas du IdAffCoordChantier et UOLeaderAffCoordChantier non null du coup c'est eux le Maitre Ouvrage
        isMaitreOuvrageGiven: false,
        MaitreOuvrage: {
          Role: null,
          Nom: null
        }
      },
      // ############ informations saisie par le client concernant cette demande qui sera renvoyée plus loin

      demandeDataEnCours: {
        // **** infos identifiant la demande initiale
        id: null, // READONLY data_json["IdAffaire"]  identifiant externe de cette demande id affaire goeland
        guid: null, // READONLY  guid demande initiale passee dans url
        realGuid: null, // READONLY dernier (temporellement) guid reel utilise pour la demande distante
        // **** infos geree par le systeme
        datecreated: null, // date premiere sauvegarde de cette demande cote client
        datelastmodif: null, // date derniere modification de cette demande cote client
        datesubmited: null, // date de bouclement (submit final) de cette demande cote client
        // **** infos concernant Etape 2 de la demande cote client
        affClientContact: null, // data_json["AffClientContact"]
        affClientEmail: null, // data_json["AffClientEmail"]
        affClientTelephone: null, // data_json["AffClientTelephone"]
        IsContactPoliceDone: true,
        responsablePolice: '', // string
        IsConditionGeneralAccepted: false,
        step2IsDone: false,
        // **** infos concernant Etape 3 de la demande cote client
        acteurBeneficiaire: {
          isActeurFromGoeland: false,
          idActeurFromGoeland: null,
          isActeurValid: false,
          isActeurCollapsed: false,
          isActeurPhysique: false,
          IdActeurSelected: null,
          RaisonSociale: null,
          RaisonSocialeIsValid: false,
          RueNumero: null,
          CPVille: null,
          Telephone: null,
          TelephonePortable: null,
          Fax: null,
          Email: null
        },
        acteurMaitreOuvrage: {
          isActeurValid: false,
          isActeurCollapsed: false,
          isActeurPhysique: false,
          IdActeurSelected: null,
          RaisonSociale: null,
          RaisonSocialeIsValid: false,
          RueNumero: null,
          CPVille: null,
          Telephone: null,
          TelephonePortable: null,
          Fax: null,
          Email: null
        },
        acteurMandataire: {
          isActeurFromGoeland: false,
          idActeurFromGoeland: null,
          isActeurValid: false,
          isActeurCollapsed: false,
          isActeurPhysique: false,
          IdActeurSelected: null,
          RaisonSociale: null,
          RaisonSocialeIsValid: false,
          RueNumero: null,
          CPVille: null,
          Telephone: null,
          TelephonePortable: null,
          Fax: null,
          Email: null
        },
        isActeurFacturationOneOfPrevious: true,
        acteurFacturationOptionSelected: 'Bénéficiaire du permis', // TODO la valeur par defaut s'affiche pas
        acteurFacturation: {
          isActeurValid: false,
          isActeurCollapsed: false,
          isActeurPhysique: false,
          IdActeurSelected: null,
          RaisonSociale: null,
          RaisonSocialeIsValid: false,
          RueNumero: null,
          CPVille: null,
          Telephone: null,
          TelephonePortable: null,
          Fax: null,
          Email: null
        },
        step3IsDone: false,
        // **** infos concernant Etape 4 de la demande cote client
        // ici on rappelle les rues et les adresses concernées
        commentaireLocalisation: null, // Commentaire sur la localisation
        descriptionTravaux: null, // [string] champ libre
        dateDebutOccupation: null, // [date] limiter date maintenant moins n mois
        dateFinOccupation: null, // [date] doit etre plus grand que debut et minumum 10 jours
        //  En cas de prolongation du chantier, veuillez nous transmettre une copie du permis délivré avec l'indication des nouvelles dates, ceci avant son échéance.
        step4IsDone: false,
        geometrieChantiersSaisie: null, // saisie de la geometrie
        // ** Utilisation du domaine public pour une fouille
        isFouilleOuForage: false, // [Boolean] les travaux se situent-ils sur la chaussée ?
        // debut ajout champs pour demande DESMET juin 2023
        fouilleLongueur01: 0, // [Number] Longueur fouille
        fouilleLargeur01: 0, // [Number] Largeur fouille
        fouilleSurface01: 0, // [Number] Surface fouille
        fouilleLongueur02: 0,
        fouilleLargeur02: 0,
        fouilleSurface02: 0,
        fouilleLongueur03: 0,
        fouilleLargeur03: 0,
        fouilleSurface03: 0,
        fouilleLongueur04: 0,
        fouilleLargeur04: 0,
        fouilleSurface04: 0,
        fouilleSurfaceTotal: 0,
        fouilleDateDebut: null,
        fouilleDateFin: null,
        // fin ajout champs pour demande DESMET juin 2023
        isFouilleSurChaussee: false, // [Boolean] les travaux se situent-ils sur la chaussée ?
        isFouilleSurTrotoir: false, // [Boolean] les travaux se situent-ils sur un trottoir ?
        isFouilleSurZonePavee: false,
        isFouilleSurZonePaveeDevisDemande: false,
        isFouilleEndomageBalisageSol: false, // [Boolean] les travaux endommageront-ils le balisage au sol ?
        step5IsDone: false,
        // ** Occupation du domaine public
        isOccupationDP: false,
        // debut ajout champs pour demande DESMET juin 2023
        occupationDPLongueur01: 0,
        occupationDPLargeur01: 0,
        occupationDPSurface01: 0,
        isOccupation_PoseDeposeModificationEnseigne: false,
        // fin ajout champs pour demande DESMET juin 2023
        isOccupation_Benne: false,
        isOccupation_DepotMateriel: false,
        isOccupation_DepotEnginsChantier: false,
        isOccupation_PalissadeOuClotureChantier: false, // palissade / clôture de chantier
        isOccupation_RoulotteOuContainer: false, //       roulotte / container de chantier
        isOccupation_CamionNacelle: false, //             camion nacelle
        isOccupation_CamionGrue: false, //         camion grue
        isOccupation_Grue: false, //               grue
        isOccupation_ChauffageMobile: false, //    chauffage mobile
        isOccupation_Echafaudage: false, //        échafaudage
        isOccupation_ElagageArbre: false, //       élagage d'arbre
        isOccupation_Etayage: false, //           étayage
        isOccupation_PontRoulant: false, //        pont roulant
        isOccupation_GroupeElectrogene: false, //        groupe électogène (ajout 2022)
        isOccupation_AccesChantier: false, //      accès chantier
        isOccupation_Autre: false, //      Autre
        Occupation_Autre: null,
        step6IsDone: false,
        isStationnementPresent: false,
        StationnementCommentaire: null, // [string] champ libre ajoute 04/12/2018 feedback Steve Michaud
        StationnementNumMacarons: 0,
        StationnementNumMacarons_date_debut: null,
        StationnementNumMacarons_date_fin: null,
        StationnementNumAutres: 0,
        StationnementNumAutres_date_debut: null,
        StationnementNumAutres_date_fin: null,
        step7IsDone: false,
        step8IsDone: false,
        isFinalSubmitDone: false // c'est ici que l'on va garde l'info si l'envoi definitif est fait
      },
      mapLayers: {
        baseLayer: baseLayerSelected,
        layerForQueryInit: 'bdcad_bf_parc_pol,bdcad_bf_parc_pol_dp,bdcad_bf_parc_pol_ddp,bdcad_cs_bati_pol,bdcad_cs_bati_pol_sout,bdcad_bf_point',
        wmsLayers: [{
          layers: 'bdcad_projets_msgroup',
          title: 'Projets et chantiers',
          isVisible: arrLayersVisibility[0]
        }, {
          layers: 'bdcad_pf_pfp_msgroup,bdcad_pf_pfp_alti',
          title: 'PFP',
          isVisible: arrLayersVisibility[1]
        }, {
          layers: 'bdcad_pfp_reperage_msgroup',
          title: 'PFP repérage',
          isVisible: arrLayersVisibility[2]
        }, {
          layers: 'bdcad_pf_pfa_msgroup,bdcad_pf_pfa_alti',
          title: 'PFA',
          isVisible: arrLayersVisibility[3]
        }, { // je choisis la version du GC public pour que cela fonctionne partout
          layers: 'envconst_arbres_public_remarquables,envconst_arbres_public_remplacement,envconst_arbres_public_projet,envconst_arbres_public_abattage,envconst_arbres_public_autres',
          title: 'Arbres',
          isVisible: arrLayersVisibility[4]
        }, {
          layers: 'envconst_toitures_veg',
          title: 'Toitures Végétalisées',
          isVisible: arrLayersVisibility[5]
        },
        /* // pas disponible sur map :
        {
          layers: 'bdcad_bf_parcom_pol',
          title: 'Parcelles Communales',
          isVisible: arrLayersVisibility[6],
        },
           */
        {
          layers: 'perimetres_lim_com_msgroup',
          title: 'Limites Communales',
          isVisible: arrLayersVisibility[6]
        }, {
          layers: 'altimetrie_hauteur_vegetation_mnc_class',
          title: 'Canopée végétation',
          isVisible: arrLayersVisibility[7]
        }] // FIN DE LA CONFIG DES mapLayers
      } };
  }, // end of data section
  computed: {
    isStep2Valid: function isStep2Valid() {
      if (!this.isSubmitToLocalDatabaseSuccessfull) {
        if (this.isIdDemandeValid && this.demandeDataEnCours.IsContactPoliceDone) {
          // si les donnees ne proviennent pas deja de la BD locale alors on sauve
          if (!this.isDemandeAlreadysaved) {
            this.saveForm(); // fin du step2 premiere sauvegarde
          }
          return true;
        } else {
          this.demandeDataEnCours.step2IsDone = false;
          return false;
        }
      }
    },
    isStep3Valid: function isStep3Valid() {
      if (!this.isSubmitToLocalDatabaseSuccessfull) {
        /*
        if (this.demandeDataEnCours.acteurBeneficiaire.isActeurValid &&
          this.demandeDataEnCours.acteurMaitreOuvrage.isActeurValid) {
          this.demandeDataEnCours.step3IsDone = true
          if (this.isDemandeAlreadysaved) {
            this.saveForm()
          }
          return true
        } else {
          this.demandeDataEnCours.step3IsDone = false
          return false
        }
        */
        return true;
      }
    },
    isStep4Valid: function isStep4Valid() {
      if (!this.isSubmitToLocalDatabaseSuccessfull) {
        if (this.demandeDataEnCours.dateDebutOccupation !== null && this.demandeDataEnCours.dateFinOccupation !== null && this.demandeDataEnCours.descriptionTravaux !== null && (this.demandeDataEnCours.geometrieChantiersSaisie !== null || this.isPolygonAlreadyPresentInGoeland)) {
          this.saveForm();
          return true;
        } else {
          this.demandeDataEnCours.step4IsDone = false;
          return false;
        }
      }
    },
    step4ValidationText: function step4ValidationText() {
      var msg = ' Veuillez svp saisir';
      if (this.demandeDataEnCours.geometrieChantiersSaisie == null && this.isPolygonAlreadyPresentInGoeland === false) msg += ' la géométrie du chantier,';
      if (this.demandeDataEnCours.descriptionTravaux == null) msg += ' la description,';
      if (this.demandeDataEnCours.dateDebutOccupation === null && this.demandeDataEnCours.dateFinOccupation === null) {
        msg += ' les dates de début et fin d\'occupation.';
      } else {
        if (this.demandeDataEnCours.dateFinOccupation === null) msg += ' la date de fin d\'occupation.';
      }
      if (this.isStep4Valid) msg = 'Vous pouvez passer à l\'étape suivante en cliquant sur le bouton ci-contre';
      return msg;
    },
    // 4. Fouilles sur DP
    isStep5Valid: function isStep5Valid() {
      return true; // en attendant d'avoir des infos de validation plus precise ...
    },
    step5ValidationText: function step5ValidationText() {
      var msg = '';
      return msg;
    },
    // Occupation du DP
    isStep6Valid: function isStep6Valid() {
      if (this.demandeDataEnCours.isFouilleOuForage === false && this.demandeDataEnCours.isOccupationDP === false) {
        this.demandeDataEnCours.step6IsDone = false;
        return false;
      }
      if (this.demandeDataEnCours.isFouilleOuForage === true && this.demandeDataEnCours.isOccupationDP === false) {
        this.demandeDataEnCours.step6IsDone = false;
        return false;
      }
      if (this.demandeDataEnCours.isOccupationDP === true && !this.isOccupationDPValid) {
        this.demandeDataEnCours.step6IsDone = false;
        return false;
      }
      return true;
    },
    isOccupationDPValid: function isOccupationDPValid() {
      // au moins une case a coche
      return this.demandeDataEnCours.isOccupation_Benne || this.demandeDataEnCours.isOccupation_DepotMateriel || this.demandeDataEnCours.isOccupation_DepotEnginsChantier || this.demandeDataEnCours.isOccupation_PalissadeOuClotureChantier || this.demandeDataEnCours.isOccupation_RoulotteOuContainer || this.demandeDataEnCours.isOccupation_CamionNacelle || this.demandeDataEnCours.isOccupation_CamionGrue || this.demandeDataEnCours.isOccupation_Grue || this.demandeDataEnCours.isOccupation_ChauffageMobile || this.demandeDataEnCours.isOccupation_Echafaudage || this.demandeDataEnCours.isOccupation_ElagageArbre || this.demandeDataEnCours.isOccupation_Etayage || this.demandeDataEnCours.isOccupation_PontRoulant || this.demandeDataEnCours.isOccupation_GroupeElectrogene || this.demandeDataEnCours.isOccupation_AccesChantier || this.demandeDataEnCours.isOccupation_PoseDeposeModificationEnseigne || this.isOccupationDPValidAutre;
    },
    isOccupationDPValidAutre: function isOccupationDPValidAutre() {
      if (Object(cgHtmlUtils_min["isNullOrUndefined"])(this.demandeDataEnCours.Occupation_Autre)) {
        return false;
      } else {
        if (this.demandeDataEnCours.Occupation_Autre.length < 2) return false;
      }
      return true;
    },
    step6ValidationText: function step6ValidationText() {
      var msg = '';
      if (this.demandeDataEnCours.isFouilleOuForage === false && this.demandeDataEnCours.isOccupationDP === false) {
        msg = 'Vous ne pouvez répondre NON aux deux questions des sections 4 et 5 !';
      }
      return msg;
    },
    // Utilisation de Places de Stationnement
    isStep7Valid: function isStep7Valid() {
      if (this.demandeDataEnCours.isStationnementPresent === true) {
        if (this.demandeDataEnCours.StationnementNumMacarons + this.demandeDataEnCours.StationnementNumAutres < 1) {
          return false;
        }
        if (this.demandeDataEnCours.StationnementNumMacarons > 0) {
          if (Object(cgHtmlUtils_min["isNullOrUndefined"])(this.demandeDataEnCours.StationnementNumMacarons_date_debut) || Object(cgHtmlUtils_min["isNullOrUndefined"])(this.demandeDataEnCours.StationnementNumMacarons_date_fin)) {
            return false;
          }
        }
        if (this.demandeDataEnCours.StationnementNumAutres > 0) {
          if (Object(cgHtmlUtils_min["isNullOrUndefined"])(this.demandeDataEnCours.StationnementNumAutres_date_debut) || Object(cgHtmlUtils_min["isNullOrUndefined"])(this.demandeDataEnCours.StationnementNumAutres_date_fin)) {
            return false;
          }
        }
      }
      return true; // en attendant d'avoir des infos de validation plus precise ...
    },
    step7ValidationText: function step7ValidationText() {
      var msg = '';
      return msg;
    },
    isFormValid: function isFormValid() {
      if (this.isStep2Valid && this.isStep3Valid && this.isStep4Valid && this.isStep5Valid && this.isStep6Valid && this.isStep7Valid && this.demandeDataEnCours.IsConditionGeneralAccepted) {
        return true;
      } else {
        return false;
      }
    },
    step8ValidationText: function step8ValidationText() {
      var msg = '';

      return msg;
    },
    calculSurface01: function calculSurface01() {
      this.demandeDataEnCours.fouilleSurface01 = 0;
      if (this.demandeDataEnCours.fouilleLongueur01 > 0 && this.demandeDataEnCours.fouilleLargeur01 > 0) {
        this.demandeDataEnCours.fouilleSurface01 = (this.demandeDataEnCours.fouilleLongueur01 * this.demandeDataEnCours.fouilleLargeur01).toFixed(2);
        return this.demandeDataEnCours.fouilleSurface01 + ' m\xB2';
      } else {
        return this.demandeDataEnCours.fouilleSurface01 + ' m\xB2';
      }
    },
    calculSurface02: function calculSurface02() {
      this.demandeDataEnCours.fouilleSurface02 = 0;
      if (this.demandeDataEnCours.fouilleLongueur02 > 0 && this.demandeDataEnCours.fouilleLargeur02 > 0) {
        this.demandeDataEnCours.fouilleSurface02 = (this.demandeDataEnCours.fouilleLongueur02 * this.demandeDataEnCours.fouilleLargeur02).toFixed(2);
        return this.demandeDataEnCours.fouilleSurface02 + ' m\xB2';
      } else {
        return this.demandeDataEnCours.fouilleSurface02 + ' m\xB2';
      }
    },
    calculSurface03: function calculSurface03() {
      this.demandeDataEnCours.fouilleSurface03 = 0;
      if (this.demandeDataEnCours.fouilleLongueur03 > 0 && this.demandeDataEnCours.fouilleLargeur03 > 0) {
        this.demandeDataEnCours.fouilleSurface03 = (this.demandeDataEnCours.fouilleLongueur03 * this.demandeDataEnCours.fouilleLargeur03).toFixed(2);
        return this.demandeDataEnCours.fouilleSurface03 + ' m\xB2';
      } else {
        return this.demandeDataEnCours.fouilleSurface03 + ' m\xB2';
      }
    },
    calculSurface04: function calculSurface04() {
      this.demandeDataEnCours.fouilleSurface04 = 0;
      if (this.demandeDataEnCours.fouilleLongueur04 > 0 && this.demandeDataEnCours.fouilleLargeur04 > 0) {
        this.demandeDataEnCours.fouilleSurface04 = (this.demandeDataEnCours.fouilleLongueur04 * this.demandeDataEnCours.fouilleLargeur04).toFixed(2);
        return this.demandeDataEnCours.fouilleSurface04 + ' m\xB2';
      } else {
        return this.demandeDataEnCours.fouilleSurface04 + ' m\xB2';
      }
    },
    calculSurfaceTotal: function calculSurfaceTotal() {
      this.demandeDataEnCours.fouilleSurfaceTotal = 0;
      if (this.demandeDataEnCours.fouilleSurface01 > 0 || this.demandeDataEnCours.fouilleSurface02 > 0) {
        this.demandeDataEnCours.fouilleSurfaceTotal = (parseFloat(this.demandeDataEnCours.fouilleSurface01) + parseFloat(this.demandeDataEnCours.fouilleSurface02) + parseFloat(this.demandeDataEnCours.fouilleSurface03) + parseFloat(this.demandeDataEnCours.fouilleSurface04)).toFixed(2);
        return this.demandeDataEnCours.fouilleSurfaceTotal + ' m\xB2';
      } else {
        return this.demandeDataEnCours.fouilleSurface04 + ' m\xB2';
      }
    },
    calculSurfaceOccupationDP01: function calculSurfaceOccupationDP01() {
      this.demandeDataEnCours.occupationDPSurface01 = 0;
      if (this.demandeDataEnCours.occupationDPLongueur01 > 0 && this.demandeDataEnCours.occupationDPLargeur01 > 0) {
        this.demandeDataEnCours.occupationDPSurface01 = (this.demandeDataEnCours.occupationDPLongueur01 * this.demandeDataEnCours.occupationDPLargeur01).toFixed(2);
        return this.demandeDataEnCours.occupationDPSurface01 + ' m\xB2';
      } else {
        return this.demandeDataEnCours.occupationDPSurface01 + ' m\xB2';
      }
    }
  }, // end of computed props section

  watch: {
    '$route': function $route(to, from) {
      var _this = this;

      goelandFormPodp_log.w('## IN demandePoDP.watch($route) ', to, from);
      if (to.params.guid !== from.params.guid) {
        goelandFormPodp_log.w('#### NAVIGATE FROM : ' + from.params.guid);
        goelandFormPodp_log.w('#### NAVIGATE TO   : ' + to.params.guid);
        // TODO provide a global reinit of all forms vars to default
        this.isGuidNull = false;
        this.isDemandeInitialeROLoaded = false;
        this.step1IsDone = false;
        this.isIdDemandeValid = false;
        this.isGuidValid = false;
        this.streetSelected = null;
        if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(to.params.guid)) {
          demandePoDP.getDemandeInitiale(to.params.guid, function (dataref) {
            goelandFormPodp_log.l('## IN demandePoDP.watch($route) callback for reloading of :' + to.params.guid);
            _this.cacheInitialData(dataref);
          });
        } else {
          goelandFormPodp_log.w('## IN demandePoDP.watch($route) to.params.guid is undefined !');
        }
      } else {
        goelandFormPodp_log.w('## IN demandePoDP.watch($route) : NO NAVIGATION BECAUSE guid is the same');
        goelandFormPodp_log.w('#### NAVIGATE FROM : ' + from.params.guid);
        goelandFormPodp_log.w('#### NAVIGATE TO   : ' + to.params.guid);
      }
    },
    'demandeDataEnCours.IsContactPoliceDone': function demandeDataEnCoursIsContactPoliceDone(val) {
      goelandFormPodp_log.l('## IN demandePoDP.watch(demandeDataEnCours.IsContactPoliceDone)', val);
    }
  },
  created: function created() {
    var _this2 = this;

    goelandFormPodp_log.l('## INSIDE  goelandFormPodp created ');
    if (this.guid !== null) {
      this.isGuidNull = false;
      demandePoDP.getDemandeInitiale(this.guid, function (dataref) {
        goelandFormPodp_log.l('## INSIDE demandePoDP.getDemandeInitiale callback for created');
        _this2.cacheInitialData(dataref);
      });
    } else {
      goelandFormPodp_log.w('## INSIDE  goelandFormPodp created : guid is null');
      this.isGuidNull = true;
    }
  }, // end of created hook section

  mounted: function mounted() {
    var _this3 = this;

    axios_default.a.get(BASE_REST_API_URL + '/streets').then(function (resp) {
      // console.dir(resp)
      _this3.streetList = resp.data;
    }).catch(function (err) {
      goelandFormPodp_log.e('## ERROR IN Form mounted axios.get ', err);
    });
    goelandFormPodp_log.l('## IN  goelandFormPodp mounted ');
    if (this.guid !== null) {
      if (demandePoDP.isDemandeCached(this.guid)) {
        this.cacheInitialData(demandePoDP.getDemandeInitiale(this.guid));
      }
    }
  }, // end of mounted hook section

  filters: {
    convertReturn2Comma: function convertReturn2Comma(value) {
      if (!value) return '';
      value = value.toString();
      return value.replace('\n', ', ');
    }
  },
  methods: {
    cacheInitialData: function cacheInitialData(dataref) {
      var _this4 = this;

      goelandFormPodp_log.l('## IN  goelandFormPodp.cacheInitialData ');
      if ((typeof dataref === 'undefined' ? 'undefined' : typeof_default()(dataref)) === 'object') {
        try {
          this.data_json = JSON.parse(dataref['json_data']);
          goelandFormPodp_log.l('data_json is :', stringify_default()(this.data_json, null, 2));
          this.demandeDataEnCours.guid = this.guid;
          this.demandeDataEnCours.realGuid = dataref['guid'];
          this.demandeInitialeRO.datecreated = dataref['datecreated'];
          this.idDemande = this.data_json['IdAffaire'];
          // lets's check if data was already saved
          demandePoDP.isDemandeAlreadysaved(this.idDemande, function (data) {
            goelandFormPodp_log.l('## INSIDE demandePoDP.isDemandeAlreadysaved callback for done');
            _this4.isDemandeAlreadysaved = data; // will be true or false
          });
          this.demandeInitialeRO.id = this.data_json['IdAffaire'];
          this.demandeInitialeRO.nomAffaire = this.data_json['NomAffaire'];
          this.demandeInitialeRO.responsableVdL = this.data_json['ResponsableVdL'];
          this.demandeInitialeRO.itWasUnAuthorizedOccupacy = this.data_json['BRegularisation'] !== '0';
          this.demandeInitialeRO.BPayant = this.data_json['BPayant'] !== '0';
          // info du client a priori beneficiaire or acteur
          this.demandeDataEnCours.affClientContact = this.data_json['AffClientContact'];
          this.demandeDataEnCours.affClientEmail = this.data_json['AffClientEmail'];
          this.demandeDataEnCours.affClientTelephone = this.data_json['AffClientTelephone'];
          // l'IDAFF "VDL-coordination chantier"
          this.demandeInitialeRO.IdAffCoordChantier = this.data_json['IdAffCoordChantier'];
          this.demandeInitialeRO.nomAffCoordChantier = this.data_json['NomAffCoordChantier'];
          this.demandeInitialeRO.UOLeaderAffCoordChantier = this.data_json['UOLeaderAffCoordChantier'];
          if (this.demandeInitialeRO.IdAffCoordChantier) {
            // si on a un IdAffCoordChantier c'est que chantier vient de la Ville pas besoin de saisir MaitreOuvrage
            this.demandeInitialeRO.MaitreOuvrage.Role = 'Maitre d\'ouvrage';
            this.demandeInitialeRO.MaitreOuvrage.Nom = this.demandeInitialeRO.UOLeaderAffCoordChantier;
            this.demandeInitialeRO.isMaitreOuvrageGiven = true;
            this.demandeDataEnCours.acteurMaitreOuvrage.isActeurValid = true;
          }
          var arrRue = this.data_json['RueL'];
          if (Object(cgHtmlUtils_min["isNullOrUndefined"])(arrRue)) {
            goelandFormPodp_log.e('La liste des RueL est absente de la demande initiale');
            this.isDemandeInitialeROLoaded = false;
            this.isGuidValid = false;
          }
          for (var i = 0; i < arrRue.length; i++) {
            this.goodStreetIds.push(arrRue[i]['IdRueL']);
          }
          // traitement acteur liés "ActeurL": [{...}]
          // on doit recevoir au moins 1 entree dans ActeurL roles possibles sont beneficiaire et mandataire
          var arrActeurLie = this.data_json['ActeurL'];
          if (arrActeurLie.length > 1) {
            this.demandeInitialeRO.isBeneficiaireGiven = true;
            this.demandeInitialeRO.isMandataireGiven = true;
            this.demandeDataEnCours.acteurMandataire.isActeurValid = true;
            this.demandeDataEnCours.acteurBeneficiaire.isActeurValid = true;
            // si on a deux entrees on part du principe que c'est mandataire qui a fait demande
            // et on recherche lequel des deux entrees il s'agit
            if (arrActeurLie[0]['Role'] === 'Maître d\'ouvrage') {
              this.demandeInitialeRO.Mandataire = arrActeurLie[0];
              this.demandeInitialeRO.Beneficiaire = arrActeurLie[1];
              this.demandeDataEnCours.acteurMandataire.isActeurFromGoeland = true;
              this.demandeDataEnCours.acteurMandataire.idActeurFromGoeland = arrActeurLie[0]['IdActeur'];
              this.demandeDataEnCours.acteurBeneficiaire.isActeurFromGoeland = true;
              this.demandeDataEnCours.acteurBeneficiaire.idActeurFromGoeland = arrActeurLie[1]['IdActeur'];
            } else {
              this.demandeInitialeRO.Beneficiaire = arrActeurLie[0];
              this.demandeInitialeRO.Mandataire = arrActeurLie[1];
              this.demandeDataEnCours.acteurMandataire.isActeurFromGoeland = true;
              this.demandeDataEnCours.acteurMandataire.idActeurFromGoeland = arrActeurLie[1]['IdActeur'];
              this.demandeDataEnCours.acteurBeneficiaire.isActeurFromGoeland = true;
              this.demandeDataEnCours.acteurBeneficiaire.idActeurFromGoeland = arrActeurLie[0]['IdActeur'];
            }
          } else {
            // on a qu'un seul acteur lié
            if (arrActeurLie[0]['Role'] === 'Requérant') {
              this.demandeInitialeRO.isBeneficiaireGiven = true;
              this.demandeDataEnCours.acteurBeneficiaire.isActeurValid = true;
              this.demandeInitialeRO.Beneficiaire = arrActeurLie[0];
              this.demandeDataEnCours.acteurBeneficiaire.isActeurFromGoeland = true;
              this.demandeDataEnCours.acteurBeneficiaire.idActeurFromGoeland = arrActeurLie[0]['IdActeur'];
            } else {
              this.demandeInitialeRO.isMandataireGiven = true;
              this.demandeDataEnCours.acteurMandataire.isActeurValid = true;
              this.demandeInitialeRO.Mandataire = arrActeurLie[0];
              this.demandeDataEnCours.acteurMandataire.isActeurFromGoeland = true;
              this.demandeDataEnCours.acteurMandataire.idActeurFromGoeland = arrActeurLie[0]['IdActeur'];
            }
          }
          goelandFormPodp_log.l('## IN  goelandFormPodp.cacheInitialData before isNullOrUndefined(this.demandeDataEnCours.geometrieChantiersSaisie)', Object(cgHtmlUtils_min["isNullOrUndefined"])(this.demandeDataEnCours.geometrieChantiersSaisie));
          if (Object(cgHtmlUtils_min["isNullOrUndefined"])(this.demandeDataEnCours.geometrieChantiersSaisie)) {
            // on active la barre edition par defaut car pas de geometrie a priori
            this.isPolygonAlreadyPresentInGoeland = false;
            goelandFormPodp_log.l('## IN  goelandFormPodp.cacheInitialData before !isNullOrUndefined(this.data_json[\'GeomAffCoordChantier\'])', this.data_json['GeomAffCoordChantier']);

            if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(this.data_json['GeomAffCoordChantier']['features'])) {
              var arrFeatures = this.data_json['GeomAffCoordChantier']['features'];
              if (arrFeatures.length > 0) {
                goelandFormPodp_log.l('## IN  goelandFormPodp.cacheInitialData found ' + arrFeatures.length + ' features', arrFeatures);
                // on desactive la barre edition par defaut si la geometrie est fournie par coordination chantier
                this.demandeInitialeRO.geomAffCoordChantier = arrFeatures[0].geometry;
                this.isPolygonAlreadyPresentInGoeland = true;
                // this.demandeDataEnCours.geometrieChantiersSaisie = arrFeatures[0].geometry
              }
            }
          }
          this.demandeDataEnCours.id = this.idDemande;
          this.demandeDataEnCours.IdAffCoordChantier = this.demandeInitialeRO.IdAffCoordChantier;
          this.demandeDataEnCours.datecreated = null;
          // state management
          this.isDemandeInitialeROLoaded = true;
          this.isGuidValid = true;
        } catch (e) {
          goelandFormPodp_log.e('###  ERROR IN  goelandFormPodp.cacheInitialData while parsing json', e, demandePoDP.lastError);
          this.demandeDataEnCours.realGuid = '## ERREUR ## pendant la lecture de la demande initiale en JSON: ';
          this.demandeDataEnCours.realGuid += stringify_default()(dataref);
          this.isDemandeInitialeROLoaded = false;
          this.isGuidValid = false;
        }
      } else {
        goelandFormPodp_log.e('###  ERROR IN  goelandFormPodp.cacheInitialData [' + dataref + ']');
        goelandFormPodp_log.e('###  ERROR IN  goelandFormPodp.cacheInitialData : demandePoDP.lastError =', demandePoDP.lastError);
        if (stringify_default()(demandePoDP.lastError).indexOf('no records found') > 0) {
          this.demandeDataEnCours.realGuid = '## ERREUR ##  Aucune demande en cours avec pour cet identifiant !';
        } else {
          this.demandeDataEnCours.realGuid = '## ERREUR ##  [' + stringify_default()(demandePoDP.lastErrorMsg) + '] !';
        }
        goelandFormPodp_log.w(stringify_default()(demandePoDP.lastError));
        goelandFormPodp_log.e(demandePoDP.lastError);
        this.isDemandeInitialeROLoaded = false;
        this.isGuidValid = false;
      }
    },
    // end of cacheInitialData
    // cette methode sert a sauver temporairement les donnes du formulaire
    saveForm: function saveForm(event) {
      var _this5 = this;

      if (this.isdemandeDataEnCoursLoaded || !this.isDemandeAlreadysaved) {
        goelandFormPodp_log.l('### IN  goelandFormPodp.saveForm ');
        if (this.isGuidValid) {
          var savedData = {
            id: this.idDemande,
            demandeDataEnCours: this.demandeDataEnCours
          };
          if (event) {
            if (Object(cgHtmlUtils_min["functionExist"])(event.preventDefault)) event.preventDefault();
          }
          demandePoDP.saveDemande(this.demandeDataEnCours.realGuid, savedData, function (resp) {
            goelandFormPodp_log.l('### IN  goelandFormPodp.saveForm AFTER saveDemande : ', resp);
            if (stringify_default()(resp).indexOf('ERROR') > 0) {
              goelandFormPodp_log.e('### ERROR IN  goelandFormPodp.saveForm AFTER saveDemande : ', resp);
              goelandFormPodp_log.w('demandePoDP.lastError = ', demandePoDP.lastError);
              _this5.lastSavingError = '## ERREUR PENDANT LA SAUVEGARDE ! ## ' + demandePoDP.lastErrorMsg + ' [' + resp + '] !';
              _this5.isSavingError = true;
            } else {
              _this5.lastSavingError = '';
              _this5.isSavingError = false;
            }
          });
        } else {
          this.lastSavingError = '## IMPOSSIBLE DE SAUVER ce guid est invalide : ' + this.demandeDataEnCours.realGuid + '] !';
          this.isSavingError = true;
        }
      } else {
        goelandFormPodp_log.w('### IN  goelandFormPodp.saveForm NOT SAVING car isdemandeDataEnCoursLoaded est FAUX');
      }
    },
    submitForm: function submitForm(event) {
      var _this6 = this;

      if (this.isdemandeDataEnCoursLoaded || !this.isDemandeAlreadysaved) {
        goelandFormPodp_log.l('### IN  goelandFormPodp.submitForm ');
        if (this.isGuidValid) {
          this.demandeDataEnCours.isFinalSubmitDone = true;
          var savedData = {
            id: this.idDemande,
            demandeDataEnCours: this.demandeDataEnCours
          };
          if (event) {
            if (Object(cgHtmlUtils_min["functionExist"])(event.preventDefault)) event.preventDefault();
          }
          demandePoDP.submitDemande(this.demandeDataEnCours.realGuid, savedData, function (resp) {
            goelandFormPodp_log.l('### IN  goelandFormPodp.submitForm AFTER submitDemande : ', resp);
            if (stringify_default()(resp).indexOf('ERROR') > 0) {
              goelandFormPodp_log.e('### ERROR IN  goelandFormPodp.submitForm AFTER submitDemande : ', resp);
              goelandFormPodp_log.w('demandePoDP.lastError = ', demandePoDP.lastError);
              _this6.lastSavingError = '## ERREUR PENDANT L\'ENVOI DU FORMULAIRE ! ## ' + demandePoDP.lastErrorMsg + ' [' + resp + '] !';
              _this6.isSavingError = true;
            } else {
              _this6.lastSavingError = '';
              _this6.isSavingError = false;
              _this6.isSubmitToLocalDatabaseSuccessfull = true;
              // pour indiquer correctement la date dans la confirmation vu que l'on a pas le retour de la bd mais que c'est sauve
              var todayDate = new Date();
              _this6.demandeDataEnCours.datesubmited = todayDate.toLocaleString('fr');
            }
          });
        } else {
          this.lastSavingError = '## IMPOSSIBLE D\'ENVOYER CE FORMULAIRE ce guid est invalide : ' + this.demandeDataEnCours.realGuid + '] !';
          this.isSavingError = true;
        }
      } else {
        goelandFormPodp_log.w('### IN  goelandFormPodp.submitForm NOT SAVING car isdemandeDataEnCoursLoaded est FAUX');
      }
    },
    dateDebutUpdate: function dateDebutUpdate(val) {
      this.dateFinDisabled.to = val;
      this.datePickerHighlighted.to = val;
    },
    dateFinUpdate: function dateFinUpdate(val) {
      this.dateDebutDisabled.from = val;
      this.datePickerHighlighted.from = val;
    },
    dateDebutUpdateFouille: function dateDebutUpdateFouille(val) {
      this.dateFinDisabled_fouille.to = val;
      this.datePickerHighlighted_fouille.to = val;
    },
    dateFinUpdateFouille: function dateFinUpdateFouille(val) {
      this.dateDebutDisabled_fouille.from = val;
      this.datePickerHighlighted_fouille.from = val;
    },
    dateDebutUpdateStationnementNumMacarons: function dateDebutUpdateStationnementNumMacarons(val) {
      this.dateFinDisabled_StationnementNumMacarons.to = val;
      this.datePickerHighlighted_StationnementNumMacarons.to = val;
    },
    dateFinUpdateStationnementNumMacarons: function dateFinUpdateStationnementNumMacarons(val) {
      this.dateDebutDisabled_StationnementNumMacarons.from = val;
      this.datePickerHighlighted_StationnementNumMacarons.from = val;
    },
    dateDebutUpdateStationnementNumAutres: function dateDebutUpdateStationnementNumAutres(val) {
      this.dateFinDisabled_StationnementNumAutres.to = val;
      this.datePickerHighlighted_StationnementNumAutres.to = val;
    },
    dateFinUpdateStationnementNumAutres: function dateFinUpdateStationnementNumAutres(val) {
      this.dateDebutDisabled_StationnementNumAutres.from = val;
      this.datePickerHighlighted_StationnementNumAutres.from = val;
    },
    newStreetSelected: function newStreetSelected(val) {
      var _this7 = this;

      goelandFormPodp_log.l('## in goelandFormPodp.newStreetSelected :', val);
      if (Object(cgHtmlUtils_min["isNullOrUndefined"])(val)) {
        this.step1IsDone = false;
        this.isIdDemandeValid = false;
      } else {
        if (this.checkIsValidStreetId(val.value)) {
          this.step1IsDone = true;
          this.isIdDemandeValid = true;
          this.streetName = val.label;
          // let that = this
          // a timer seems to be the only way to get it working
          window.setTimeout(function () {
            // that.$refs.mapchantier.updateScreen()
          }, 1500);

          if (this.isDemandeAlreadysaved) {
            // let's get back the current data
            demandePoDP.getdemandeEnCours(this.idDemande, function (dataref) {
              goelandFormPodp_log.l('##****** IN demandePoDP.getdemandeEnCours callback', dataref);
              if (typeof dataref === 'string') {
                goelandFormPodp_log.e('## ERROR IN demandePoDP.getdemandeEnCours callback', dataref);
                _this7.isdemandeDataEnCoursLoaded = false;
              } else {
                _this7.demandeDataEnCours = JSON.parse(dataref['json_data']);
                _this7.demandeDataEnCours.datecreated = dataref['datecreated'];
                _this7.demandeDataEnCours.datelastmodif = dataref['datelastmodif'];
                _this7.demandeDataEnCours.datesubmited = dataref['datesubmited'];
                _this7.geometrieChantiersSaisiePrecedement = _this7.demandeDataEnCours.geometrieChantiersSaisie;
                if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(_this7.demandeDataEnCours.datesubmited)) {
                  _this7.isSubmitToLocalDatabaseSuccessfull = true;
                } else {
                  // this.$refs.mapchantier.updateScreen()
                }
                _this7.isdemandeDataEnCoursLoaded = true;
              }
            });
          }
        } else {
          this.step1IsDone = false;
          this.isIdDemandeValid = false;
        }
      }
      // this.streetSelected = val.value
    },
    checkIsValidStreetId: function checkIsValidStreetId(idStreet) {
      if (this.goodStreetIds.indexOf(idStreet) > -1 && this.demandeInitialeRO.id === this.idDemande) {
        goelandFormPodp_log.l('##++ in goelandFormPodp.checkIsValidStreetId VALID idStreet:', idStreet);
        return true;
      } else {
        goelandFormPodp_log.l('##-- in goelandFormPodp.checkIsValidStreetId INVALID idStreet:', idStreet);
        return false;
      }
    },

    saveGeometry: function saveGeometry(val) {
      goelandFormPodp_log.l('##++ in goelandFormPodp.saveGeometry cgil-vue-olmap event gomapSaveGeomClick received : ', val);
      this.demandeDataEnCours.geometrieChantiersSaisie = val;
    },
    adjustMap: function adjustMap(val) {
      goelandFormPodp_log.l('##++ in goelandFormPodp.adjustMap goCollapse event gocollapseOpen received : ', val);
      this.showMap = true;
      // 2018-05-03 cgil commented out next line because it breaks map display component when collapse is false and reveals underlying content
      // this.$refs.mapchantier.updateScreen()
    },
    getViewUrl: function getViewUrl() {
      return '/#/view/' + this.demandeDataEnCours.realGuid;
    } // end of methods section
  } });
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5adbfe22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/goelandFormPodp.vue
var goelandFormPodp_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isItDevEnv)?_c('div',{},[_vm._v("\n      isGuidNull = "+_vm._s(_vm.isGuidNull)),_c('br'),_vm._v("\n      guid = "+_vm._s(_vm.guid)),_c('br'),_vm._v("\n      isDemandeInitialeROLoaded = "+_vm._s(_vm.isDemandeInitialeROLoaded)),_c('br'),_vm._v("\n      step1IsDone = "+_vm._s(_vm.step1IsDone)),_c('br'),_vm._v("\n      isIdDemandeValid = "+_vm._s(_vm.isIdDemandeValid)),_c('br'),_vm._v("\n      isGuidValid = "+_vm._s(_vm.isGuidValid)),_c('br'),_vm._v("\n      streetSelected = "+_vm._s(_vm.streetSelected)),_c('br'),_vm._v("\n      geometrieWKT = "+_vm._s(_vm.demandeDataEnCours.geometrieChantiersSaisie)+"\n    ")]):_vm._e(),_vm._v(" "),(!_vm.isDemandeInitialeROLoaded && !_vm.isGuidNull)?_c('p',[_vm._v("Veuillez patienter, récupération de la demande numéro : "+_vm._s(_vm.guid))]):_vm._e(),_vm._v(" "),(!_vm.isGuidValid && !_vm.isGuidNull)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('p',[_vm._v(_vm._s(_vm.demandeDataEnCours.realGuid))])]):_vm._e(),_vm._v(" "),(_vm.isSavingError)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('p',[_vm._v(_vm._s(_vm.lastSavingError))])]):_vm._e(),_vm._v(" "),(_vm.isDemandeInitialeROLoaded)?_c('p',[_vm._v("guid effectif : ["+_vm._s(_vm.demandeDataEnCours.realGuid)+"] créé le : "+_vm._s(_vm.demandeInitialeRO.datecreated))]):_vm._e(),_vm._v(" "),_c('go-collapse',{directives:[{name:"show",rawName:"v-show",value:(_vm.isGuidValid),expression:"isGuidValid"}],attrs:{"title":_vm.step1Msg,"open":!_vm.step1IsDone && _vm.isGuidValid,"done":_vm.step1IsDone,"disabled":!_vm.isGuidValid}},[_c('form',{attrs:{"id":"goform-step1","action":"#"}},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"idaff"}},[_vm._v("identifiant reçu par email: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.idDemande),expression:"idDemande"}],staticClass:"form-control",attrs:{"type":"number","id":"idaff","min":"1","max":"9999999","maxlength":"7","tabindex":"1","disabled":""},domProps:{"value":(_vm.idDemande)},on:{"input":function($event){if($event.target.composing){ return; }_vm.idDemande=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"listStreets"}},[_vm._v("choisissez la rue en relation avec cette demande: ")]),_vm._v(" "),_c('v-select',{attrs:{"id":"listStreets","tabindex":"2","options":_vm.streetList,"on-change":_vm.newStreetSelected,"placeholder":"Veuillez choisir une rue ...","label":"label"},model:{value:(_vm.streetSelected),callback:function ($$v) {_vm.streetSelected=$$v},expression:"streetSelected"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.streetSelected))])],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('p',[_vm._v("\n        En cas de problème, n'hésitez pas à nous contacter."),_c('br'),_vm._v("\n        Nous répondons à vos appels du lundi au vendredi, de 08h00 à 11h30 et de 14h00 à 16h00."),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Service de la mobilité et de l’aménagement des espaces publics")]),_c('br'),_vm._v("\n        Surveillance du domaine public"),_c('br'),_c('br'),_vm._v("\n        Téléphones  "),_c('a',{attrs:{"href":"tel:+41213155412"}},[_vm._v("+41 21 315  5412")]),_vm._v(" ou  "),_c('a',{attrs:{"href":"tel:+41213155262"}},[_vm._v("5262")]),_c('br'),_vm._v("\n        E-mail "),_c('a',{attrs:{"href":"mailto:podp@lausanne.ch"}},[_vm._v("podp@lausanne.ch")]),_c('br')])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isIdDemandeValid && !_vm.isSubmitToLocalDatabaseSuccessfull),expression:"isIdDemandeValid && !isSubmitToLocalDatabaseSuccessfull"}],attrs:{"id":"questions"}},[_c('go-collapse',{attrs:{"title":_vm.step2Msg,"open":_vm.step1IsDone && !_vm.demandeDataEnCours.step2IsDone,"disabled":!_vm.isIdDemandeValid,"done":_vm.demandeDataEnCours.step2IsDone}},[_c('div',{staticClass:"form-group col-md-6"},[_c('h4',[_vm._v(_vm._s(_vm.demandeInitialeRO.id)+"/"+_vm._s(_vm.streetName))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.demandeInitialeRO.nomAffaire))]),_vm._v(" "),_c('p',[_vm._v("\n              L'inspecteur des chantiers de la Ville en charge de l'affaire est :\n              "),_c('strong',[_vm._v("M."+_vm._s(_vm.demandeInitialeRO.responsableVdL))])]),_vm._v(" "),(_vm.demandeInitialeRO.itWasUnAuthorizedOccupacy)?_c('h5',[_c('strong',[_vm._v("il s'agit d'une demande effectuée suite à une occupation non autorisée")])]):_vm._e(),_vm._v(" "),(_vm.demandeInitialeRO.BPayant)?_c('h5',[_vm._v("Ce permis sera "),_c('strong',[_vm._v("payant")])]):_c('h5',[_vm._v("Ce permis sera gratuit")]),_vm._v(" "),(_vm.isDemandeInitialeROLoaded)?_c('div',[_c('go-collapse-acteur-role-details',{attrs:{"acteurReference":_vm.demandeInitialeRO.Mandataire}}),_vm._v(" "),_c('go-collapse-acteur-role-details',{attrs:{"acteurReference":_vm.demandeInitialeRO.Beneficiaire}}),_vm._v(" "),_c('go-collapse-acteur-role-details',{attrs:{"acteurReference":_vm.demandeInitialeRO.MaitreOuvrage}},[_vm._v("\n                Affaire Coordination : "+_vm._s(_vm.demandeInitialeRO.IdAffCoordChantier)+" / "+_vm._s(_vm.demandeInitialeRO.nomAffCoordChantier)+"\n              ")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('fieldset',[_c('legend',[_vm._v("Vos informations de contact ")]),_vm._v(" "),_c('h5',[_vm._v("le permis d'occupation temporaire du domaine public sera envoyé à "),_c('strong',[_vm._v(_vm._s(_vm.demandeDataEnCours.affClientEmail))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"affClientContact"}},[_vm._v("Prénom Nom:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.affClientContact),expression:"demandeDataEnCours.affClientContact"}],staticClass:"form-control",attrs:{"type":"text","id":"affClientContact","placeholder":"Email"},domProps:{"value":(_vm.demandeDataEnCours.affClientContact)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "affClientContact", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"affClientTelephone"}},[_vm._v("Numéro de téléphone :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.affClientTelephone),expression:"demandeDataEnCours.affClientTelephone"}],staticClass:"form-control",attrs:{"type":"tel","id":"affClientTelephone","placeholder":"Téléphone"},domProps:{"value":(_vm.demandeDataEnCours.affClientTelephone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "affClientTelephone", $event.target.value)}}})])]),_vm._v(" "),(_vm.demandeDataEnCours.IsContactPoliceDone)?[_c('div',{staticClass:"col-sm-12 cg-button-next"},[_c('el-button',{staticClass:"pull-right",attrs:{"type":"primary","disabled":!_vm.isStep2Valid},on:{"click":function($event){_vm.saveForm($event);_vm.demandeDataEnCours.step2IsDone=true;}}},[_vm._v("\n                    SUIVANT"),_c('i',{staticClass:"el-icon-arrow-right el-icon-right"})])],1)]:_vm._e()],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDataEnCours.IsContactPoliceDone && _vm.demandeDataEnCours.step2IsDone),expression:"demandeDataEnCours.IsContactPoliceDone && demandeDataEnCours.step2IsDone"}]},[_c('go-collapse',{attrs:{"title":_vm.step4Msg,"open":_vm.demandeDataEnCours.step2IsDone && !_vm.demandeDataEnCours.step4IsDone,"disabled":!_vm.isStep3Valid,"done":_vm.demandeDataEnCours.step4IsDone},on:{"gocollapseOpen":_vm.adjustMap}},[_c('form',{attrs:{"id":"goform-step4","action":"#"}},[_c('div',{staticClass:"form-group col-md-12"},[(_vm.isPolygonAlreadyPresentInGoeland)?_c('p',[_vm._v("Le périmètre des travaux a déjà été saisi par un service communal, il ne peut pas être modifié.")]):_vm._e(),_vm._v(" "),(!_vm.isPolygonAlreadyPresentInGoeland)?_c('p',[_vm._v("Veuillez dessiner ci-dessous le-s périmètre-s que vous souhaitez occuper.")]):_vm._e(),_vm._v(" "),(_vm.showMap)?_c('div',[_c('cgil-ol-map',{ref:"mapchantier",staticStyle:{"height":"800px","width":"100%"},attrs:{"edit-geom-enabled":!_vm.isPolygonAlreadyPresentInGoeland,"center":_vm.center,"zoom":8,"layers-config":_vm.mapLayers,"geomGeoJSON":_vm.demandeInitialeRO.geomAffCoordChantier,"geomWkt":_vm.geometrieChantiersSaisiePrecedement},on:{"gomapSaveGeomClick":_vm.saveGeometry}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6",attrs:{"id":"divcommentaireLocalisation"}},[_c('div',{},[_c('label',{staticClass:"control-label",attrs:{"for":"commentaireLocalisation"}},[_vm._v("Remarque : ")])]),_vm._v(" "),_c('div',{},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.commentaireLocalisation),expression:"demandeDataEnCours.commentaireLocalisation"}],staticClass:"form-control",attrs:{"rows":"3","id":"commentaireLocalisation","type":"text"},domProps:{"value":(_vm.demandeDataEnCours.commentaireLocalisation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "commentaireLocalisation", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6",attrs:{"id":"divdescriptionTravaux"}},[_c('div',{},[_c('label',{staticClass:"control-label",attrs:{"for":"descriptionTravaux"}},[_vm._v("* Description des travaux: ")])]),_vm._v(" "),_c('div',{},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.descriptionTravaux),expression:"demandeDataEnCours.descriptionTravaux"}],staticClass:"form-control",attrs:{"rows":"3","id":"descriptionTravaux","placeholder":"Veuillez SVP saisir la description des travaux prévus","type":"text"},domProps:{"value":(_vm.demandeDataEnCours.descriptionTravaux)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "descriptionTravaux", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",attrs:{"id":"divDatBegin"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"dateDebutOccupation"}},[_vm._v("\n                  * Date de début :\n                ")]),_vm._v(" "),_c('datepicker',{attrs:{"id":"dateDebutOccupation","language":"fr","full-month-name":true,"bootstrapStyling":true,"mondayFirst":true,"disabled":_vm.dateDebutDisabled,"highlighted":_vm.datePickerHighlighted},on:{"selected":_vm.dateDebutUpdate},model:{value:(_vm.demandeDataEnCours.dateDebutOccupation),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "dateDebutOccupation", $$v)},expression:"demandeDataEnCours.dateDebutOccupation"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",attrs:{"id":"divDateEnd"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"dateFinOccupation"}},[_vm._v("\n                  * Date de fin :\n                ")]),_vm._v(" "),_c('datepicker',{attrs:{"id":"dateFinOccupation","language":"fr","full-month-name":true,"bootstrapStyling":true,"mondayFirst":true,"disabled":_vm.dateFinDisabled,"highlighted":_vm.datePickerHighlighted},on:{"selected":_vm.dateFinUpdate},model:{value:(_vm.demandeDataEnCours.dateFinOccupation),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "dateFinOccupation", $$v)},expression:"demandeDataEnCours.dateFinOccupation"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-alert',{attrs:{"closable":false,"type":"step4ValidationType","title":_vm.step4ValidationText}}),_vm._v(" "),_c('el-button',{staticClass:"pull-right",attrs:{"type":"primary","disabled":!_vm.isStep4Valid},on:{"click":function($event){_vm.saveForm($event);_vm.demandeDataEnCours.step4IsDone=true;}}},[_vm._v("\n               SUIVANT"),_c('i',{staticClass:"el-icon-arrow-right el-icon-right"})])],1)])]),_vm._v(" "),_c('go-collapse',{attrs:{"title":_vm.step5Msg,"open":_vm.demandeDataEnCours.step4IsDone && !_vm.demandeDataEnCours.step5IsDone,"disabled":!_vm.isStep4Valid,"done":_vm.demandeDataEnCours.step5IsDone}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',{attrs:{"for":"isFouilleOuForage"}},[_vm._v("Souhaitez-vous effectuer des travaux de fouilles et/ou de forages sur le domaine public ?")]),_vm._v(" "),_c('go-switch',{staticClass:"pull-right",attrs:{"id":"isFouilleOuForage"},model:{value:(_vm.demandeDataEnCours.isFouilleOuForage),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "isFouilleOuForage", $$v)},expression:"demandeDataEnCours.isFouilleOuForage"}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.demandeDataEnCours.isFouilleOuForage)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('fieldset',{staticClass:"fouille-fieldset"},[_c('legend',{staticClass:"fouille-legend"},[_vm._v("Fouille numéro 1 :")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLongueur01),expression:"demandeDataEnCours.fouilleLongueur01"}],attrs:{"type":"number","min":"0","id":"fouilleLongueur01","placeholder":"Longueur en m"},domProps:{"value":(_vm.demandeDataEnCours.fouilleLongueur01)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLongueur01", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLargeur01),expression:"demandeDataEnCours.fouilleLargeur01"}],attrs:{"type":"number","min":"0","id":"fouilleLargeur01","placeholder":"Largeur en m"},domProps:{"value":(_vm.demandeDataEnCours.fouilleLargeur01)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLargeur01", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_vm._v("Surface = "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.calculSurface01))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('fieldset',{staticClass:"fouille-fieldset"},[_c('legend',{staticClass:"fouille-legend"},[_vm._v("Fouille numéro 2 :")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLongueur02),expression:"demandeDataEnCours.fouilleLongueur02"}],attrs:{"type":"number","min":"0","id":"fouilleLongueur02","placeholder":"Longueur en m"},domProps:{"value":(_vm.demandeDataEnCours.fouilleLongueur02)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLongueur02", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLargeur02),expression:"demandeDataEnCours.fouilleLargeur02"}],attrs:{"type":"number","min":"0","id":"fouilleLargeur02","placeholder":"Largeur en m"},domProps:{"value":(_vm.demandeDataEnCours.fouilleLargeur02)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLargeur02", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_vm._v("Surface = "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.calculSurface02))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('fieldset',{staticClass:"fouille-fieldset"},[_c('legend',{staticClass:"fouille-legend"},[_vm._v("Fouille numéro 3 :")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLongueur03),expression:"demandeDataEnCours.fouilleLongueur03"}],attrs:{"type":"number","min":"0","id":"fouilleLongueur03","placeholder":"Longueur en m"},domProps:{"value":(_vm.demandeDataEnCours.fouilleLongueur03)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLongueur03", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLargeur03),expression:"demandeDataEnCours.fouilleLargeur03"}],attrs:{"type":"number","min":"0","id":"fouilleLargeur03","placeholder":"Largeur en m"},domProps:{"value":(_vm.demandeDataEnCours.fouilleLargeur03)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLargeur03", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_vm._v("Surface = "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.calculSurface03))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('fieldset',{staticClass:"fouille-fieldset"},[_c('legend',{staticClass:"fouille-legend"},[_vm._v("Fouille numéro 4 :")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLongueur04),expression:"demandeDataEnCours.fouilleLongueur04"}],attrs:{"type":"number","min":"0","id":"fouilleLongueur04","placeholder":"Longueur en m"},domProps:{"value":(_vm.demandeDataEnCours.fouilleLongueur04)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLongueur04", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLargeur04),expression:"demandeDataEnCours.fouilleLargeur04"}],attrs:{"type":"number","min":"0","id":"fouilleLargeur04","placeholder":"Largeur en m"},domProps:{"value":(_vm.demandeDataEnCours.fouilleLargeur04)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLargeur04", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_vm._v("Surface = "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.calculSurface04))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h4',{staticClass:"pull-right"},[_vm._v("Surface Totale =  "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.calculSurfaceTotal))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"col-sm-6",attrs:{"id":"divDatBegin"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"fouilleDateDebut"}},[_vm._v("\n                    * Date de début :\n                  ")]),_vm._v(" "),_c('datepicker',{attrs:{"id":"fouilleDateDebut","language":"fr","full-month-name":true,"bootstrapStyling":true,"mondayFirst":true,"disabled":_vm.dateDebutDisabled_fouille,"highlighted":_vm.datePickerHighlighted_fouille},on:{"selected":_vm.dateDebutUpdateFouille},model:{value:(_vm.demandeDataEnCours.fouilleDateDebut),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "fouilleDateDebut", $$v)},expression:"demandeDataEnCours.fouilleDateDebut"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",attrs:{"id":"divDateEnd"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"fouilleDateFin"}},[_vm._v("\n                    * Date de fin :\n                  ")]),_vm._v(" "),_c('datepicker',{attrs:{"id":"fouilleDateFin","language":"fr","full-month-name":true,"bootstrapStyling":true,"mondayFirst":true,"disabled":_vm.dateFinDisabled_fouille,"highlighted":_vm.datePickerHighlighted_fouille},on:{"selected":_vm.dateFinUpdateFouille},model:{value:(_vm.demandeDataEnCours.fouilleDateFin),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "fouilleDateFin", $$v)},expression:"demandeDataEnCours.fouilleDateFin"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('label',{attrs:{"for":"isFouilleSurChaussee"}},[_vm._v("Ces travaux se situent-ils sur la chaussée ?")]),_vm._v(" "),_c('go-switch',{staticClass:"pull-right",attrs:{"id":"isFouilleSurChaussee"},model:{value:(_vm.demandeDataEnCours.isFouilleSurChaussee),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "isFouilleSurChaussee", $$v)},expression:"demandeDataEnCours.isFouilleSurChaussee"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('label',{attrs:{"for":"isFouilleSurTrotoir"}},[_vm._v("Ces travaux se situent-ils sur un trottoir ?")]),_vm._v(" "),_c('go-switch',{staticClass:"pull-right",attrs:{"id":"isFouilleSurTrotoir"},model:{value:(_vm.demandeDataEnCours.isFouilleSurTrotoir),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "isFouilleSurTrotoir", $$v)},expression:"demandeDataEnCours.isFouilleSurTrotoir"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('label',{attrs:{"for":"isFouilleEndomageBalisageSol"}},[_vm._v("Ces travaux endommageront-ils le balisage au sol ?")]),_vm._v(" "),_c('go-switch',{staticClass:"pull-right",attrs:{"id":"isFouilleEndomageBalisageSol"},model:{value:(_vm.demandeDataEnCours.isFouilleEndomageBalisageSol),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "isFouilleEndomageBalisageSol", $$v)},expression:"demandeDataEnCours.isFouilleEndomageBalisageSol"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('label',{attrs:{"for":"isFouilleSurZonePavee"}},[_vm._v("Ces travaux se situent-ils sur une zone pavée ?")]),_vm._v(" "),_c('go-switch',{staticClass:"pull-right",attrs:{"id":"isFouilleSurZonePavee"},model:{value:(_vm.demandeDataEnCours.isFouilleSurZonePavee),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "isFouilleSurZonePavee", $$v)},expression:"demandeDataEnCours.isFouilleSurZonePavee"}})],1),_vm._v(" "),(_vm.demandeDataEnCours.isFouilleSurZonePavee)?_c('div',{staticClass:"col-sm-12"},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"text-item"},[_vm._v("\n                L’unité travaux peut réaliser les travaux de réfection de la zone pavée,\n                devis sur demande auprès de\n                "),_c('a',{attrs:{"href":"mailto:mapunitetravaux@lausanne.ch"}},[_vm._v("mapunitetravaux@lausanne.ch")]),_vm._v(".\n                Le permis d’occupation et sa facturation seront adaptés en conséquence.\n              ")])])],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-alert',{attrs:{"closable":false,"type":"step5ValidationType","title":_vm.step5ValidationText}}),_vm._v(" "),_c('el-button',{staticClass:"pull-right",attrs:{"type":"primary","disabled":!_vm.isStep5Valid},on:{"click":function($event){_vm.saveForm($event);_vm.demandeDataEnCours.step5IsDone=true;}}},[_vm._v("\n               SUIVANT"),_c('i',{staticClass:"el-icon-arrow-right el-icon-right"})])],1)]),_vm._v(" "),_c('go-collapse',{attrs:{"title":_vm.step6Msg,"open":_vm.demandeDataEnCours.step5IsDone && !_vm.demandeDataEnCours.step6IsDone,"disabled":!_vm.isStep4Valid,"done":_vm.demandeDataEnCours.step6IsDone}},[_c('label',{attrs:{"for":"isOccupationDP"}},[_vm._v("Hormis les éventuelles fouilles et/ou forages, souhaitez-vous occuper le domaine public ?")]),_vm._v(" "),_c('go-switch',{staticClass:"pull-right",attrs:{"id":"isOccupationDP"},model:{value:(_vm.demandeDataEnCours.isOccupationDP),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "isOccupationDP", $$v)},expression:"demandeDataEnCours.isOccupationDP"}}),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.demandeDataEnCours.isOccupationDP)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-sm-12"},[_c('fieldset',{staticClass:"fouille-fieldset"},[_c('legend',{staticClass:"fouille-legend"},[_vm._v("Taille occupation :")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.occupationDPLongueur01),expression:"demandeDataEnCours.occupationDPLongueur01"}],attrs:{"type":"number","min":"0","id":"occupationDPLongueur01","placeholder":"Longueur en m"},domProps:{"value":(_vm.demandeDataEnCours.occupationDPLongueur01)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "occupationDPLongueur01", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.occupationDPLargeur01),expression:"demandeDataEnCours.occupationDPLargeur01"}],attrs:{"type":"number","min":"0","id":"occupationDPLargeur01","placeholder":"Largeur en m"},domProps:{"value":(_vm.demandeDataEnCours.occupationDPLargeur01)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "occupationDPLargeur01", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_vm._v("Surface = "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.calculSurfaceOccupationDP01))])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-sm-12"},[_c('label',[_vm._v("Veuillez cocher le-s type-s d'occupation souhaité-s")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_Benne),expression:"demandeDataEnCours.isOccupation_Benne"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_Benne)?_vm._i(_vm.demandeDataEnCours.isOccupation_Benne,null)>-1:(_vm.demandeDataEnCours.isOccupation_Benne)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_Benne,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_Benne", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_Benne", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_Benne", $$c)}}}}),_vm._v(" Benne\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_DepotMateriel),expression:"demandeDataEnCours.isOccupation_DepotMateriel"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_DepotMateriel)?_vm._i(_vm.demandeDataEnCours.isOccupation_DepotMateriel,null)>-1:(_vm.demandeDataEnCours.isOccupation_DepotMateriel)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_DepotMateriel,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_DepotMateriel", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_DepotMateriel", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_DepotMateriel", $$c)}}}}),_vm._v(" Dépôt de matériel\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_DepotEnginsChantier),expression:"demandeDataEnCours.isOccupation_DepotEnginsChantier"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_DepotEnginsChantier)?_vm._i(_vm.demandeDataEnCours.isOccupation_DepotEnginsChantier,null)>-1:(_vm.demandeDataEnCours.isOccupation_DepotEnginsChantier)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_DepotEnginsChantier,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_DepotEnginsChantier", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_DepotEnginsChantier", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_DepotEnginsChantier", $$c)}}}}),_vm._v(" Dépôt d'engins de chantier\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_PalissadeOuClotureChantier),expression:"demandeDataEnCours.isOccupation_PalissadeOuClotureChantier"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_PalissadeOuClotureChantier)?_vm._i(_vm.demandeDataEnCours.isOccupation_PalissadeOuClotureChantier,null)>-1:(_vm.demandeDataEnCours.isOccupation_PalissadeOuClotureChantier)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_PalissadeOuClotureChantier,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_PalissadeOuClotureChantier", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_PalissadeOuClotureChantier", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_PalissadeOuClotureChantier", $$c)}}}}),_vm._v("  Palissade / Clôture de chantier\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_RoulotteOuContainer),expression:"demandeDataEnCours.isOccupation_RoulotteOuContainer"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_RoulotteOuContainer)?_vm._i(_vm.demandeDataEnCours.isOccupation_RoulotteOuContainer,null)>-1:(_vm.demandeDataEnCours.isOccupation_RoulotteOuContainer)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_RoulotteOuContainer,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_RoulotteOuContainer", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_RoulotteOuContainer", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_RoulotteOuContainer", $$c)}}}}),_vm._v(" Roulotte / Container de chantier\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_CamionNacelle),expression:"demandeDataEnCours.isOccupation_CamionNacelle"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_CamionNacelle)?_vm._i(_vm.demandeDataEnCours.isOccupation_CamionNacelle,null)>-1:(_vm.demandeDataEnCours.isOccupation_CamionNacelle)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_CamionNacelle,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_CamionNacelle", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_CamionNacelle", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_CamionNacelle", $$c)}}}}),_vm._v(" Camion nacelle\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_CamionGrue),expression:"demandeDataEnCours.isOccupation_CamionGrue"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_CamionGrue)?_vm._i(_vm.demandeDataEnCours.isOccupation_CamionGrue,null)>-1:(_vm.demandeDataEnCours.isOccupation_CamionGrue)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_CamionGrue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_CamionGrue", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_CamionGrue", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_CamionGrue", $$c)}}}}),_vm._v("  Camion grue\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_Grue),expression:"demandeDataEnCours.isOccupation_Grue"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_Grue)?_vm._i(_vm.demandeDataEnCours.isOccupation_Grue,null)>-1:(_vm.demandeDataEnCours.isOccupation_Grue)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_Grue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_Grue", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_Grue", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_Grue", $$c)}}}}),_vm._v(" Grue\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_ChauffageMobile),expression:"demandeDataEnCours.isOccupation_ChauffageMobile"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_ChauffageMobile)?_vm._i(_vm.demandeDataEnCours.isOccupation_ChauffageMobile,null)>-1:(_vm.demandeDataEnCours.isOccupation_ChauffageMobile)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_ChauffageMobile,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_ChauffageMobile", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_ChauffageMobile", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_ChauffageMobile", $$c)}}}}),_vm._v(" Chauffage mobile\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_Echafaudage),expression:"demandeDataEnCours.isOccupation_Echafaudage"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_Echafaudage)?_vm._i(_vm.demandeDataEnCours.isOccupation_Echafaudage,null)>-1:(_vm.demandeDataEnCours.isOccupation_Echafaudage)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_Echafaudage,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_Echafaudage", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_Echafaudage", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_Echafaudage", $$c)}}}}),_vm._v("  Echafaudage\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_ElagageArbre),expression:"demandeDataEnCours.isOccupation_ElagageArbre"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_ElagageArbre)?_vm._i(_vm.demandeDataEnCours.isOccupation_ElagageArbre,null)>-1:(_vm.demandeDataEnCours.isOccupation_ElagageArbre)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_ElagageArbre,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_ElagageArbre", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_ElagageArbre", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_ElagageArbre", $$c)}}}}),_vm._v(" Elagage d'arbre\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_Etayage),expression:"demandeDataEnCours.isOccupation_Etayage"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_Etayage)?_vm._i(_vm.demandeDataEnCours.isOccupation_Etayage,null)>-1:(_vm.demandeDataEnCours.isOccupation_Etayage)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_Etayage,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_Etayage", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_Etayage", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_Etayage", $$c)}}}}),_vm._v(" Etayage\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_PontRoulant),expression:"demandeDataEnCours.isOccupation_PontRoulant"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_PontRoulant)?_vm._i(_vm.demandeDataEnCours.isOccupation_PontRoulant,null)>-1:(_vm.demandeDataEnCours.isOccupation_PontRoulant)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_PontRoulant,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_PontRoulant", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_PontRoulant", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_PontRoulant", $$c)}}}}),_vm._v("  Pont roulant\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_AccesChantier),expression:"demandeDataEnCours.isOccupation_AccesChantier"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_AccesChantier)?_vm._i(_vm.demandeDataEnCours.isOccupation_AccesChantier,null)>-1:(_vm.demandeDataEnCours.isOccupation_AccesChantier)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_AccesChantier,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_AccesChantier", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_AccesChantier", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_AccesChantier", $$c)}}}}),_vm._v(" Accès chantier\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_GroupeElectrogene),expression:"demandeDataEnCours.isOccupation_GroupeElectrogene"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_GroupeElectrogene)?_vm._i(_vm.demandeDataEnCours.isOccupation_GroupeElectrogene,null)>-1:(_vm.demandeDataEnCours.isOccupation_GroupeElectrogene)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_GroupeElectrogene,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_GroupeElectrogene", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_GroupeElectrogene", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_GroupeElectrogene", $$c)}}}}),_vm._v(" Groupe électrogène\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.isOccupation_PoseDeposeModificationEnseigne),expression:"demandeDataEnCours.isOccupation_PoseDeposeModificationEnseigne"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.demandeDataEnCours.isOccupation_PoseDeposeModificationEnseigne)?_vm._i(_vm.demandeDataEnCours.isOccupation_PoseDeposeModificationEnseigne,null)>-1:(_vm.demandeDataEnCours.isOccupation_PoseDeposeModificationEnseigne)},on:{"change":function($event){var $$a=_vm.demandeDataEnCours.isOccupation_PoseDeposeModificationEnseigne,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_PoseDeposeModificationEnseigne", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.demandeDataEnCours, "isOccupation_PoseDeposeModificationEnseigne", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.demandeDataEnCours, "isOccupation_PoseDeposeModificationEnseigne", $$c)}}}}),_vm._v("\n                    Pose / dépose / modification d’enseigne ou de support d’affichage\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('label',{staticClass:"goOccupationCheckbox",staticStyle:{"font-weight":"normal"},attrs:{"for":"Occupation_Autre"}},[_vm._v("Autre : ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.Occupation_Autre),expression:"demandeDataEnCours.Occupation_Autre"}],staticClass:"form-control",staticStyle:{"display":"inline-block","width":"75%"},attrs:{"type":"text","id":"Occupation_Autre","placeholder":"indiquez le type d'occupation"},domProps:{"value":(_vm.demandeDataEnCours.Occupation_Autre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "Occupation_Autre", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-alert',{attrs:{"closable":false,"type":"step6ValidationType","title":_vm.step6ValidationText}}),_vm._v(" "),_c('el-button',{staticClass:"pull-right",attrs:{"type":"primary","disabled":!_vm.isStep6Valid},on:{"click":function($event){_vm.saveForm($event);_vm.demandeDataEnCours.step6IsDone=true;}}},[_vm._v("\n               SUIVANT"),_c('i',{staticClass:"el-icon-arrow-right el-icon-right"})])],1)],1),_vm._v(" "),_c('go-collapse',{attrs:{"title":_vm.step7Msg,"open":_vm.demandeDataEnCours.step6IsDone && !_vm.demandeDataEnCours.step7IsDone,"disabled":!_vm.isStep6Valid,"done":_vm.demandeDataEnCours.step7IsDone}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',{attrs:{"for":"isStationnementPresent"}},[_vm._v("Souhaitez-vous occuper des places de stationnement situées sur le domaine public ?")]),_vm._v(" "),_c('go-switch',{staticClass:"pull-right",attrs:{"id":"isStationnementPresent"},model:{value:(_vm.demandeDataEnCours.isStationnementPresent),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "isStationnementPresent", $$v)},expression:"demandeDataEnCours.isStationnementPresent"}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.demandeDataEnCours.isStationnementPresent)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"StationnementNumMacarons"}},[_vm._v("Nombre de places autorisées aux macarons ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.StationnementNumMacarons),expression:"demandeDataEnCours.StationnementNumMacarons"}],attrs:{"type":"number","min":"0","id":"StationnementNumMacarons"},domProps:{"value":(_vm.demandeDataEnCours.StationnementNumMacarons)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "StationnementNumMacarons", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDataEnCours.StationnementNumMacarons > 0),expression:"demandeDataEnCours.StationnementNumMacarons > 0"}],staticClass:"col-sm-6",attrs:{"id":"divDateBeginStationnementNumMacarons"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"dateDebutOccupationStationnementNumMacarons"}},[_vm._v("\n                    Date de début :\n                  ")]),_vm._v(" "),_c('datepicker',{attrs:{"id":"dateDebutOccupationStationnementNumMacarons","language":"fr","full-month-name":true,"bootstrapStyling":true,"mondayFirst":true,"disabled":_vm.dateDebutDisabled_StationnementNumMacarons,"highlighted":_vm.datePickerHighlighted_StationnementNumMacarons},on:{"selected":_vm.dateDebutUpdateStationnementNumMacarons},model:{value:(_vm.demandeDataEnCours.StationnementNumMacarons_date_debut),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "StationnementNumMacarons_date_debut", $$v)},expression:"demandeDataEnCours.StationnementNumMacarons_date_debut"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDataEnCours.StationnementNumMacarons > 0),expression:"demandeDataEnCours.StationnementNumMacarons > 0"}],staticClass:"col-sm-6",attrs:{"id":"divDateEndStationnementNumMacarons"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"dateFinOccupationStationnementNumMacarons"}},[_vm._v("\n                    Date de fin :\n                  ")]),_vm._v(" "),_c('datepicker',{attrs:{"id":"dateFinOccupationOccupationStationnementNumMacarons","language":"fr","full-month-name":true,"bootstrapStyling":true,"mondayFirst":true,"disabled":_vm.dateFinDisabled_StationnementNumMacarons,"highlighted":_vm.datePickerHighlighted_StationnementNumMacarons},on:{"selected":_vm.dateFinUpdateStationnementNumMacarons},model:{value:(_vm.demandeDataEnCours.StationnementNumMacarons_date_fin),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "StationnementNumMacarons_date_fin", $$v)},expression:"demandeDataEnCours.StationnementNumMacarons_date_fin"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"StationnementNumAutres"}},[_vm._v("Nombre d'autres places")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.StationnementNumAutres),expression:"demandeDataEnCours.StationnementNumAutres"}],attrs:{"type":"number","min":"0","id":"StationnementNumAutres"},domProps:{"value":(_vm.demandeDataEnCours.StationnementNumAutres)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "StationnementNumAutres", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDataEnCours.StationnementNumAutres >0),expression:"demandeDataEnCours.StationnementNumAutres >0"}],staticClass:"col-sm-6",attrs:{"id":"divDateBeginStationnementNumMacarons"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"dateDebutOccupationStationnementNumAutres"}},[_vm._v("\n                    Date de début :\n                  ")]),_vm._v(" "),_c('datepicker',{attrs:{"id":"dateDebutOccupationStationnementNumAutres","language":"fr","full-month-name":true,"bootstrapStyling":true,"mondayFirst":true,"disabled":_vm.dateDebutDisabled_StationnementNumAutres,"highlighted":_vm.datePickerHighlighted_StationnementNumAutres},on:{"selected":_vm.dateDebutUpdateStationnementNumAutres},model:{value:(_vm.demandeDataEnCours.StationnementNumAutres_date_debut),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "StationnementNumAutres_date_debut", $$v)},expression:"demandeDataEnCours.StationnementNumAutres_date_debut"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDataEnCours.StationnementNumAutres >0),expression:"demandeDataEnCours.StationnementNumAutres >0"}],staticClass:"col-sm-6",attrs:{"id":"divDateEndStationnementNumMacarons"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"dateFinOccupationOccupationStationnementNumAutres"}},[_vm._v("\n                    Date de fin :\n                  ")]),_vm._v(" "),_c('datepicker',{attrs:{"id":"dateFinOccupationOccupationStationnementNumAutres","language":"fr","full-month-name":true,"bootstrapStyling":true,"mondayFirst":true,"disabled":_vm.dateFinDisabled_StationnementNumAutres,"highlighted":_vm.datePickerHighlighted_StationnementNumAutres},on:{"selected":_vm.dateFinUpdateStationnementNumAutres},model:{value:(_vm.demandeDataEnCours.StationnementNumAutres_date_fin),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "StationnementNumAutres_date_fin", $$v)},expression:"demandeDataEnCours.StationnementNumAutres_date_fin"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12",attrs:{"id":"divStationnementCommentaire"}},[_c('div',{},[_c('label',{staticClass:"control-label",attrs:{"for":"StationnementCommentaire"}},[_vm._v("Commentaire : ")])]),_vm._v(" "),_c('div',{},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.StationnementCommentaire),expression:"demandeDataEnCours.StationnementCommentaire"}],staticClass:"form-control",attrs:{"rows":"3","id":"StationnementCommentaire","type":"text"},domProps:{"value":(_vm.demandeDataEnCours.StationnementCommentaire)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "StationnementCommentaire", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-alert',{attrs:{"closable":false,"type":"step7ValidationType","title":_vm.step7ValidationText}}),_vm._v(" "),_c('el-button',{staticClass:"pull-right",attrs:{"id":"cmdstep7Save","type":"primary","disabled":!_vm.isStep7Valid},on:{"click":function($event){_vm.saveForm($event);_vm.demandeDataEnCours.step7IsDone=true;}}},[_vm._v("\n               SUIVANT"),_c('i',{staticClass:"el-icon-arrow-right el-icon-right"})])],1)]),_vm._v(" "),_c('go-collapse',{attrs:{"title":_vm.step8Msg,"open":_vm.demandeDataEnCours.step7IsDone && !_vm.demandeDataEnCours.step8IsDone,"disabled":!_vm.isStep6Valid && !_vm.demandeDataEnCours.step7IsDone,"done":_vm.demandeDataEnCours.step8IsDone}},[_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_c('p',[_vm._v("Le requérant demeure seul responsable envers la Commune de Lausanne du respect des\n              "),_c('a',{attrs:{"href":"http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public/domaine-public-conditions-d-usage-du-domaine-public.html","target":"_blank"}},[_vm._v("\n                conditions d'usage du domaine public\n              ")]),_vm._v("\n              ou d'un bien fonds qui lui est assimilé.\n            ")]),_vm._v(" "),_c('p',[_vm._v("\n              En cochant la case ci-dessous, il certifie les avoir lues et accepte les suites pénales\n              ou juridiques en cas d'accident.\n              Le présent formulaire, les conditions d'usage du domaine public,\n              ainsi que les tarifs en vigueur, peuvent être obtenus sur le présent site Internet:\n              "),_c('a',{attrs:{"href":"http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public.html","target":"_blank"}},[_vm._v("\n                www.lausanne.ch/domaine_public")])]),_vm._v(" "),_c('strong',[_vm._v("Acceptez-vous les\n              "),_c('a',{attrs:{"href":"http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public/domaine-public-conditions-d-usage-du-domaine-public.html","target":"_blank"}},[_vm._v("\n                conditions générales de l'utilisation temporaire du domaine public ?\n              ")])]),_vm._v(" "),_c('go-switch',{model:{value:(_vm.demandeDataEnCours.IsConditionGeneralAccepted),callback:function ($$v) {_vm.$set(_vm.demandeDataEnCours, "IsConditionGeneralAccepted", $$v)},expression:"demandeDataEnCours.IsConditionGeneralAccepted"}}),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('el-alert',{attrs:{"closable":false,"type":"step8ValidationType","title":_vm.step8ValidationText}}),_vm._v(" "),_c('el-button',{staticClass:"pull-right",attrs:{"id":"cmdsendForm","type":"primary","disabled":!_vm.isFormValid},on:{"click":function($event){_vm.submitForm($event);_vm.demandeDataEnCours.step8IsDone=true;}}},[_vm._v("\n               ENVOI DE LA DEMANDE"),_c('i',{staticClass:"el-icon-arrow-right el-icon-right"})])],1)])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isIdDemandeValid && _vm.isSubmitToLocalDatabaseSuccessfull),expression:"isIdDemandeValid && isSubmitToLocalDatabaseSuccessfull"}],attrs:{"id":"information"}},[_c('go-collapse',{attrs:{"title":_vm.stepRequestSendedMsg,"open":_vm.isSubmitToLocalDatabaseSuccessfull,"disabled":false,"done":_vm.isSubmitToLocalDatabaseSuccessfull}},[_vm._v("\n\n      Madame, Monsieur,"),_c('br'),_c('br'),_vm._v("\n      Votre demande de permis d'occupation temporaire du domaine public numéro "+_vm._s(_vm.demandeDataEnCours.id)+"\n      nous a été envoyée le "+_vm._s(_vm.demandeDataEnCours.datesubmited)+" "),_c('br'),_c('br'),_vm._v("\n      Nous vous en remercions et vous informons que son traitement est en cours."),_c('br'),_vm._v("\n      Une réponse de notre part vous parviendra, au plus tard, trois jours ouvrables avant la date d'occupation souhaitée."),_c('br'),_c('br'),_vm._v("\n\n      Vous pouvez consulter les valeurs envoyées pour votre demande "),_c('a',{attrs:{"href":_vm.getViewUrl()}},[_vm._v("ici")]),_c('br'),_c('br'),_vm._v("\n\n      Dans l'intervalle, nous vous adressons, Madame, Monsieur, nos cordiales salutations."),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('small',[_c('b',[_vm._v("Ville de Lausanne")]),_vm._v(" | service des routes et de la mobilité | surveillance du domaine public")]),_c('br'),_vm._v(" "),_c('small',[_vm._v("rue du Vallon 27 | 1005 Lausanne | T +41 21 315 5412 ou 5472 ou 5262  |\n        "),_c('a',{attrs:{"href":"http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public.html","target":"_blank"}},[_vm._v("web")])])])],1)],1)}
var goelandFormPodp_staticRenderFns = []
var goelandFormPodp_esExports = { render: goelandFormPodp_render, staticRenderFns: goelandFormPodp_staticRenderFns }
/* harmony default export */ var components_goelandFormPodp = (goelandFormPodp_esExports);
// CONCATENATED MODULE: ./src/components/goelandFormPodp.vue
function goelandFormPodp_injectStyle (ssrContext) {
  __webpack_require__("6FJY")
}
var goelandFormPodp_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var goelandFormPodp___vue_template_functional__ = false
/* styles */
var goelandFormPodp___vue_styles__ = goelandFormPodp_injectStyle
/* scopeId */
var goelandFormPodp___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var goelandFormPodp___vue_module_identifier__ = null
var goelandFormPodp_Component = goelandFormPodp_normalizeComponent(
  goelandFormPodp,
  components_goelandFormPodp,
  goelandFormPodp___vue_template_functional__,
  goelandFormPodp___vue_styles__,
  goelandFormPodp___vue_scopeId__,
  goelandFormPodp___vue_module_identifier__
)

/* harmony default export */ var src_components_goelandFormPodp = (goelandFormPodp_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/goelandViewPodp.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















var goelandViewPodp_log = config_getLog('goelandViewPODP', 4, 1);

var goelandViewPodp_pos = [538127.1, 151624.1]; // Av Acacacias Lausanne
// const pos = [538350.5, 152669.0] // cathedrale Lausanne
var goelandViewPodp_baseLayerSelected = Object(cgHtmlUtils_min["getStringParam"])('baselayer', 'fonds_geo_osm_bdcad_gris');
var goelandViewPodp_layersVisibility = Object(cgHtmlUtils_min["getStringParam"])('lvisibles', '41');
var goelandViewPodp_arrLayersVisibility = hexToArr('0x' + goelandViewPodp_layersVisibility);
goelandViewPodp_log.w('layersVisibility:' + goelandViewPodp_layersVisibility + ' => arrLayersVisibility: ' + goelandViewPodp_arrLayersVisibility);

/* harmony default export */ var goelandViewPodp = ({
  name: 'goelandViewPodp',
  components: {
    cgilOlMap: components_cgil_vue_olmap_cgil_vue_olmap,
    goSwitch: components_ui_goSwitch,
    vSelect: vue_select_default.a,
    goCollapse: components_ui_goCollapse,
    goCollapseActeurRoleDetails: components_ui_goCollapseActeurRoleDetails,
    goSelectActeur: components_geo_goSelectActeur,
    Datepicker: build_default.a
  },
  props: {
    guid: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      isItDevEnv: DEV,
      center: goelandViewPodp_pos,
      isGuidNull: null,
      data_json: null, // Ref sur le contenu de la demande distante initiale provenant de la db goeland
      // GESTION DES ETATS DE CHARGEMENTS
      isDemandeInitialeROLoaded: false, // chargement des donnees initiales distante data_json initiale est-il termine
      isIdDemandeValid: true,
      isDemandeAlreadysaved: null, // est-ce que la demande en cours contient deja des données ?
      isdemandeDataEnCoursLoaded: false, // est-ce que les données de la demande en cours sont chargées ?
      isSubmitToLocalDatabaseSuccessfull: false, // on a envoye le formulaire et il est sauve dans la BD  postgresql locale
      isGuidValid: null,
      // GESTION ERREUR SAUVEGARDE
      isSavingError: false,
      lastSavingError: '',
      goodStreetIds: [], // pour stocker ids des rues du chantier pour controle securite
      step1Msg: '1. identification',
      // une fois que l'utilisateur indique au moins une rue en relation avec cette demande
      // on considere cette etape 1 d'identification  comme terminee et on passe a la suivante
      step1IsDone: true,
      step2Msg: '1. informations générales',
      /* dans cette etape on affice les informations en lecture uniquement de la demande initiale
       on verifie dans la BD locale si un debut de demande existe si c'est le cas on rafraichi les donnee
       si ce ne'est pas le cas alors l'utilisateur doit :
               a) [IsContactPoliceDone] : confirmer qu'il a pris contact avec la police
               b) responsablePolice : indiquer le responsable police avec qui il a discuté
               c) IsConditionGeneralAccepted: confirmer qu'il accepte les Conditions generales
          une fois que ces 3 conditions sont remplies l'Etape 2 est terminee [step2IsDone=true]
          on sauve l'etat de la demande en cours demandeDataEnCours
       */

      step2arrContactPolice: ['Frédéric Vauthey', 'Martial Maillard', 'Anouk Louvet-Jardin'],
      step3Msg: '3. Interlocuteurs',
      step3arrActeurFacturationOptions: ['Bénéficiaire du permis', 'Maitre d\'ouvrage', 'Mandataire', 'Autre'],
      step4Msg: '2. localisation',
      showMap: true,
      isPolygonAlreadyPresentInGoeland: null,
      dateDebutDisabled: { to: null, from: null },
      dateFinDisabled: { to: null, from: null },
      datePickerHighlighted: { to: null, from: null },
      step5Msg: '3. fouilles',
      step6Msg: '4. occupation',
      step7Msg: '5. places de stationnement',
      // pour les controles datepicker min max
      dateDebutDisabled_StationnementNumMacarons: { to: null, from: null },
      dateFinDisabled_StationnementNumMacarons: { to: null, from: null },
      datePickerHighlighted_StationnementNumMacarons: { to: null, from: null },
      dateDebutDisabled_StationnementNumAutres: { to: null, from: null },
      dateFinDisabled_StationnementNumAutres: { to: null, from: null },
      datePickerHighlighted_StationnementNumAutres: { to: null, from: null },
      step8Msg: '8. Envoyer la demande',
      stepRequestSendedMsg: 'Votre demande a été envoyée',
      idDemande: null, // pour permetre evt saisie manuelle id affaire (securite)
      streetSelected: null, // pour stocker rue selectionne par utilisateur (securite)
      streetName: '',
      streetList: [],
      geometrieChantiersSaisiePrecedement: '',
      // ############ informations initiales recues via Goeland sur cette demande
      demandeInitialeRO: {
        id: 0, // READONLY data_json["IdAffaire"]  identifiant externe de cette demande id affaire goeland
        nomAffaire: null, // NEW data_json["NomAffaire"] titre affaire goéland
        datecreated: null, // date de creation des donnees distante demande initiale
        responsableVdL: null, //  data_json["ResponsableVdL"] le user qui saisit la demande
        itWasUnAuthorizedOccupacy: null, // data_json["BRegularisation"] s'agit itl d'une regularisation
        BPayant: null, // data_json["BPayant"] le permis est payant
        // infos provenant de coordination chantier
        IdAffCoordChantier: null, // data_json["IdAffCoordChantier"]
        nomAffCoordChantier: null, // data_json["NomAffCoordChantier"]
        UOLeaderAffCoordChantier: null, // data_json["UOLeaderAffCoordChantier"]
        geomAffCoordChantier: null, // data_json["GeomAffCoordChantier"]
        // infos concernant les acteurs liés reçus data_json["ActeurL": [{...}]
        // on doit recevoir au moins 1 entree dans ActeurL
        isBeneficiaireGiven: false,
        isMandataireGiven: false,
        Beneficiaire: {
          idActeur: null,
          Role: null,
          Nom: null,
          AdresseCorresp: null,
          Telephone: null,
          TelephonePortable: null,
          Fax: null,
          Email: null
        },
        Mandataire: {
          idActeur: null,
          Role: null,
          Nom: null,
          AdresseCorresp: null,
          Telephone: null,
          TelephonePortable: null,
          Fax: null,
          Email: null
        },
        // cas du IdAffCoordChantier et UOLeaderAffCoordChantier non null du coup c'est eux le Maitre Ouvrage
        isMaitreOuvrageGiven: false,
        MaitreOuvrage: {
          Role: null,
          Nom: null
        }
      },

      // ############ informations saisie par le client concernant cette demande qui sera renvoyée plus loin
      demandeDataEnCours: {
        // **** infos identifiant la demande initiale
        id: null, // READONLY data_json["IdAffaire"]  identifiant externe de cette demande id affaire goeland
        guid: null, // READONLY  guid demande initiale passee dans url
        realGuid: null, // READONLY dernier (temporellement) guid reel utilise pour la demande distante
        // **** infos geree par le systeme
        datecreated: null, // date premiere sauvegarde de cette demande cote client
        datelastmodif: null, // date derniere modification de cette demande cote client
        datesubmited: null, // date de bouclement (submit final) de cette demande cote client
        // **** infos concernant Etape 2 de la demande cote client
        affClientContact: null, // data_json["AffClientContact"]
        affClientEmail: null, // data_json["AffClientEmail"]
        affClientTelephone: null, // data_json["AffClientTelephone"]
        IsContactPoliceDone: false,
        responsablePolice: null, // string
        IsConditionGeneralAccepted: false,
        step2IsDone: false,
        // **** infos concernant Etape 3 de la demande cote client
        acteurBeneficiaire: {
          isActeurValid: false,
          isActeurCollapsed: false,
          isActeurPhysique: false,
          IdActeurSelected: null,
          RaisonSociale: null,
          RaisonSocialeIsValid: false,
          RueNumero: null,
          CPVille: null,
          Telephone: null,
          TelephonePortable: null,
          Fax: null,
          Email: null
        },
        acteurMaitreOuvrage: {
          isActeurValid: false,
          isActeurCollapsed: false,
          isActeurPhysique: false,
          IdActeurSelected: null,
          RaisonSociale: null,
          RaisonSocialeIsValid: false,
          RueNumero: null,
          CPVille: null,
          Telephone: null,
          TelephonePortable: null,
          Fax: null,
          Email: null
        },
        acteurMandataire: {
          isActeurValid: false,
          isActeurCollapsed: false,
          isActeurPhysique: false,
          IdActeurSelected: null,
          RaisonSociale: null,
          RaisonSocialeIsValid: false,
          RueNumero: null,
          CPVille: null,
          Telephone: null,
          TelephonePortable: null,
          Fax: null,
          Email: null
        },
        isActeurFacturationOneOfPrevious: true,
        acteurFacturationOptionSelected: 'Bénéficiaire du permis', // TODO la valeur par defaut s'affiche pas
        acteurFacturation: {
          isActeurValid: false,
          isActeurCollapsed: false,
          isActeurPhysique: false,
          IdActeurSelected: null,
          RaisonSociale: null,
          RaisonSocialeIsValid: false,
          RueNumero: null,
          CPVille: null,
          Telephone: null,
          TelephonePortable: null,
          Fax: null,
          Email: null
        },
        step3IsDone: false,
        // **** infos concernant Etape 4 de la demande cote client
        // ici on rappelle les rues et les adresses concernées
        commentaireLocalisation: null, // Commentaire sur la localisation
        descriptionTravaux: null, // [string] champ libre
        dateDebutOccupation: null, // [date] limiter date maintenant moins n mois
        dateFinOccupation: null, // [date] doit etre plus grand que debut et minumum 10 jours
        //  En cas de prolongation du chantier, veuillez nous transmettre une copie du permis délivré avec l'indication des nouvelles dates, ceci avant son échéance.
        step4IsDone: false,
        geometrieChantiersSaisie: null, // saisie de la geometrie
        // ** Utilisation du domaine public pour une fouille
        isFouilleOuForage: false, // [Boolean] les travaux se situent-ils sur la chaussée ?
        // debut ajout champs pour demande DESMET juin 2023
        fouilleLongueur01: 0, // [Number] Longueur fouille
        fouilleLargeur01: 0, // [Number] Largeur fouille
        fouilleSurface01: 0, // [Number] Surface fouille
        fouilleLongueur02: 0,
        fouilleLargeur02: 0,
        fouilleSurface02: 0,
        fouilleLongueur03: 0,
        fouilleLargeur03: 0,
        fouilleSurface03: 0,
        fouilleLongueur04: 0,
        fouilleLargeur04: 0,
        fouilleSurface04: 0,
        fouilleSurfaceTotal: 0,
        fouilleDateDebut: null,
        fouilleDateFin: null,
        // fin ajout champs pour demande DESMET juin 2023
        isFouilleSurChaussee: false, // [Boolean] les travaux se situent-ils sur la chaussée ?
        isFouilleSurTrotoir: false, // [Boolean] les travaux se situent-ils sur un trottoir ?
        isFouilleSurZonePavee: false,
        isFouilleSurZonePaveeDevisDemande: false,
        isFouilleEndomageBalisageSol: false, // [Boolean] les travaux endommageront-ils le balisage au sol ?
        step5IsDone: false,
        // ** Occupation du domaine public
        isOccupationDP: false,
        // debut ajout champs pour demande DESMET juin 2023
        occupationDPLongueur01: 0,
        occupationDPLargeur01: 0,
        occupationDPSurface01: 0,
        isOccupation_PoseDeposeModificationEnseigne: false,
        // fin ajout champs pour demande DESMET juin 2023
        isOccupation_Benne: false,
        isOccupation_DepotMateriel: false,
        isOccupation_DepotEnginsChantier: false,
        isOccupation_PalissadeOuClotureChantier: false, // palissade / clôture de chantier
        isOccupation_RoulotteOuContainer: false, //       roulotte / container de chantier
        isOccupation_CamionNacelle: false, //             camion nacelle
        isOccupation_CamionGrue: false, //         camion grue
        isOccupation_Grue: false, //               grue
        isOccupation_ChauffageMobile: false, //    chauffage mobile
        isOccupation_Echafaudage: false, //        échafaudage
        isOccupation_ElagageArbre: false, //       élagage d'arbre
        isOccupation_Etayage: false, //           étayage
        isOccupation_PontRoulant: false, //        pont roulant
        isOccupation_GroupeElectrogene: false, //        groupe électogène (ajout 2022)
        isOccupation_AccesChantier: false, //      accès chantier
        isOccupation_Autre: false, //      Autre
        Occupation_Autre: null,
        step6IsDone: false,
        isStationnementPresent: false,
        StationnementCommentaire: null,
        StationnementNumMacarons: 0,
        StationnementNumMacarons_date_debut: null,
        StationnementNumMacarons_date_fin: null,
        StationnementNumAutres: 0,
        StationnementNumAutres_date_debut: null,
        StationnementNumAutres_date_fin: null,
        step7IsDone: false,
        step8IsDone: false,
        isFinalSubmitDone: false // c'est ici que l'on va garde l'info si l'envoi definitif est fait
      },
      mapLayers: {
        baseLayer: goelandViewPodp_baseLayerSelected,
        layerForQueryInit: 'bdcad_bf_parc_pol,bdcad_bf_parc_pol_dp,bdcad_bf_parc_pol_ddp,bdcad_cs_bati_pol,bdcad_cs_bati_pol_sout,bdcad_bf_point',
        wmsLayers: [{
          layers: 'bdcad_projets_msgroup',
          title: 'Projets et chantiers',
          isVisible: goelandViewPodp_arrLayersVisibility[0]
        }, {
          layers: 'bdcad_pf_pfp_msgroup,bdcad_pf_pfp_alti',
          title: 'PFP',
          isVisible: goelandViewPodp_arrLayersVisibility[1]
        }, {
          layers: 'bdcad_pfp_reperage_msgroup',
          title: 'PFP repérage',
          isVisible: goelandViewPodp_arrLayersVisibility[2]
        }, {
          layers: 'bdcad_pf_pfa_msgroup,bdcad_pf_pfa_alti',
          title: 'PFA',
          isVisible: goelandViewPodp_arrLayersVisibility[3]
        }, { // je choisis la version du GC public pour que cela fonctionne partout
          layers: 'envconst_arbres_public_remarquables,envconst_arbres_public_remplacement,envconst_arbres_public_projet,envconst_arbres_public_abattage,envconst_arbres_public_autres',
          title: 'Arbres',
          isVisible: goelandViewPodp_arrLayersVisibility[4]
        }, {
          layers: 'envconst_toitures_veg',
          title: 'Toitures Végétalisées',
          isVisible: goelandViewPodp_arrLayersVisibility[5]
        },
        /* // pas disponible sur map :
        {
          layers: 'bdcad_bf_parcom_pol',
          title: 'Parcelles Communales',
          isVisible: arrLayersVisibility[6],
        },
           */
        {
          layers: 'perimetres_lim_com_msgroup',
          title: 'Limites Communales',
          isVisible: goelandViewPodp_arrLayersVisibility[6]
        }, {
          layers: 'altimetrie_hauteur_vegetation_mnc_class',
          title: 'Canopée végétation',
          isVisible: goelandViewPodp_arrLayersVisibility[7]
        }] // FIN DE LA CONFIG DES mapLayers
      } };
  }, // end of data section
  computed: {
    isStep2Valid: function isStep2Valid() {
      if (!this.isSubmitToLocalDatabaseSuccessfull) {
        if (this.isIdDemandeValid && this.demandeDataEnCours.IsContactPoliceDone && this.demandeDataEnCours.IsConditionGeneralAccepted) {
          this.demandeDataEnCours.step2IsDone = true;
          return true;
        } else {
          this.demandeDataEnCours.step2IsDone = false;
          return false;
        }
      }
    },
    isStep3Valid: function isStep3Valid() {
      if (!this.isSubmitToLocalDatabaseSuccessfull) {
        /* TODO ici il faut toujours acteurBeneficiaire complet
          et idéalement au moins un des deux suivants acteurMaitreOuvrage ou acteurMandataire
        */
        if (this.demandeDataEnCours.acteurBeneficiaire.isActeurValid && this.demandeDataEnCours.acteurMaitreOuvrage.isActeurValid) {
          this.demandeDataEnCours.step3IsDone = true;
          return true;
        } else {
          this.demandeDataEnCours.step3IsDone = false;
          return false;
        }
      }
    },
    isStep4Valid: function isStep4Valid() {
      if (!this.isSubmitToLocalDatabaseSuccessfull) {
        if (this.demandeDataEnCours.dateDebutOccupation !== null && this.demandeDataEnCours.dateFinOccupation !== null && this.demandeDataEnCours.descriptionTravaux !== null) {
          this.demandeDataEnCours.step4IsDone = true;
          this.saveForm();
          return true;
        } else {
          this.demandeDataEnCours.step4IsDone = false;
          return false;
        }
      }
    },
    // Fouilles sur DP
    isStep5Valid: function isStep5Valid() {
      return true; // en attendant d'avoir des infos de validation plus precise ...
    },
    // Occupation du DP
    isStep6Valid: function isStep6Valid() {
      return true; // en attendant d'avoir des infos de validation plus precise ...
    },
    // Utilisation de Places de Stationnement
    isStep7Valid: function isStep7Valid() {
      return true; // en attendant d'avoir des infos de validation plus precise ...
    },
    isFormValid: function isFormValid() {
      if (this.isStep2Valid && this.isStep3Valid && this.isStep4Valid && this.isStep5Valid && this.isStep6Valid && this.isStep7Valid) {
        return true;
      } else {
        return false;
      }
    }

  }, // end of computed props section

  watch: {
    '$route': function $route(to, from) {
      var _this = this;

      goelandViewPodp_log.w('## IN viewPoDP.watch($route) ', to, from);
      if (to.params.guid !== from.params.guid) {
        goelandViewPodp_log.w('#### NAVIGATE FROM : ' + from.params.guid);
        goelandViewPodp_log.w('#### NAVIGATE TO   : ' + to.params.guid);
        // TODO provide a global reinit of all forms vars to default
        this.isGuidNull = false;
        this.isDemandeInitialeROLoaded = false;
        this.step1IsDone = false;
        this.isIdDemandeValid = false;
        this.isGuidValid = false;
        this.streetSelected = null;
        if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(to.params.guid)) {
          demandePoDP.getDemandeInitiale(to.params.guid, function (dataref) {
            goelandViewPodp_log.l('## IN viewPoDP.watch($route) callback for reloading of :' + to.params.guid);
            _this.cacheInitialData(dataref);
          });
        } else {
          goelandViewPodp_log.w('## IN viewPoDP.watch($route) to.params.guid is undefined !');
        }
      } else {
        goelandViewPodp_log.w('## IN viewPoDP.watch($route) : NO NAVIGATION BECAUSE guid is the same');
        goelandViewPodp_log.w('#### NAVIGATE FROM : ' + from.params.guid);
        goelandViewPodp_log.w('#### NAVIGATE TO   : ' + to.params.guid);
      }
    }
  },
  created: function created() {
    var _this2 = this;

    goelandViewPodp_log.l('## INSIDE  goelandFormPodp created ');
    if (this.guid !== null) {
      this.isGuidNull = false;
      demandePoDP.getDemandeInitiale(this.guid, function (dataref) {
        goelandViewPodp_log.l('## INSIDE viewPoDP.getDemandeInitiale callback for created');
        _this2.cacheInitialData(dataref);
      });
    } else {
      goelandViewPodp_log.w('## INSIDE  goelandFormPodp created : guid is null');
      this.isGuidNull = true;
    }
  }, // end of created hook section

  mounted: function mounted() {
    var _this3 = this;

    axios_default.a.get(BASE_REST_API_URL + '/streets').then(function (resp) {
      // console.dir(resp)
      _this3.streetList = resp.data;
    }).catch(function (err) {
      goelandViewPodp_log.e('## ERROR IN Form mounted axios.get ', err);
    });
    goelandViewPodp_log.l('## IN  goelandFormPodp mounted ');
    if (this.guid !== null) {
      if (demandePoDP.isDemandeCached(this.guid)) {
        this.cacheInitialData(demandePoDP.getDemandeInitiale(this.guid));
      }
    }
  }, // end of mounted hook section

  filters: {
    convertReturn2Comma: function convertReturn2Comma(value) {
      if (!value) return '';
      value = value.toString();
      return value.replace('\n', ', ');
    },
    capitalize: function capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    dateformat: function dateformat(value) {
      if (!value) return '';
      var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      var madate = new Date(value);
      return madate.toLocaleDateString('fr-CH', options);
    },
    dateTimeformat: function dateTimeformat(value) {
      if (!value) return '';
      var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      var madate = new Date(value);
      return madate.toLocaleDateString('fr-CH', options) + ' à ' + madate.toLocaleTimeString('fr-CH');
    }
  },
  methods: {
    cacheInitialData: function cacheInitialData(dataref) {
      var _this4 = this;

      goelandViewPodp_log.l('## IN  goelandViewPodp.cacheInitialData ');
      if ((typeof dataref === 'undefined' ? 'undefined' : typeof_default()(dataref)) === 'object') {
        try {
          this.data_json = JSON.parse(dataref['json_data']);
          this.demandeDataEnCours.guid = this.guid;
          this.demandeDataEnCours.realGuid = dataref['guid'];
          this.demandeInitialeRO.datecreated = dataref['datecreated'];
          this.idDemande = this.data_json['IdAffaire'];
          // lets's check if data was already saved
          demandePoDP.isDemandeAlreadysaved(this.idDemande, function (data) {
            goelandViewPodp_log.l('## INSIDE demandePoDP.isDemandeAlreadysaved callback for done');
            _this4.isDemandeAlreadysaved = data; // will be true or false
            _this4.getSubmitedData();
          });
          this.demandeInitialeRO.id = this.data_json['IdAffaire'];
          this.demandeInitialeRO.nomAffaire = this.data_json['NomAffaire'];
          this.demandeInitialeRO.responsableVdL = this.data_json['ResponsableVdL'];
          this.demandeInitialeRO.itWasUnAuthorizedOccupacy = this.data_json['BRegularisation'] !== '0';
          this.demandeInitialeRO.BPayant = this.data_json['BPayant'] !== '0';
          // info du client a priori beneficiaire or acteur
          this.demandeDataEnCours.affClientContact = this.data_json['AffClientContact'];
          this.demandeDataEnCours.affClientEmail = this.data_json['AffClientEmail'];
          this.demandeDataEnCours.affClientTelephone = this.data_json['AffClientTelephone'];
          // l'IDAFF "VDL-coordination chantier"
          this.demandeInitialeRO.IdAffCoordChantier = this.data_json['IdAffCoordChantier'];
          this.demandeInitialeRO.nomAffCoordChantier = this.data_json['NomAffCoordChantier'];
          this.demandeInitialeRO.UOLeaderAffCoordChantier = this.data_json['UOLeaderAffCoordChantier'];
          if (this.demandeInitialeRO.IdAffCoordChantier) {
            // si on a un IdAffCoordChantier c'est que chantier vient de la Ville pas besoin de saisir MaitreOuvrage
            this.demandeInitialeRO.MaitreOuvrage.Role = 'Maitre d\'Ouvrage';
            this.demandeInitialeRO.MaitreOuvrage.Nom = this.demandeInitialeRO.UOLeaderAffCoordChantier;
            this.demandeInitialeRO.isMaitreOuvrageGiven = true;
            this.demandeDataEnCours.acteurMaitreOuvrage.isActeurValid = true;
          }
          var arrRue = this.data_json['RueL'];
          if (Object(cgHtmlUtils_min["isNullOrUndefined"])(arrRue)) {
            goelandViewPodp_log.e('La liste des RueL est absente de la demande initiale');
            this.isDemandeInitialeROLoaded = false;
            this.isGuidValid = false;
          }
          for (var i = 0; i < arrRue.length; i++) {
            this.goodStreetIds.push(arrRue[i]['IdRueL']);
          }
          // traitement acteur liés "ActeurL": [{...}]
          // on doit recevoir au moins 1 entree dans ActeurL roles possibles sont beneficiaire et mandataire
          var arrActeurLie = this.data_json['ActeurL'];
          if (arrActeurLie.length > 1) {
            this.demandeInitialeRO.isBeneficiaireGiven = true;
            this.demandeInitialeRO.isMandataireGiven = true;
            this.demandeDataEnCours.acteurMandataire.isActeurValid = true;
            this.demandeDataEnCours.acteurBeneficiaire.isActeurValid = true;
            // si on a deux entrees on part du principe que c'est mandataire qui a fait demande
            // et on recherche lequel des deux entrees il s'agit
            if (arrActeurLie[0]['Role'] === 'Mandataire') {
              this.demandeInitialeRO.Mandataire = arrActeurLie[0];
              this.demandeInitialeRO.Beneficiaire = arrActeurLie[1];
            } else {
              this.demandeInitialeRO.Beneficiaire = arrActeurLie[0];
              this.demandeInitialeRO.Mandataire = arrActeurLie[1];
            }
          } else {
            // on a qu'un seul acteur lié
            if (arrActeurLie[0]['Role'] === 'Bénéficiaire') {
              this.demandeInitialeRO.isBeneficiaireGiven = true;
              this.demandeDataEnCours.acteurBeneficiaire.isActeurValid = true;
              this.demandeInitialeRO.Beneficiaire = arrActeurLie[0];
            } else {
              this.demandeInitialeRO.isMandataireGiven = true;
              this.demandeDataEnCours.acteurMandataire.isActeurValid = true;
              this.demandeInitialeRO.Mandataire = arrActeurLie[0];
            }
          }
          if (Object(cgHtmlUtils_min["isNullOrUndefined"])(this.demandeDataEnCours.geometrieChantiersSaisie)) {
            // on active la barre edition par defaut car pas de geometrie a priori
            this.isPolygonAlreadyPresentInGoeland = false;
            if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(this.data_json['GeomAffCoordChantier']['features'])) {
              var arrFeatures = this.data_json['GeomAffCoordChantier']['features'];
              if (arrFeatures.length > 0) {
                goelandViewPodp_log.l('## IN  goelandFormPodp.cacheInitialData found ' + arrFeatures.length + ' features', arrFeatures);
                // on desactive la barre edition par defaut si la geometrie est fournie par coordination chantier
                this.demandeInitialeRO.geomAffCoordChantier = arrFeatures[0].geometry;
                this.isPolygonAlreadyPresentInGoeland = true;
                // this.demandeDataEnCours.geometrieChantiersSaisie = arrFeatures[0].geometry
              }
            }
          }
          this.demandeDataEnCours.id = this.idDemande;
          this.demandeDataEnCours.IdAffCoordChantier = this.demandeInitialeRO.IdAffCoordChantier;
          this.demandeDataEnCours.datecreated = null;
          // state management
          this.isDemandeInitialeROLoaded = true;
          this.isGuidValid = true;
          this.getSubmitedData();
        } catch (e) {
          goelandViewPodp_log.e('###  ERROR IN  goelandFormPodp.cacheInitialData while parsing json', demandePoDP.lastError);
          this.demandeDataEnCours.realGuid = '## ERREUR ## pendant la lecture de la demande initiale en JSON: ';
          this.demandeDataEnCours.realGuid += stringify_default()(dataref);
          this.isDemandeInitialeROLoaded = false;
          this.isGuidValid = false;
        }
      } else {
        goelandViewPodp_log.e('###  ERROR IN  goelandFormPodp.cacheInitialData [' + dataref + ']');
        goelandViewPodp_log.e('###  ERROR IN  goelandFormPodp.cacheInitialData : demandePoDP.lastError =', demandePoDP.lastError);
        if (stringify_default()(demandePoDP.lastError).indexOf('no records found') > 0) {
          this.demandeDataEnCours.realGuid = '## ERREUR ##  Aucune demande en cours avec pour cet identifiant !';
        } else {
          this.demandeDataEnCours.realGuid = '## ERREUR ##  [' + stringify_default()(demandePoDP.lastErrorMsg) + '] !';
        }
        goelandViewPodp_log.w(stringify_default()(demandePoDP.lastError));
        goelandViewPodp_log.e(demandePoDP.lastError);
        this.isDemandeInitialeROLoaded = false;
        this.isGuidValid = false;
      }
    },
    // end of cacheInitialData
    submitForm: function submitForm(event) {
      var _this5 = this;

      if (this.isdemandeDataEnCoursLoaded || !this.isDemandeAlreadysaved) {
        goelandViewPodp_log.l('### IN  goelandFormPodp.submitForm ');
        if (this.isGuidValid) {
          this.demandeDataEnCours.isFinalSubmitDone = true;
          var savedData = {
            id: this.idDemande,
            demandeDataEnCours: this.demandeDataEnCours
          };
          if (event) {
            if (Object(cgHtmlUtils_min["functionExist"])(event.preventDefault)) event.preventDefault();
          }
          demandePoDP.submitDemande(this.demandeDataEnCours.realGuid, savedData, function (resp) {
            goelandViewPodp_log.l('### IN  goelandFormPodp.submitForm AFTER submitDemande : ', resp);
            if (stringify_default()(resp).indexOf('ERROR') > 0) {
              goelandViewPodp_log.e('### ERROR IN  goelandFormPodp.submitForm AFTER submitDemande : ', resp);
              goelandViewPodp_log.w('demandePoDP.lastError = ', demandePoDP.lastError);
              _this5.lastSavingError = '## ERREUR PENDANT L\'ENVOI DU FORMULAIRE ! ## ' + demandePoDP.lastErrorMsg + ' [' + resp + '] !';
              _this5.isSavingError = true;
            } else {
              _this5.lastSavingError = '';
              _this5.isSavingError = false;
              _this5.isSubmitToLocalDatabaseSuccessfull = true;
              // pour indiquer correctement la date dans la confirmation vu que l'on a pas le retour de la bd mais que c'est sauve
              var todayDate = new Date();
              _this5.demandeDataEnCours.datesubmited = todayDate.toLocaleString('fr');
            }
          });
        } else {
          this.lastSavingError = '## IMPOSSIBLE D\'ENVOYER CE FORMULAIRE ce guid est invalide : ' + this.demandeDataEnCours.realGuid + '] !';
          this.isSavingError = true;
        }
      } else {
        goelandViewPodp_log.w('### IN  goelandFormPodp.submitForm NOT SAVING car isdemandeDataEnCoursLoaded est FAUX');
      }
    },
    getSubmitedData: function getSubmitedData() {
      var _this6 = this;

      goelandViewPodp_log.l('## in goelandViewPodp.getSubmitedData isDemandeAlreadysaved = ', this.isDemandeAlreadysaved);
      this.step1IsDone = true;
      this.isIdDemandeValid = true;
      var that = this;
      // a timer seems to be the only way to get it working
      window.setTimeout(function () {
        that.$refs.mapchantier.updateScreen();
      }, 1500);
      if (this.isDemandeAlreadysaved) {
        // let's get back the current data
        demandePoDP.getdemandeEnCours(this.idDemande, function (dataref) {
          goelandViewPodp_log.l('##****** IN demandePoDP.getdemandeEnCours callback', dataref);
          if (typeof dataref === 'string') {
            goelandViewPodp_log.w('## ERROR IN demandePoDP.getdemandeEnCours callback', dataref);
            _this6.isdemandeDataEnCoursLoaded = false;
          } else {
            goelandViewPodp_log.l('## IN demandePoDP.getdemandeEnCours before JSON.parse');
            _this6.demandeDataEnCours = JSON.parse(dataref['json_data']);
            _this6.demandeDataEnCours.datecreated = dataref['datecreated'];
            _this6.demandeDataEnCours.datelastmodif = dataref['datelastmodif'];
            _this6.demandeDataEnCours.datesubmited = dataref['datesubmited'];
            goelandViewPodp_log.l('## IN demandePoDP.getdemandeEnCours before geometrieChantiersSaisiePrecedement');
            _this6.geometrieChantiersSaisiePrecedement = _this6.demandeDataEnCours.geometrieChantiersSaisie;
            if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(_this6.demandeDataEnCours.datesubmited)) {
              _this6.isSubmitToLocalDatabaseSuccessfull = true;
            } else {
              // this.$refs.mapchantier.updateScreen()
            }
            _this6.isdemandeDataEnCoursLoaded = true;
            goelandViewPodp_log.l('## IN demandePoDP.getdemandeEnCours before JSON.stringify');
            // const tmpJsonData = JSON.stringify(getObjecSortedtbyKey(this.demandeDataEnCours), null, 2)
            var tmpJsonData = stringify_default()(_this6.demandeDataEnCours, null, 2);
            goelandViewPodp_log.l('## IN demandePoDP.getdemandeEnCours before setting jsonDemandeDataEnCours.innerHTML');
            // this.$refs.jsonDemandeDataEnCours.innerHTML = tmpJsonData
            goelandViewPodp_log.l('##****** IN demandePoDP.getdemandeEnCours finished loading demandeDataEnCours', tmpJsonData);
          }
        });
      }
      // this.streetSelected = val.value
    },
    checkIsValidStreetId: function checkIsValidStreetId(idStreet) {
      if (this.goodStreetIds.indexOf(idStreet) > -1 && this.demandeInitialeRO.id === this.idDemande) {
        goelandViewPodp_log.l('##++ in goelandFormPodp.checkIsValidStreetId VALID idStreet:', idStreet);
        return true;
      } else {
        goelandViewPodp_log.l('##-- in goelandFormPodp.checkIsValidStreetId INVALID idStreet:', idStreet);
        return false;
      }
    },

    saveGeometry: function saveGeometry(val) {
      goelandViewPodp_log.l('##++ in goelandFormPodp.saveGeometry cgil-vue-olmap event gomapSaveGeomClick received : ', val);
      this.demandeDataEnCours.geometrieChantiersSaisie = val;
    },
    adjustMap: function adjustMap(val) {
      goelandViewPodp_log.l('##++ in goelandFormPodp.adjustMap goCollapse event gocollapseOpen received : ', val);
      // 2018-05-03 cgil commented out next line because it breaks map display component when collapse is false and reveals underlying content
      // this.$refs.mapchantier.updateScreen()
      this.showMap = true;
    } // end of methods section
  } });
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93155de2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/goelandViewPodp.vue
var goelandViewPodp_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isItDevEnv)?_c('div',{},[_c('go-collapse',{attrs:{"title":"1. Infos Debug pour développement (sur serveur dev uniquement)","open":false,"done":true}},[_vm._v("\n      isGuidNull = "+_vm._s(_vm.isGuidNull)),_c('br'),_vm._v("\n      guid = "+_vm._s(_vm.guid)),_c('br'),_vm._v("\n      isDemandeInitialeROLoaded = "+_vm._s(_vm.isDemandeInitialeROLoaded)),_c('br'),_vm._v("\n      isDemandeAlreadysaved = "+_vm._s(_vm.isDemandeAlreadysaved)),_c('br'),_vm._v("\n      isIdDemandeValid = "+_vm._s(_vm.isIdDemandeValid)),_c('br'),_vm._v("\n      isGuidValid = "+_vm._s(_vm.isGuidValid)),_c('br'),_vm._v("\n      isSubmitToLocalDatabaseSuccessfull = "+_vm._s(_vm.isSubmitToLocalDatabaseSuccessfull)),_c('br'),_vm._v(" "),(_vm.isDemandeInitialeROLoaded)?_c('p',[_vm._v("guid effectif : ["+_vm._s(_vm.demandeDataEnCours.realGuid)+"] créé le : "+_vm._s(_vm.demandeInitialeRO.datecreated))]):_vm._e(),_vm._v(" "),_c('pre',{ref:"jsonDemandeDataEnCours"})])],1):_vm._e(),_vm._v(" "),(!_vm.isDemandeInitialeROLoaded && !_vm.isGuidNull)?_c('p',[_vm._v("Veuillez patienter, récupération de la demande numéro : "+_vm._s(_vm.guid))]):_vm._e(),_vm._v(" "),(!_vm.isGuidValid && !_vm.isGuidNull)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('p',[_vm._v(_vm._s(_vm.demandeDataEnCours.realGuid))])]):_vm._e(),_vm._v(" "),(_vm.isSavingError)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('p',[_vm._v(_vm._s(_vm.lastSavingError))])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isIdDemandeValid && _vm.isSubmitToLocalDatabaseSuccessfull),expression:"isIdDemandeValid && isSubmitToLocalDatabaseSuccessfull"}],attrs:{"id":"questions"}},[_c('go-collapse',{attrs:{"title":_vm.step2Msg,"open":true,"done":_vm.demandeDataEnCours.step2IsDone}},[_c('div',{staticClass:"form-group col-md-6"},[_c('h4',[_vm._v(_vm._s(_vm.demandeInitialeRO.id)+"/"+_vm._s(_vm.streetName))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.demandeInitialeRO.nomAffaire)))]),_vm._v(" "),_c('p',[_vm._v("\n              Le surveillant de la Ville en charge de l'affaire est :\n              "),_c('strong',[_vm._v("M."+_vm._s(_vm.demandeInitialeRO.responsableVdL))])]),_vm._v(" "),(_vm.demandeInitialeRO.itWasUnAuthorizedOccupacy)?_c('h5',[_c('strong',[_vm._v("il s'agit d'une demande effectuée suite à une occupation non autorisée")])]):_vm._e(),_vm._v(" "),(_vm.demandeInitialeRO.BPayant)?_c('h5',[_vm._v("Ce permis sera "),_c('strong',[_vm._v("payant")])]):_c('h5',[_vm._v("Ce permis sera gratuit")]),_vm._v(" "),(_vm.isDemandeInitialeROLoaded)?_c('div',[_c('go-collapse-acteur-role-details',{attrs:{"acteurReference":_vm.demandeInitialeRO.Mandataire}}),_vm._v(" "),_c('go-collapse-acteur-role-details',{attrs:{"acteurReference":_vm.demandeInitialeRO.Beneficiaire}}),_vm._v(" "),_c('go-collapse-acteur-role-details',{attrs:{"acteurReference":_vm.demandeInitialeRO.MaitreOuvrage}},[_vm._v("\n                Affaire Coordination : "+_vm._s(_vm.demandeInitialeRO.IdAffCoordChantier)+" / "+_vm._s(_vm.demandeInitialeRO.nomAffCoordChantier)+"\n              ")]),_vm._v(" "),_c('hr')],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('fieldset',[_c('legend',[_vm._v("Vos informations de contact ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nom :")]),_vm._v(_vm._s(_vm.demandeDataEnCours.affClientContact)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Votre email :")]),_vm._v(_vm._s(_vm.demandeDataEnCours.affClientEmail)+"\n                "),_c('span',{staticClass:"help-block",attrs:{"id":"helpBlockaffClientEmail"}},[_vm._v("Le permis sera envoyé à cette adresse mail !")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tel :")]),_vm._v(_vm._s(_vm.demandeDataEnCours.affClientTelephone)+"\n              ")])])])]),_vm._v(" "),_c('go-collapse',{attrs:{"title":_vm.step4Msg,"open":true,"disabled":false,"done":_vm.demandeDataEnCours.step4IsDone},on:{"gocollapseOpen":_vm.adjustMap}},[_c('form',{attrs:{"id":"goform-step4","action":"#"}},[_c('div',{staticClass:"form-group col-md-12"},[_c('h4',[_vm._v("plan du perimetre du chantier")]),_vm._v(" "),(_vm.isPolygonAlreadyPresentInGoeland)?_c('p',[_vm._v("ce perimetre du chantier provient de la coordination de chantier VdL (il existe déjà goéland) on peut juste le visualiser.")]):_vm._e(),_vm._v(" "),(!_vm.isPolygonAlreadyPresentInGoeland)?_c('p',[_vm._v("Vous avez créé le(s) polygone(S) de l'emprise de votre demande sur le DP")]):_vm._e(),_vm._v(" "),(_vm.showMap)?_c('div',[_c('cgil-ol-map',{ref:"mapchantier",staticStyle:{"height":"800px","width":"100%"},attrs:{"edit-geom-enabled":false,"layers-config":_vm.mapLayers,"geomGeoJSON":_vm.demandeInitialeRO.geomAffCoordChantier,"geomWkt":_vm.geometrieChantiersSaisiePrecedement},on:{"gomapSaveGeomClick":_vm.saveGeometry}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('div',{},[_c('label',{staticClass:"control-label",attrs:{"for":"commentaireLocalisation"}},[_vm._v("Commentaire : "+_vm._s(_vm.demandeDataEnCours.commentaireLocalisation))])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('div',{},[_c('label',{staticClass:"control-label",attrs:{"for":"descriptionTravaux"}},[_vm._v("Description des travaux: "+_vm._s(_vm.demandeDataEnCours.descriptionTravaux))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",attrs:{"id":"divDatBegin"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                Date de Début : "+_vm._s(_vm._f("dateformat")(_vm.demandeDataEnCours.dateDebutOccupation))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",attrs:{"id":"divDateEnd"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                Date de Fin : "+_vm._s(_vm._f("dateformat")(_vm.demandeDataEnCours.dateFinOccupation))+"\n              ")])])])])]),_vm._v(" "),_c('go-collapse',{attrs:{"title":_vm.step5Msg,"open":true,"disabled":false,"done":_vm.demandeDataEnCours.step5IsDone}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.demandeDataEnCours.isFouilleOuForage)?_c('label',[_vm._v("Vous allez effectuer des fouilles et/ou des forages sur le DP ")]):_vm._e(),_vm._v(" "),(!_vm.demandeDataEnCours.isFouilleOuForage)?_c('label',[_vm._v("Vous n'allez pas effectuer des fouilles et/ou des forages sur le DP ")]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.demandeDataEnCours.isFouilleOuForage)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('fieldset',{staticClass:"fouille-fieldset"},[_c('legend',{staticClass:"fouille-legend"},[_vm._v("Fouille numéro 1 :")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLongueur01),expression:"demandeDataEnCours.fouilleLongueur01"}],attrs:{"type":"number","min":"0","id":"fouilleLongueur01","placeholder":"Longueur en m","readonly":"","disabled":""},domProps:{"value":(_vm.demandeDataEnCours.fouilleLongueur01)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLongueur01", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLargeur01),expression:"demandeDataEnCours.fouilleLargeur01"}],attrs:{"type":"number","min":"0","id":"fouilleLargeur01","placeholder":"Largeur en m","readonly":"","disabled":""},domProps:{"value":(_vm.demandeDataEnCours.fouilleLargeur01)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLargeur01", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_vm._v("Surface = "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.demandeDataEnCours.fouilleSurface01)+"  m²")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('fieldset',{staticClass:"fouille-fieldset"},[_c('legend',{staticClass:"fouille-legend"},[_vm._v("Fouille numéro 2 :")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLongueur02),expression:"demandeDataEnCours.fouilleLongueur02"}],attrs:{"type":"number","min":"0","id":"fouilleLongueur02","placeholder":"Longueur en m","readonly":"","disabled":""},domProps:{"value":(_vm.demandeDataEnCours.fouilleLongueur02)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLongueur02", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLargeur02),expression:"demandeDataEnCours.fouilleLargeur02"}],attrs:{"type":"number","min":"0","id":"fouilleLargeur02","placeholder":"Largeur en m","readonly":"","disabled":""},domProps:{"value":(_vm.demandeDataEnCours.fouilleLargeur02)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLargeur02", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_vm._v("Surface = "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.demandeDataEnCours.fouilleSurface02)+"  m²")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('fieldset',{staticClass:"fouille-fieldset"},[_c('legend',{staticClass:"fouille-legend"},[_vm._v("Fouille numéro 3 :")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLongueur03),expression:"demandeDataEnCours.fouilleLongueur03"}],attrs:{"type":"number","min":"0","id":"fouilleLongueur03","placeholder":"Longueur en m","readonly":"","disabled":""},domProps:{"value":(_vm.demandeDataEnCours.fouilleLongueur03)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLongueur03", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLargeur03),expression:"demandeDataEnCours.fouilleLargeur03"}],attrs:{"type":"number","min":"0","id":"fouilleLargeur03","placeholder":"Largeur en m","readonly":"","disabled":""},domProps:{"value":(_vm.demandeDataEnCours.fouilleLargeur03)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLargeur03", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_vm._v("Surface = "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.demandeDataEnCours.fouilleSurface03)+"  m²")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('fieldset',{staticClass:"fouille-fieldset"},[_c('legend',{staticClass:"fouille-legend"},[_vm._v("Fouille numéro 4 :")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLongueur04),expression:"demandeDataEnCours.fouilleLongueur04"}],attrs:{"type":"number","min":"0","id":"fouilleLongueur04","placeholder":"Longueur en m","readonly":"","disabled":""},domProps:{"value":(_vm.demandeDataEnCours.fouilleLongueur04)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLongueur04", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.fouilleLargeur04),expression:"demandeDataEnCours.fouilleLargeur04"}],attrs:{"type":"number","min":"0","id":"fouilleLargeur04","placeholder":"Largeur en m","readonly":"","disabled":""},domProps:{"value":(_vm.demandeDataEnCours.fouilleLargeur04)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "fouilleLargeur04", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_vm._v("Surface = "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.demandeDataEnCours.fouilleSurface04)+"  m²")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h4',{staticClass:"pull-right"},[_vm._v("Surface Totale =  "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.demandeDataEnCours.fouilleSurfaceTotal)+"  m²")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"col-sm-6",attrs:{"id":"divDatBegin"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                  Date de Début : "+_vm._s(_vm._f("dateformat")(_vm.demandeDataEnCours.fouilleDateDebut))+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",attrs:{"id":"divDateEnd"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                  Date de Fin : "+_vm._s(_vm._f("dateformat")(_vm.demandeDataEnCours.fouilleDateFin))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.demandeDataEnCours.isFouilleSurChaussee)?_c('label',[_vm._v("Les travaux se situent sur la chaussée.")]):_vm._e(),_vm._v(" "),(!_vm.demandeDataEnCours.isFouilleSurChaussee)?_c('label',[_vm._v("Les travaux ne se situent pas sur la chaussée.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.demandeDataEnCours.isFouilleSurTrotoir)?_c('label',[_vm._v("Les travaux se situent sur un trottoir.")]):_vm._e(),_vm._v(" "),(!_vm.demandeDataEnCours.isFouilleSurTrotoir)?_c('label',[_vm._v("Les travaux ne se situent pas sur un trottoir.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.demandeDataEnCours.isFouilleEndomageBalisageSol)?_c('label',[_vm._v("Les travaux endommageront le balisage au sol.")]):_vm._e(),_vm._v(" "),(!_vm.demandeDataEnCours.isFouilleEndomageBalisageSol)?_c('label',[_vm._v("Les travaux n'endommageront pas le balisage au sol.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.demandeDataEnCours.isFouilleSurZonePavee)?_c('label',[_vm._v("Les travaux se situent sur une zone pavée.")]):_vm._e(),_vm._v(" "),(!_vm.demandeDataEnCours.isFouilleSurZonePavee)?_c('label',[_vm._v("Les travaux ne se situent pas sur une zone pavée.")]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('go-collapse',{attrs:{"title":_vm.step6Msg,"open":true,"disabled":false,"done":_vm.demandeDataEnCours.step6IsDone}},[(_vm.demandeDataEnCours.isOccupationDP)?_c('label',[_vm._v("Vous allez occuper le DP avec :")]):_vm._e(),_vm._v(" "),(!_vm.demandeDataEnCours.isOccupationDP)?_c('label',[_vm._v("Vous n'allez pas occuper le DP.")]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"col-sm-12"},[_c('fieldset',{staticClass:"fouille-fieldset"},[_c('legend',{staticClass:"fouille-legend"},[_vm._v("Taille occupation :")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.occupationDPLongueur01),expression:"demandeDataEnCours.occupationDPLongueur01"}],attrs:{"type":"number","min":"0","id":"occupationDPLongueur01","placeholder":"Longueur en m","readonly":"","disabled":""},domProps:{"value":(_vm.demandeDataEnCours.occupationDPLongueur01)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "occupationDPLongueur01", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.occupationDPLargeur01),expression:"demandeDataEnCours.occupationDPLargeur01"}],attrs:{"type":"number","min":"0","id":"occupationDPLargeur01","placeholder":"Largeur en m","readonly":"","disabled":""},domProps:{"value":(_vm.demandeDataEnCours.occupationDPLargeur01)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "occupationDPLargeur01", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_vm._v("Surface = "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.demandeDataEnCours.occupationDPSurface01)+"  m²")])])])])])]),_vm._v(" "),(_vm.demandeDataEnCours.isOccupationDP)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group"},[(_vm.demandeDataEnCours.isOccupation_Benne)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Benne")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_DepotMateriel)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Dépôt de matériel")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_DepotEnginsChantier)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Dépôt d'engins de chantier")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_PalissadeOuClotureChantier)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Palissade / Clôture de chantier")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_RoulotteOuContainer)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Roulotte / Container de chantier")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_CamionNacelle)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Camion nacelle")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_CamionGrue)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Camion grue")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_Grue)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Grue")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_ChauffageMobile)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Chauffage mobile")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_Echafaudage)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Echafaudage")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_ElagageArbre)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Elagage d'arbre")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_Etayage)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Etayage")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_PontRoulant)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Pont roulant")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_AccesChantier)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Accès chantier")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_GroupeElectrogene)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v("Groupe électrogène")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.isOccupation_PoseDeposeModificationEnseigne)?_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"checkbox goOccupationCheckbox"},[_c('label',[_vm._v(" Pose / dépose / modification d’enseigne ou de support d’affichage")])])]):_vm._e(),_vm._v(" "),(_vm.demandeDataEnCours.Occupation_Autre != null)?_c('div',{staticClass:"col-sm-4"},[_c('label',{attrs:{"for":"Occupation_Autre"}},[_vm._v("Autre : "+_vm._s(_vm.demandeDataEnCours.Occupation_Autre))])]):_vm._e()])]):_vm._e()]),_vm._v(" "),_c('go-collapse',{attrs:{"title":_vm.step7Msg,"open":true,"disabled":false,"done":_vm.demandeDataEnCours.step7IsDone}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.demandeDataEnCours.isStationnementPresent)?_c('label',[_vm._v("Vos travaux occuperonts des places de stationnement publiques.")]):_vm._e(),_vm._v(" "),(!_vm.demandeDataEnCours.isStationnementPresent)?_c('label',[_vm._v("Vos travaux n'occuperonts pas des places de stationnement publiques.")]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.demandeDataEnCours.isStationnementPresent)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[(_vm.demandeDataEnCours.StationnementNumMacarons > 0)?_c('label',{staticClass:"control-label"},[_vm._v("\n                "+_vm._s(_vm.demandeDataEnCours.StationnementNumMacarons)+" place(s) ouvertes aux macarons.\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDataEnCours.StationnementNumMacarons > 0),expression:"demandeDataEnCours.StationnementNumMacarons > 0"}],staticClass:"col-sm-6",attrs:{"id":"divDateBeginStationnementNumMacarons"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                  Date de Début : "+_vm._s(_vm._f("dateformat")(_vm.demandeDataEnCours.StationnementNumMacarons_date_debut))+"\n                ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDataEnCours.StationnementNumMacarons > 0),expression:"demandeDataEnCours.StationnementNumMacarons > 0"}],staticClass:"col-sm-6",attrs:{"id":"divDateEndStationnementNumMacarons"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                  Date de Fin : "+_vm._s(_vm._f("dateformat")(_vm.demandeDataEnCours.StationnementNumMacarons_date_fin))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[(_vm.demandeDataEnCours.StationnementNumAutres >0)?_c('label',{staticClass:"control-label"},[_vm._v("\n                "+_vm._s(_vm.demandeDataEnCours.StationnementNumAutres)+" autres place(s).")]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDataEnCours.StationnementNumAutres >0),expression:"demandeDataEnCours.StationnementNumAutres >0"}],staticClass:"col-sm-6",attrs:{"id":"divDateBeginStationnementNumMacarons"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                  Date de Début : "+_vm._s(_vm._f("dateformat")(_vm.demandeDataEnCours.StationnementNumAutres_date_debut))+"\n                ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDataEnCours.StationnementNumAutres >0),expression:"demandeDataEnCours.StationnementNumAutres >0"}],staticClass:"col-sm-6",attrs:{"id":"divDateEndStationnementNumMacarons"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("\n                  Date de Fin : "+_vm._s(_vm._f("dateformat")(_vm.demandeDataEnCours.StationnementNumAutres_date_fin))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12",attrs:{"id":"divStationnementCommentaire"}},[_c('div',{},[_c('label',{staticClass:"control-label",attrs:{"for":"StationnementCommentaire"}},[_vm._v("Commentaire : ")])]),_vm._v(" "),_c('div',{},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.demandeDataEnCours.StationnementCommentaire),expression:"demandeDataEnCours.StationnementCommentaire"}],staticClass:"form-control",attrs:{"rows":"3","id":"StationnementCommentaire","type":"text"},domProps:{"value":(_vm.demandeDataEnCours.StationnementCommentaire)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.demandeDataEnCours, "StationnementCommentaire", $event.target.value)}}})])])]):_vm._e()])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isIdDemandeValid && _vm.isSubmitToLocalDatabaseSuccessfull),expression:"isIdDemandeValid && isSubmitToLocalDatabaseSuccessfull"}],attrs:{"id":"information"}},[_c('go-collapse',{attrs:{"title":_vm.stepRequestSendedMsg,"open":_vm.isSubmitToLocalDatabaseSuccessfull,"disabled":false,"done":_vm.isSubmitToLocalDatabaseSuccessfull}},[_vm._v("\n\n      Madame, Monsieur,"),_c('br'),_c('br'),_vm._v("\n      Votre demande de permis d'occupation temporaire du domaine public numéro "+_vm._s(_vm.demandeDataEnCours.id)+"\n      nous a été envoyée le "+_vm._s(_vm.demandeDataEnCours.datesubmited)+" "),_c('br'),_c('br'),_vm._v("\n      Nous vous en remercions et vous informons que son traitement est en cours."),_c('br'),_vm._v("\n      Une réponse de notre part vous parviendra, au plus tard, trois jours ouvrables avant la date d'occupation souhaitée."),_c('br'),_c('br'),_vm._v("\n\n      Dans l'intervalle, nous vous adressons, Madame, Monsieur, nos cordiales salutations."),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('small',[_c('b',[_vm._v("Ville de Lausanne")]),_vm._v(" | service des routes et de la mobilité | surveillance du domaine public")]),_c('br'),_vm._v(" "),_c('small',[_vm._v("rue du Vallon 27 | 1005 Lausanne | T +41 21 315 5412 ou 5472 ou 5262  | "),_c('a',{attrs:{"href":"http://www.lausanne.ch/lausanne-officielle/administration/finances-et-mobilite/routes-mobilite/domaine-public-utilisation-temporaire-du-domaine-public.html"}},[_vm._v("web")])])])],1)])}
var goelandViewPodp_staticRenderFns = []
var goelandViewPodp_esExports = { render: goelandViewPodp_render, staticRenderFns: goelandViewPodp_staticRenderFns }
/* harmony default export */ var components_goelandViewPodp = (goelandViewPodp_esExports);
// CONCATENATED MODULE: ./src/components/goelandViewPodp.vue
function goelandViewPodp_injectStyle (ssrContext) {
  __webpack_require__("aGWz")
}
var goelandViewPodp_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var goelandViewPodp___vue_template_functional__ = false
/* styles */
var goelandViewPodp___vue_styles__ = goelandViewPodp_injectStyle
/* scopeId */
var goelandViewPodp___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var goelandViewPodp___vue_module_identifier__ = null
var goelandViewPodp_Component = goelandViewPodp_normalizeComponent(
  goelandViewPodp,
  components_goelandViewPodp,
  goelandViewPodp___vue_template_functional__,
  goelandViewPodp___vue_styles__,
  goelandViewPodp___vue_scopeId__,
  goelandViewPodp___vue_module_identifier__
)

/* harmony default export */ var src_components_goelandViewPodp = (goelandViewPodp_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/goSelectPodpDemande.vue
//
//
//
//
//
//
//
//
//
//
//
//
//





var goSelectPodpDemande_log = config_getLog('goelandSelectPODPDemande', 4, 1);

/* harmony default export */ var goSelectPodpDemande = ({
  name: 'goSelectPodpDemande',
  components: {
    vSelect: vue_select_default.a
  },
  props: {
    value: {
      type: Object
    }
  },
  data: function data() {
    return {
      dataSelected: null,
      dataName: '',
      test: null,
      dataList: []
    };
  }, // end of data section
  computed: {}, // end of computed props section
  watch: {
    value: function value(val) {
      this.dataSelected = val;
    }
  }, // end of watch props section
  created: function created() {
    goSelectPodpDemande_log.l('## IN goSelectPodpDemande created ');
  },
  mounted: function mounted() {
    var _this = this;

    goSelectPodpDemande_log.l('## IN goSelectPodpDemande mounted ', this.dataList.length);
    if (this.dataList.length < 1) {
      setTimeout(function () {
        goSelectPodpDemande_log.l('## IN goSelectPodpDemande mounted SetTimeout');
        // TODO tester quand il n'y a pas de demandes
        demandePoDP.getListDemandes(function (data) {
          goSelectPodpDemande_log.l('## INSIDE  goSelectPodpDemande mounted callback for getListDemandes', data);
          _this.dataList = data;
        });
      }, 1000);
    }
    this.dataSelected = this.value;
  }, // end of computed props section

  methods: {
    changeSelected: function changeSelected(val) {
      this.$emit('input', val);
      this.$emit('newguid', val);
      goSelectPodpDemande_log.l('## INSIDE  goSelectPodpDemande changeSelected ', val.value);
    }
  } // end of methods section
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-641bcb5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/goSelectPodpDemande.vue
var goSelectPodpDemande_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"id":"listDemande","tabindex":"-1","options":_vm.dataList,"placeholder":"Veuillez choisir une demande ...","label":"label","value":_vm.dataSelected,"onChange":_vm.changeSelected}})],1)}
var goSelectPodpDemande_staticRenderFns = []
var goSelectPodpDemande_esExports = { render: goSelectPodpDemande_render, staticRenderFns: goSelectPodpDemande_staticRenderFns }
/* harmony default export */ var components_goSelectPodpDemande = (goSelectPodpDemande_esExports);
// CONCATENATED MODULE: ./src/components/goSelectPodpDemande.vue
function goSelectPodpDemande_injectStyle (ssrContext) {
  __webpack_require__("CT3h")
}
var goSelectPodpDemande_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var goSelectPodpDemande___vue_template_functional__ = false
/* styles */
var goSelectPodpDemande___vue_styles__ = goSelectPodpDemande_injectStyle
/* scopeId */
var goSelectPodpDemande___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var goSelectPodpDemande___vue_module_identifier__ = null
var goSelectPodpDemande_Component = goSelectPodpDemande_normalizeComponent(
  goSelectPodpDemande,
  components_goSelectPodpDemande,
  goSelectPodpDemande___vue_template_functional__,
  goSelectPodpDemande___vue_styles__,
  goSelectPodpDemande___vue_scopeId__,
  goSelectPodpDemande___vue_module_identifier__
)

/* harmony default export */ var src_components_goSelectPodpDemande = (goSelectPodpDemande_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DemandeSansGuid.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var DemandeSansGuid_log = config_getLog('demandeSansGuid', 4, 1);

/* harmony default export */ var DemandeSansGuid = ({
  name: 'DemandeSansGuid',
  components: {
    goCollapse: components_ui_goCollapse,
    goSelectPodpDemande: src_components_goSelectPodpDemande
  },
  data: function data() {
    return {
      msg1: '1) Sécurité des chantiers :',
      msg2: '2) Surveillance du domaine public :',
      msg3: ' POUR LES TESTS Uniquement...',
      isItDevEnv: DEV,
      isMainOpen: true,
      popdDemande: null
    };
  },
  methods: {
    guidChanged: function guidChanged(val) {
      DemandeSansGuid_log.l('# IN  App guidChanged', val);
      if (!Object(cgHtmlUtils_min["isNullOrUndefined"])(val.value)) {
        DemandeSansGuid_log.l('# IN  DemandeSansGuid guidChanged about to navigate to ', val.value);
        /*
        this.$router
        window.location = `/#/demande/${val.value}?timestamp=${(new Date()).getTime()}`
        */
        this.$router.push({
          name: 'goelandFormPodp',
          params: { guid: val.value }
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65ebf638","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DemandeSansGuid.vue
var DemandeSansGuid_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('go-collapse',{attrs:{"title":_vm.msg1,"open":_vm.isMainOpen}},[_c('p',[_vm._v("\n        Le requérant doit contacter le-la surveillant-e du domaine public, en charge du secteur sur lequel il souhaite obtenir un permis temporaire d'occupation du domaine public.\n        Lors de ce contact, il devra être en possession des informations suivantes :\n      ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("coordonnées complète (y compris adresse e-mail)")]),_vm._v(" "),_c('li',[_vm._v("numéro IDAFF (xxx'xxx), si les travaux sont mandatés par un gestionnaire de réseaux communal")]),_vm._v(" "),_c('li',[_vm._v("localisation des travaux")])]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":__webpack_require__("wEbZ")}}),_vm._v(" "),_c('a',{staticClass:"niceLink",attrs:{"href":"https://www.lausanne.ch/.binaryData/website/path/lausanne/prestations/mobilite-et-amenagements-publics/demande-permis-utilisation-temporaire-domaine-public/contentAutogenerated/autogeneratedContainer/col1/06/linkList/0/websitedownload/plan-des-secteurs-occupation-dp.2022-06-30-10-20-21.pdf"}},[_vm._v("Plan des secteurs et numéros de téléphone")])]),_vm._v(" "),_c('p',[_vm._v("\n        Après ce contact obligatoire, le requérant recevra, par e-mail, un identifiant de demande unique. Ce code est indispensable pour effectuer la demande d'occupation temporaire du domaine public.\n        "),_c('br'),_c('br'),_vm._v("\n        Vous trouverez de plus amples informations, comme par exemple les délais de demande,\n        les tarifs ou encore les conditions d'usage du domaine public, sur le\n        "),_c('a',{attrs:{"href":"https://www.lausanne.ch/prestations/mobilite-et-amenagements-publics/demande-permis-utilisation-temporaire-domaine-public.html"}},[_vm._v("\n          site web de la Ville de Lausanne\n        ")])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n        Si vous avez des questions, n'hésitez pas à nous contacter."),_c('br'),_c('br'),_vm._v("\n        Nous répondons à vos appels du lundi au vendredi, de 08h00 à 11h30 et de 14h00 à 16h00."),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Service de la mobilité et de l’aménagement des espaces publics")]),_c('br'),_vm._v("\n        Surveillance du domaine public"),_c('br'),_c('br'),_vm._v("\n        Téléphones  "),_c('a',{attrs:{"href":"tel:+41213155412"}},[_vm._v("+41 21 315  5412")]),_vm._v(" ou  "),_c('a',{attrs:{"href":"tel:+41213155262"}},[_vm._v("5262")]),_c('br'),_vm._v("\n        E-mail "),_c('a',{attrs:{"href":"mailto:podp@lausanne.ch"}},[_vm._v("podp@lausanne.ch")]),_c('br')])])],1)}
var DemandeSansGuid_staticRenderFns = []
var DemandeSansGuid_esExports = { render: DemandeSansGuid_render, staticRenderFns: DemandeSansGuid_staticRenderFns }
/* harmony default export */ var components_DemandeSansGuid = (DemandeSansGuid_esExports);
// CONCATENATED MODULE: ./src/components/DemandeSansGuid.vue
function DemandeSansGuid_injectStyle (ssrContext) {
  __webpack_require__("DkYG")
}
var DemandeSansGuid_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var DemandeSansGuid___vue_template_functional__ = false
/* styles */
var DemandeSansGuid___vue_styles__ = DemandeSansGuid_injectStyle
/* scopeId */
var DemandeSansGuid___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DemandeSansGuid___vue_module_identifier__ = null
var DemandeSansGuid_Component = DemandeSansGuid_normalizeComponent(
  DemandeSansGuid,
  components_DemandeSansGuid,
  DemandeSansGuid___vue_template_functional__,
  DemandeSansGuid___vue_styles__,
  DemandeSansGuid___vue_scopeId__,
  DemandeSansGuid___vue_module_identifier__
)

/* harmony default export */ var src_components_DemandeSansGuid = (DemandeSansGuid_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Test.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  import goCollapse from './ui/goCollapse'
  import goSelectCountry from './geo/goSelectCountry.vue'
  import goSelectCanton from './geo/goSelectCanton.vue'
  import goSelectCommune from './geo/goSelectCommune.vue'
  import goSelectActeur from './geo/goSelectActeur.vue'
  import goSelectPodpDemande from './goSelectPodpDemande.vue'
  import Datepicker from 'vuejs-datepicker'
 */






var Test_log = config_getLog('goelandTest', 4, 1);
var Test_baseLayerSelected = Object(cgHtmlUtils_min["getStringParam"])('baselayer', 'fonds_geo_osm_bdcad_gris');
var Test_layersVisibility = Object(cgHtmlUtils_min["getStringParam"])('lvisibles', '41');
var Test_arrLayersVisibility = hexToArr('0x' + Test_layersVisibility);
Test_log.w('layersVisibility:' + Test_layersVisibility + ' => arrLayersVisibility: ' + Test_arrLayersVisibility);

var defaultCountry = { 'value': 197, 'label': 'Suisse' };
var defaultCanton = { 'value': 22, 'label': 'Vaud' };
var defaultCommuneVD = { 'value': 5586, 'label': 'Lausanne' };
var Test_pos = [538350.5, 152669.0]; // cathedrale Lausanne

/* harmony default export */ var Test = ({
  name: 'home',
  components: {
    /*
    goCollapse,
    goSelectCountry,
    goSelectCanton,
    goSelectCommune,
    goSelectActeur,
    goSelectPodpDemande,
    Datepicker,
     */
    cgilOlMap: components_cgil_vue_olmap_cgil_vue_olmap
  },
  data: function data() {
    return {
      center: Test_pos,
      initialGeom: 'MULTIPOLYGON(((2538319.52 1152664.64,2538318.72 1152659.83,2538343.55 1152656.63,2538344.15 1152661.63,2538319.52 1152664.64)),((2538352.76 1152659.83,2538351.16 1152645.21,2538361.57 1152644.41,2538362.78 1152651.02,2538372.19 1152650.02,2538374.19 1152657.03,2538352.76 1152659.83)))',
      savedGeom: null,
      isTestCountryOpen: false,
      country: defaultCountry,
      isTestCantonOpen: false,
      canton: defaultCanton,
      isTestCommuneOpen: false,
      commune: defaultCommuneVD,
      isTestActeurOpen: false,
      acteur: null,
      isTestPopdOpen: true,
      popdDemande: null,
      datebegin: null,
      ajax_country: {
        callback: function callback(response) {
          return response.map(function (i) {
            return i.name;
          });
        },
        url: 'https://restcountries.eu/rest/v1/lang/fr'
      },
      mapLayers: {
        baseLayer: Test_baseLayerSelected,
        layerForQueryInit: 'bdcad_bf_parc_pol,bdcad_bf_parc_pol_dp,bdcad_bf_parc_pol_ddp,bdcad_cs_bati_pol,bdcad_cs_bati_pol_sout,bdcad_bf_point',
        wmsLayers: [{
          layers: 'bdcad_projets_msgroup',
          title: 'Projets et chantiers',
          isVisible: Test_arrLayersVisibility[0]
        }, {
          layers: 'bdcad_pf_pfp_msgroup,bdcad_pf_pfp_alti',
          title: 'PFP',
          isVisible: Test_arrLayersVisibility[1]
        }, {
          layers: 'bdcad_pfp_reperage_msgroup',
          title: 'PFP repérage',
          isVisible: Test_arrLayersVisibility[2]
        }, {
          layers: 'bdcad_pf_pfa_msgroup,bdcad_pf_pfa_alti',
          title: 'PFA',
          isVisible: Test_arrLayersVisibility[3]
        }, { // je choisis la version du GC public pour que cela fonctionne partout
          layers: 'envconst_arbres_public_remarquables,envconst_arbres_public_remplacement,envconst_arbres_public_projet,envconst_arbres_public_abattage,envconst_arbres_public_autres',
          title: 'Arbres',
          isVisible: Test_arrLayersVisibility[4]
        }, {
          layers: 'envconst_toitures_veg',
          title: 'Toitures Végétalisées',
          isVisible: Test_arrLayersVisibility[5]
        },
        /* // pas disponible sur map :
        {
          layers: 'bdcad_bf_parcom_pol',
          title: 'Parcelles Communales',
          isVisible: arrLayersVisibility[6],
        },
           */
        {
          layers: 'perimetres_lim_com_msgroup',
          title: 'Limites Communales',
          isVisible: Test_arrLayersVisibility[6]
        }, {
          layers: 'altimetrie_hauteur_vegetation_mnc_class',
          title: 'Canopée végétation',
          isVisible: Test_arrLayersVisibility[7]
        }] // FIN DE LA CONFIG DES mapLayers
      } };
  },
  computed: {
    getTestCommuneMSg: function getTestCommuneMSg() {
      if (this.canton !== null) {
        return 'Test composant goSelectCommune (Suisse) ' + this.canton.label;
      } else {
        return 'Test composant goSelectCommune (Suisse) ';
      }
    }
  },
  methods: {
    saveActeur: function saveActeur(val) {
      Test_log.l('## IN Test.vue.saveActeur\n received :', val);
    },
    saveGeometry: function saveGeometry(val) {
      console.info('In demoApp cgil-vue-olmap event gomapSaveGeomClick received : ', val);
      this.savedGeom = val;
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283ae4a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Test.vue
var Test_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cgil-ol-map',{staticStyle:{"height":"800px","width":"100%"},attrs:{"edit-geom-enabled":true,"center":_vm.center,"zoom":8,"layers-config":_vm.mapLayers,"geomWkt":_vm.initialGeom},on:{"gomapSaveGeomClick":_vm.saveGeometry}}),_vm._v(" "),_c('el-input',{attrs:{"title":"initial geometry","type":"textarea","rows":4,"placeholder":"Initial geometry"},model:{value:(_vm.initialGeom),callback:function ($$v) {_vm.initialGeom=$$v},expression:"initialGeom"}}),_vm._v(" "),_c('el-input',{attrs:{"title":"saved geometry","type":"textarea","rows":4,"placeholder":"saved geometry"},model:{value:(_vm.savedGeom),callback:function ($$v) {_vm.savedGeom=$$v},expression:"savedGeom"}})],1)}
var Test_staticRenderFns = []
var Test_esExports = { render: Test_render, staticRenderFns: Test_staticRenderFns }
/* harmony default export */ var components_Test = (Test_esExports);
// CONCATENATED MODULE: ./src/components/Test.vue
var Test_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Test___vue_template_functional__ = false
/* styles */
var Test___vue_styles__ = null
/* scopeId */
var Test___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Test___vue_module_identifier__ = null
var Test_Component = Test_normalizeComponent(
  Test,
  components_Test,
  Test___vue_template_functional__,
  Test___vue_styles__,
  Test___vue_scopeId__,
  Test___vue_module_identifier__
)

/* harmony default export */ var src_components_Test = (Test_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js








vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_Home
  }, {
    path: '/demande',
    name: 'DemandeSansGuid',
    component: src_components_DemandeSansGuid
  }, {
    path: '/demande/:guid',
    name: 'goelandFormPodp',
    component: src_components_goelandFormPodp,
    props: true
  }, {
    path: '/view/:guid',
    name: 'goelandViewPodp',
    component: src_components_goelandViewPodp,
    props: true
  }, {
    path: '/test',
    name: 'Test',
    component: src_components_Test
  }]
}));
// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/display.css
var display = __webpack_require__("sfy8");
var display_default = /*#__PURE__*/__webpack_require__.n(display);

// EXTERNAL MODULE: ./node_modules/bootstrap-sass/assets/stylesheets/_bootstrap.scss
var _bootstrap = __webpack_require__("C9st");
var _bootstrap_default = /*#__PURE__*/__webpack_require__.n(_bootstrap);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("tvR6");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// CONCATENATED MODULE: ./src/main.js








// import './element-variables.scss'

vue_esm["default"].use(element_ui_common_default.a);
// import GSignInButton from 'vue-google-signin-button'

/*
// https://github.com/MMF-FE/vue-svgicon
import * as svgicon from 'vue-svgicon'
Vue.use(svgicon, {
  tagName: 'svgicon'
})

import N3Components from 'N3-components'
import 'N3-components/dist/index.min.css'
// install N3
Vue.use(N3Components, 'en')

import KeenUI from 'keen-ui'
Vue.use(KeenUI)
*/
// Vue.use(GSignInButton)
vue_esm["default"].config.productionTip = false;
vue_esm["default"].config.debug = Object({"NODE_ENV":"production"}).DEBUG_MODE;

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: router,
  render: function render(h) {
    return h(src_App);
  }
});

/***/ }),

/***/ "UIWc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aGWz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h1YY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sfy8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "snlp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uuFV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wEbZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/plan.9934f93.png";

/***/ }),

/***/ "xFzx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xxwd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f064f6bbeb380eb5fb7d.js